/**
 * Combined v2 configurator.
 *
 * Liquid-derived values are emitted by product-combined-v2 and the catalog-mode
 * product-secret-v2 section, then passed to init().
 */
(function () {
  if (window.theme && window.theme.combinedV2) return;

  window.theme = window.theme || {};

  var CONFIG_SELECTOR = '[data-combined-v2-config]';
  var instances = {};

  function normalizeListingContext(value) {
    var normalized = String(value || '').trim().toLowerCase();
    var allowed = [
      'single-listing',
      'bundle-listing',
      'free-nano-listing',
      'secret-menu-listing',
      'secret-menu-bundle-listing'
    ];
    return allowed.indexOf(normalized) !== -1 ? normalized : '';
  }

  function normalizeTwoSideListingContext(value) {
    var normalized = String(value || '').trim().toLowerCase();
    var allowed = [
      'single-listing',
      'secret-menu-listing',
      'single-or-secret-menu-listing'
    ];
    return allowed.indexOf(normalized) !== -1 ? normalized : 'single-or-secret-menu-listing';
  }

  function createInstance(cfg) {
    var root = document.getElementById('bundle-builder-' + cfg.sectionId);
    if (!root) return null;

    var catalogMode = cfg.catalogMode === 'secret_v2';
    var sizeOrder = catalogMode ? String(cfg.sizeOrder || '').split(/[\r\n,]+/).map(toLookupKey).filter(function (key, index, keys) {
      return key && keys.indexOf(key) === index;
    }) : [];
    var stepOrder = ['1', '2', '3', '4', '5'];
    var addToCartButton = root.querySelector('[data-add-to-cart]');
    var addToCartLabel = root.querySelector('[data-add-to-cart-label]');
    var addToCartMessage = root.querySelector('[data-add-to-cart-message]');
    var addToCartError = root.querySelector('[data-add-to-cart-error]');
    var addToCartSpinner = root.querySelector('[data-add-to-cart-spinner]');
    var giftConfig = cfg.freeGift && cfg.freeGift.enabled ? cfg.freeGift : null;
    var giftSelect = giftConfig ? root.querySelector('[data-gift-variant]') : null;
    var giftValidationEl = giftConfig ? root.querySelector('[data-gift-validation]') : null;
    if (giftConfig) stepOrder.push('6');
    var creatorCartUncertain = false;
    var ultemPriceEl = root.querySelector('[data-ultem-price]');
    var ultemAddLabelEl = root.querySelector('[data-ultem-add-label]');
    var ultemSwapPriceEl = root.querySelector('[data-ultem-swap-price]');
    var ultemSwapLabelEl = root.querySelector('[data-ultem-swap-label]');
    var ultemNoteEl = root.querySelector('[data-ultem-note]');
    var ultemPreviewEl = root.querySelector('[data-ultem-image] img');
    var colorBodyPreviewEl = root.querySelector('[data-color-body-preview]');
    var lidModeFieldsEl = root.querySelector('[data-lid-mode-fields]');
    var lidPreviewRowEl = root.querySelector('[data-lid-preview-row]');
    var lidFieldsEl = root.querySelector('[data-lid-fields]');
    var lidBodyPreviewEl = root.querySelector('[data-lid-body-preview]');
    var lidHelpTextEl = root.querySelector('[data-lid-help-text]');
    var sizeValidationEl = root.querySelector('[data-size-validation]');
    var colorValidationEl = root.querySelector('[data-color-validation]');
    var lidValidationEl = root.querySelector('[data-lid-validation]');
    var pocketFieldsEl = root.querySelector('[data-pocket-fields]');
    var pocketBodyPreviewEl = root.querySelector('[data-pocket-body-preview]');
    var pocketHelpTextEl = root.querySelector('[data-pocket-help-text]');
    var pocketValidationEl = root.querySelector('[data-pocket-validation]');
    var priceEl = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var stockEl = root.querySelector('[data-stock-pill]');
    var stockLabelEl = root.querySelector('[data-stock-label]');
    var notifyModalEl = root.querySelector('[data-notify-modal]');
    var notifyFormEl = root.querySelector('[data-notify-form]');
    var notifyEmailInput = root.querySelector('[data-notify-email]');
    var notifyDesignInput = root.querySelector('[data-notify-design]');
    var notifyContextEl = root.querySelector('[data-notify-context]');
    var notifySizeSelect = root.querySelector('[data-notify-size]');
    var notifyFirstColorSelect = root.querySelector('[data-notify-first-color-select]');
    var notifySecondColorSelect = root.querySelector('[data-notify-second-color-select]');
    var notifySecondColorField = root.querySelector('[data-notify-second-color-field]');
    var notifyFirstColorLabelEl = root.querySelector('[data-notify-first-color-label]');
    var notifySecondColorLabelEl = root.querySelector('[data-notify-second-color-label]');
    var notifyMessageEl = root.querySelector('[data-notify-message]');
    var notifySubmitBtn = root.querySelector('[data-notify-submit]');
    var notifyProductInput = root.querySelector('[data-notify-product]');
    var notifyVariantLabelInput = root.querySelector('[data-notify-variant-label]');
    var notifyCaseSizeInput = root.querySelector('[data-notify-case-size]');
    var notifyFirstColorInput = root.querySelector('[data-notify-first-color]');
    var notifySecondColorInput = root.querySelector('[data-notify-second-color]');
    var notifyDateInput = root.querySelector('[data-notify-date]');
    var galleryStage = root.querySelector('[data-gallery-stage]');
    var galleryPrevButton = root.querySelector('[data-gallery-prev]');
    var galleryNextButton = root.querySelector('[data-gallery-next]');
    var mainSlide = root.querySelector('[data-gallery-slide][data-slide-index="0"]');
    var mainThumb = root.querySelector('[data-gallery-thumb][data-slide-target="0"]');
    // PDP-001 gallery v2: pinned preview, # / N counter, fading arrows, resume, video slides.
    var galleryV2 = root.hasAttribute('data-gallery-v2');
    var galleryCounterCurrent = root.querySelector('[data-gallery-counter-current]');
    var galleryCounterTotal = root.querySelector('[data-gallery-counter-total]');
    var galleryThumbsRest = root.querySelector('[data-gallery-thumbs-rest]');
    var galleryUiTimer = null;
    var galleryUiHover = false;
    var galleryResumeIndex = 0;
    var galleryReady = false;
    var galleryLastUserAt = 0;
    var galleryResizeObserver = null;
    var galleryIdleHandle = null;
    var galleryIdleTimer = null;
    var galleryDisposed = false;
    var galleryVideoCleanups = [];
    var GALLERY_UI_STEP_MS = 1000;
    var galleryReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var mainImg = root.querySelector('[data-primary-media]');
    var thumbImg = root.querySelector('[data-primary-thumb-image]');
    var mainPreviewFrame = root.querySelector('[data-primary-preview-frame]');
    var thumbPreviewFrame = root.querySelector('[data-primary-thumb-preview-frame]');
    var sizeListEl = root.querySelector('[data-size-list]');
    var sizeCapacityBar = null;
    var colorListEl = root.querySelector('[data-color-list]');
    var caseSpecsEl = root.querySelector('[data-case-specs]');
    var caseSpecPanels = caseSpecsEl ? caseSpecsEl.querySelectorAll('[data-case-spec-panel]') : [];
    var defaultSizeKey = root.getAttribute('data-default-size-key') || '';
    var productHandle = root.getAttribute('data-current-handle');
    var catalogHostHandle = productHandle;
    var productTitle = cfg.productTitle;
    var fetchTier = root.getAttribute('data-current-tier') || 'Single Pack';
    var configurationError = String(cfg.configurationError || '').trim();
    var twoSideParentTitleTemplate = root.getAttribute('data-two-side-parent-title-template') || 'Weekly AM-PM {size} 2.0';
    var twoSideCart = window.theme && window.theme.twoSideCart;
    var colorMode = 'listing';
    var listingContext = normalizeListingContext(cfg.listingContext);
    var twoSideListingContext = catalogMode
      ? normalizeTwoSideListingContext(cfg.twoSideListingContext)
      : listingContext;
    var moneyFormat = cfg.moneyFormat;
    var cartCurrency = cfg.cartCurrency;
    var lidTitle = cfg.lidTitle;
    var lidPlaceholderAm = cfg.lidPlaceholderAm;
    var lidPlaceholderPm = cfg.lidPlaceholderPm;
    var lidHelpCopy = cfg.lidHelpCopy;
    var pocketHelpCopy = cfg.pocketHelpCopy;
    var galleryBgSrc = cfg.galleryBgSrc;
    var galleryBgThumbSrc = cfg.galleryBgThumbSrc;
    var pocketBodyPreviewSrc = cfg.pocketBodyPreviewSrc;
    var ultemEnabledBySetting = cfg.ultemEnabledBySetting;
    var ultemPreviewImages = cfg.ultemPreviewImages || {};
    var ultemSwapConfig = cfg.ultemSwap || {};
    var ultemSwapEnabledBySetting = !!ultemSwapConfig.enabled;
    var ultemCaseHandle = String(ultemSwapConfig.handle || '').trim();
    var ultemCaseUrl = String(ultemSwapConfig.url || '').trim();
    var BUNDLE_MARKER_PREFIX = 'com2';
    var TWO_SIDE_BUNDLE_MARKER_PREFIX = 'com3';
    var FOCUS_RING = 'tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-gray-950 tw:focus-visible:ring-offset-1';
    var FOCUS_RING_BLACK = 'tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-black tw:focus-visible:ring-offset-1';
    var FOCUS_RING_INSET = 'tw:focus:outline-none tw:focus-visible:bg-gray-50 tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-gray-950';
    var DOTW_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var NANO_POCKET_OPTIONS = ['AM', 'PM', 'LUNCH', 'EXTRA', 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    var MISSION_POCKET_OPTIONS = ['AM-LUNCH-PM', 'FRI-SAT-SUN', 'AM-PM-EXTRA'];
    var POCKET_BODY_PREVIEW_WIDTHS = { nano: '52px', mission: '56px', weekly: '42px', ampm: '86px', two_week: '86px'};
    var LID_HELP_COPY = {
      short: 'You have the option to engrave text on the lid. Up to 3 characters.\nThis step allows you add & customize the engraving.',
      long: 'You have the option to engrave text on the lid. Up to 12 characters.\nThis step allows you add & customize the engraving.'
    };
    var POCKET_HELP_COPY = {
      dotw: 'You have the option to add days of the week engravings in the pockets.\nThis step allows you to add them by selecting the start day for the case (the first pocket) and the rest of the days will follow sequentially.',
      nano: 'You have the option to engrave a single pocket label.\nSelect the label you want and the preview will show the corresponding pocket engraving.',
      mission: 'You have the option to engrave the Mission Case with one of three preset pocket label sets.\nSelect a preset and the preview will show all three pocket engravings.'
    };
    var LID_ALLOWED_PATTERN = /^[\w\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/;
    var LID_ALLOWED_DESCRIPTION = 'Use letters, numbers, spaces, and basic punctuation.';
    var NOTIFY_ENDPOINT = 'https://script.google.com/macros/s/AKfycbxmSIHmqUAYAX_3xFOZRzjvnzAZGrmCOmyvQkvcxZwvTH8uvIQJ83NCNFgIieZ-7-jP8Q/exec';
    var lidProduct = readInlineJson('lid-product-json-' + cfg.sectionId);
    var pocketProduct = readInlineJson('pocket-product-json-' + cfg.sectionId);
    var ultemProduct = readInlineJson('ultem-product-json-' + cfg.sectionId);
    var twoSideCarrierProduct = readInlineJson('two-side-carrier-product-json-' + cfg.sectionId);
    var twoSideAmProduct = readInlineJson('two-side-am-product-json-' + cfg.sectionId);
    var twoSidePmProduct = readInlineJson('two-side-pm-product-json-' + cfg.sectionId);
    var secretAmpmCarrierProduct = readInlineJson('secret-v2-ampm-carrier-product-json-' + cfg.sectionId);
    var secretTwoWeekCarrierProduct = readInlineJson('secret-v2-two-week-carrier-product-json-' + cfg.sectionId);
    var pocketImagesByColor = readInlineJson('case-color-pocket-images-json-' + cfg.sectionId) || {};
    var caseImagesByColor = readInlineJson('case-images-json-' + cfg.sectionId) || {};
    var lidVariant = null;
    var pocketVariant = null;
    var ultemVariant = null;
    var sizePayload = null;
    var sizeCatalog = [];
    var sizeFetchPromise = null;
    var sizeFetchLoading = false;
    var sizeFetchError = configurationError;
    var colorPayload = null;
    var colorCatalog = [];
    var colorFetchPromise = null;
    var colorFetchLoading = false;
    var colorFetchError = '';
    var colorFetchSize = null;
    var firstColorPayload = null;
    var firstColorCatalog = [];
    var firstColorFetchPromise = null;
    var firstColorFetchLoading = false;
    var firstColorFetchError = '';
    var firstColorFetchSize = null;
    var firstColorPrefetchPayload = null;
    var firstColorPrefetchPromise = null;
    var firstColorPrefetchSize = null;
    var secondColorPayload = null;
    var secondColorCatalog = [];
    var secondColorFetchPromise = null;
    var secondColorFetchLoading = false;
    var secondColorFetchError = '';
    var secondColorFetchSize = null;
    var secondColorFetchFirstColor = null;
    var secondColorPrefetchPayload = null;
    var secondColorPrefetchPromise = null;
    var secondColorPrefetchSize = null;
    var secondColorPrefetchFirstColor = null;
    var notifyColorFetchToken = 0;
    var notifySecondColorFetchToken = 0;
    var notifySessionToken = 0;
    var notifyReturnFocusEl = null;
    var notifyRequestedColorsOnly = false;
    var notifySubmitting = false;
    var notifyFirstLoading = false;
    var notifySecondLoading = false;
    var notifySingleColors = [];
    var notifyFirstColors = [];
    var notifySecondColors = [];
    var notifyLookupSize = '';
    var notifySecondFirstColor = '';
    var colorPrefetchPayload = null;
    var colorPrefetchPromise = null;
    var colorPrefetchSize = null;
    var colorCandidateForSizeChange = null;
    var secondColorCandidateForSizeChange = null;
    var ignoreUrlColorPreselectOnce = false;
    var urlPreselectApplying = false;
    var urlPreselectApplied = false;
    var activeGalleryIndex = 0;
    var gallerySwipeState = null;
    var currentTooltip = null;
    var currentTooltipTrigger = null;
    var detailsCurrentPage = null;
    var detailsRequestedPage = null;
    var detailsFetchToken = 0;
    var openSizePopover = null;
    var sizePopoverListenersBound = false;
    var sizePopoverSeq = 0;
    var openColorPopover = null;
    var colorPopoverListenersBound = false;
    var galleryPreviewState = { imageUrl: '', altText: '', variant: null };
    var GALLERY_SWIPE_THRESHOLD = 48;
    var GALLERY_SWIPE_AXIS_RATIO = 1.2;
    var LEGACY_TWO_CASE_LID_SCALE = 1.2;
    var CASE_SIZES = {
      'nano-pill-case': { main: '130px', main_mb: '86px', thumb: '20px', color: '48px', lid: '64px', lidBody: '96px', lidFrame: '36px', lidBodyFrame: '54px' },
      'nano-vitamin-case': { main: '145px', main_mb: '102px', thumb: '22px', color: '56px', lid: '76px', lidBody: '114px', lidFrame: '42px', lidBodyFrame: '63px' },
      'mission-pill-case': { main: '180px', main_mb: '120px', thumb: '20px', color: '56px', lid: '80px', lidBody: '120px', lidFrame: '50px', lidBodyFrame: '75px' },
      'mission-vitamin-case': { main: '200px', main_mb: '130px', thumb: '22px', color: '64px', lid: '96px', lidBody: '144px', lidFrame: '56px', lidBodyFrame: '84px' },
      'weekly-xs-case': { main: '320px', main_mb: '240px', thumb: '46px', color: '90px', lid: '160px', lidBody: '210px' },
      'weekly-pill-case': { main: '350px', main_mb: '263px', thumb: '52px', color: '100px', lid: '170px', lidBody: '225px' },
      'weekly-vitamin-case': { main: '420px', main_mb: '315px', thumb: '58px', color: '120px', lid: '180px', lidBody: '255px' },
      'weekly-vitamin-xl-case': { main: '420px', main_mb: '315px', thumb: '58px', color: '120px', lid: '180px', lidBody: '255px' },
      'weekly-vitamin-2xl-case': { main: '480px', main_mb: '360px', thumb: '62px', color: '130px', lid: '210px', lidBody: '285px' },
      'weekly-am-pm-pill-case': { main: '480px', main_mb: '360px', thumb: '87px', color: '120px', lid: '200px', lidBody: '225px' },
      'weekly-am-pm-vitamin-case': { main: '480px', main_mb: '360px', thumb: '105px', color: '120px', lid: '220px', lidBody: '255px' },
      'weekly-am-pm-vitamin-xl-case': { main: '480px', main_mb: '360px', thumb: '105px', color: '120px', lid: '220px', lidBody: '255px' },
      '2-week-pill-case': { main: '480px', main_mb: '360px', thumb: '87px', color: '120px', lid: '200px', lidBody: '225px' },
      '2-week-vitamin-case': { main: '480px', main_mb: '360px', thumb: '105px', color: '120px', lid: '220px', lidBody: '255px' },
      '2-week-vitamin-xl-case': { main: '480px', main_mb: '360px', thumb: '105px', color: '120px', lid: '220px', lidBody: '255px' }
    };
    var TWO_SIDE_COMPONENT_CASE_SIZES = {
      'weekly-am-pm-pill-case': { main: '350px', main_mb: '232px', thumb: '52px', color: '120px', lid: '200px', lidBody: '225px' },
      'weekly-am-pm-vitamin-case': { main: '420px', main_mb: '280px', thumb: '58px', color: '120px', lid: '220px', lidBody: '255px' },
      'weekly-am-pm-vitamin-xl-case': { main: '420px', main_mb: '280px', thumb: '58px', color: '120px', lid: '220px', lidBody: '255px' },
      '2-week-pill-case': { main: '350px', main_mb: '232px', thumb: '52px', color: '120px', lid: '200px', lidBody: '225px' },
      '2-week-vitamin-case': { main: '420px', main_mb: '280px', thumb: '58px', color: '120px', lid: '220px', lidBody: '255px' },
      '2-week-vitamin-xl-case': { main: '420px', main_mb: '280px', thumb: '58px', color: '120px', lid: '220px', lidBody: '255px' }
    };
    var DETAILS_PAGE_BY_SIZE = {
      'nano-pill-case': 'nano-pill-case',
      'nano-vitamin-case': 'nano-vitamin-case',
      'mission-pill-case': 'mission-pill-case',
      'mission-vitamin-case': 'mission-vitamin-case',
      'weekly-xs-case': 'weekly-xs-case',
      'weekly-xs-pill-case': 'weekly-xs-pill-case',
      'weekly-pill-case': 'weekly-pill-case',
      'weekly-vitamin-case': 'weekly-vitamin-case',
      'weekly-vitamin-xl-case': 'weekly-vitamin-xl-case',
      'weekly-vitamin-2xl-case': 'weekly-vitamin-2xl-case',
      'weekly-am-pm-pill-case': 'weekly-am-pm-pill-case',
      'weekly-am-pm-vitamin-case': 'weekly-am-pm-vitamin-case',
      'weekly-am-pm-vitamin-xl-case': 'weekly-am-pm-vitamin-xl',
      '2-week-pill-case': '2-week-pill-case',
      '2-week-vitamin-case': '2-week-vitamin-case',
      '2-week-vitamin-xl-case': '2-week-vitamin-xl-case'
    };
    var LID_PREVIEW_CONFIG = {
      'nano-pill-case': {
        orientation: 'vertical',
        fontSize: { gallery: 22, galleryMobile: 16, thumb: 4, thumbMobile: 4, header: 13, body: 16 },
        slots: { single: [{ slot: 0, x: 50, y: 27, w: 90, h: 24 }] }
      },
      'nano-vitamin-case': {
        orientation: 'vertical',
        fontSize: { gallery: 26, galleryMobile: 20, thumb: 4, thumbMobile: 4, header: 16, body: 22 },
        slots: { single: [{ slot: 0, x: 50, y: 27, w: 90, h: 24 }] }
      },
      'mission-pill-case': {
        orientation: 'vertical',
        stroke: true,
        fontSize: { gallery: 30, galleryMobile: 24, thumb: 6, thumbMobile: 4, header: 16, body: 22 },
        slots: { single: [{ slot: 0, x: 50, y: 35, w: 90, h: 24 }] }
      },
      'mission-vitamin-case': {
        orientation: 'vertical',
        stroke: true,
        fontSize: { gallery: 34, galleryMobile: 26, thumb: 8, thumbMobile: 4, header: 18, body: 27 },
        slots: { single: [{ slot: 0, x: 50, y: 35, w: 90, h: 24 }] }
      },
      'weekly-xs-case': {
        stroke: true,
        fontSize: { gallery: 30, galleryMobile: 24, thumb: 6, thumbMobile: 6, header: 15, body: 20 },
        slots: { single: [{ slot: 0, x: 50, y: 48 }] }
      },
      'weekly-pill-case': {
        stroke: true,
        fontSize: { gallery: 31, galleryMobile: 26, thumb: 8, thumbMobile: 4, header: 16, body: 20 },
        slots: { single: [{ slot: 0, x: 50, y: 48 }] }
      },
      'weekly-vitamin-case': {
        stroke: true,
        fontSize: { gallery: 42, galleryMobile: 30, thumb: 10, thumbMobile: 4, header: 18, body: 24 },
        slots: { single: [{ slot: 0, x: 50, y: 48 }] }
      },
      'weekly-vitamin-xl-case': {
        stroke: true,
        fontSize: { gallery: 42, galleryMobile: 30, thumb: 10, thumbMobile: 4, header: 18, body: 24 },
        slots: { single: [{ slot: 0, x: 50, y: 48 }] }
      },
      'weekly-vitamin-2xl-case': {
        stroke: true,
        fontSize: { gallery: 44, galleryMobile: 36, thumb: 10, thumbMobile: 4, header: 20, body: 27 },
        slots: { single: [{ slot: 0, x: 50, y: 48 }] }
      },
      'weekly-am-pm-pill-case': {
        stroke: true,
        scale: { body: LEGACY_TWO_CASE_LID_SCALE },
        fontSize: { gallery: 28, galleryMobile: 24, thumb: 8, thumbMobile: 4, header: 14, body: 16 },
        slots: {
          ampm: [{ slot: 0, x: 50, y: { default: 68, header: 69, body: 72 } }, { slot: 1, x: 50, y: { default: 31, header: 30, body: 27 } }]
        }
      },
      'weekly-am-pm-vitamin-case': {
        stroke: true,
        scale: { body: LEGACY_TWO_CASE_LID_SCALE },
        fontSize: { gallery: 32, galleryMobile: 30, thumb: 8, thumbMobile: 4, header: 16, body: 18 },
        slots: {
          ampm: [{ slot: 0, x: 50, y: { default: 70, header: 72, body: 72 } }, { slot: 1, x: 50, y: { default: 28, header: 28, body: 23.5 } }]
        }
      },
      'weekly-am-pm-vitamin-xl-case': {
        stroke: true,
        scale: { body: LEGACY_TWO_CASE_LID_SCALE },
        fontSize: { gallery: 36, galleryMobile: 30, thumb: 8, thumbMobile: 4, header: 16, body: 18 },
        slots: {
          ampm: [{ slot: 0, x: 50, y: { default: 71, header: 71, body: 75 } }, { slot: 1, x: 50, y: { default: 29, header: 28, body: 25 } }]
        }
      },
      '2-week-pill-case': {
        stroke: true,
        scale: { body: LEGACY_TWO_CASE_LID_SCALE },
        fontSize: { gallery: 28, galleryMobile: 24, thumb: 10, thumbMobile: 4, header: 14, body: 16 },
        slots: {
          two_week: [{ slot: 0, x: 50, y: { default: 31, header: 30, body: 27 } }, { slot: 1, x: 50, y: { default: 68, header: 69, body: 72 } }]
        }
      },
      '2-week-vitamin-case': {
        stroke: true,
        scale: { body: LEGACY_TWO_CASE_LID_SCALE },
        fontSize: { gallery: 32, galleryMobile: 30, thumb: 12, thumbMobile: 4, header: 16, body: 18 },
        slots: {
          two_week: [{ slot: 0, x: 50, y: { default: 28, header: 28, body: 23.5 } }, { slot: 1, x: 50, y: { default: 70, header: 72, body: 72 } }]
        }
      },
      '2-week-vitamin-xl-case': {
        stroke: true,
        scale: { body: LEGACY_TWO_CASE_LID_SCALE },
        fontSize: { gallery: 36, galleryMobile: 30, thumb: 12, thumbMobile: 4, header: 16, body: 18 },
        slots: {
          two_week: [{ slot: 0, x: 50, y: { default: 29, header: 28, body: 25 } }, { slot: 1, x: 50, y: { default: 71, header: 71, body: 75 } }]
        }
      }
    };
    var TWO_SIDE_COMPONENT_LID_PREVIEW_CONFIG = {
      'weekly-am-pm-pill-case': {
        stroke: true,
        fontSize: { gallery: 28, galleryMobile: 20, thumb: 8, thumbMobile: 4, header: 14, body: 16 },
        slots: {
          ampm: [{ slot: 0, x: 50, y: { default: 75, header: 75, body: 75 } }, { slot: 1, x: 50, y: { default: 25, header: 25, body: 25 } }]
        }
      },
      'weekly-am-pm-vitamin-case': {
        stroke: true,
        fontSize: { gallery: 38, galleryMobile: 28, thumb: 8, thumbMobile: 4, header: 20, body: 22 },
        slots: {
          ampm: [{ slot: 0, x: 50, y: { default: 74, header: 74, body: 74 } }, { slot: 1, x: 50, y: { default: 25, header: 26, body: 24 } }]
        }
      },
      'weekly-am-pm-vitamin-xl-case': {
        stroke: true,
        fontSize: { gallery: 38, galleryMobile: 30, thumb: 8, thumbMobile: 4, header: 20, body: 22 },
        slots: {
          ampm: [{ slot: 0, x: 50, y: { default: 74, header: 74, body: 75 } }, { slot: 1, x: 50, y: { default: 25, header: 28, body: 25 } }]
        }
      },
      '2-week-pill-case': {
        stroke: true,
        fontSize: { gallery: 28, galleryMobile: 20, thumb: 10, thumbMobile: 4, header: 14, body: 16 },
        slots: {
          two_week: [{ slot: 0, x: 50, y: { default: 25, header: 25, body: 25 } }, { slot: 1, x: 50, y: { default: 75, header: 75, body: 75 } }]
        }
      },
      '2-week-vitamin-case': {
        stroke: true,
        fontSize: { gallery: 38, galleryMobile: 28, thumb: 12, thumbMobile: 4, header: 20, body: 22 },
        slots: {
          two_week: [{ slot: 0, x: 50, y: { default: 25, header: 26, body: 24 } }, { slot: 1, x: 50, y: { default: 74, header: 74, body: 74 } }]
        }
      },
      '2-week-vitamin-xl-case': {
        stroke: true,
        fontSize: { gallery: 38, galleryMobile: 30, thumb: 12, thumbMobile: 4, header: 16, body: 22 },
        slots: {
          two_week: [{ slot: 0, x: 50, y: { default: 25, header: 28, body: 25 } }, { slot: 1, x: 50, y: { default: 74, header: 74, body: 75 } }]
        }
      }
    };
    var DEFAULT_LID_PREVIEW_SLOTS = {
      single: [{ slot: 0, x: 50, y: 48 }],
      singleVertical: [{ slot: 0, x: 50, y: 35, w: 90, h: 24 }],
      ampm: [{ slot: 0, x: 50, y: 72 }, { slot: 1, x: 50, y: 28 }],
      two_week: [{ slot: 0, x: 50, y: 28 }, { slot: 1, x: 50, y: 72 }]
    };

    var pickerState = {
      family: root.getAttribute('data-family') || null,
      tier: root.getAttribute('data-current-tier') || null,
      pendingSize: null,
      size: null,
      firstColor: null,
      secondColor: null,
      selectedVariant: null,
      twoSideComponents: null,
      lidEngraving: { mode: null, labels: [], variantId: null },
      pocketEngraving: { mode: null, value: '', variantId: null },
      // NONE / ADD (an extra Ultem lid alongside the aluminum case) /
      // SWAP (the case itself carries an Ultem lid).
      ultem: { mode: 'NONE', variantId: null },
      colorSummaryShown: false,
      lidSummaryShown: false,
      pocketSummaryShown: false,
      touchedSteps: {},
      expandedStep: null,
      urlPreselect: null
    };

    stepOrder.forEach(function (step) {
      pickerState.touchedSteps[step] = false;
    });

    function toLookupKey(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/['"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function formatKey(value) {
      var key = String(value || '').trim();
      if (!key) return '';
      return key
        .replace(/-/g, ' ')
        .replace(/\b[a-z]/g, function (letter) { return letter.toUpperCase(); });
    }

    function formatMoneySafe(cents) {
      var n = parseInt(cents, 10);
      if (!isFinite(n)) return '';
      if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
        return window.theme.Currency.formatMoney(n, window.theme.moneyFormat || moneyFormat);
      }
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(n, moneyFormat);
      }
      return '$' + (n / 100).toFixed(2);
    }

    function getCaseMetaCurrency() {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return String(window.Shopify.currency.active || '').trim().toUpperCase();
      }

      return String(cartCurrency || (window.theme && window.theme.shopCurrency) || '').trim().toUpperCase();
    }

    function buildCaseMeta(variant) {
      var cents = parseMoneyCents(variant && variant.price);
      var currency = getCaseMetaCurrency();
      if (!currency || cents <= 0) return '';

      return currency + ':' + (cents / 100).toFixed(2);
    }

    function closeCompareTooltip(callback) {
      if (!currentTooltip) {
        currentTooltipTrigger = null;
        if (callback) callback();
        return;
      }
      var tooltip = currentTooltip;
      function cleanup() {
        if (tooltip && tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
        if (currentTooltip === tooltip) currentTooltip = null;
        currentTooltipTrigger = null;
        if (callback) callback();
      }
      if (window.jQuery) {
        window.jQuery(tooltip).fadeOut(200, cleanup);
      } else {
        cleanup();
      }
    }

    function showCompareTooltip(trigger) {
      var tooltipUrl = trigger && trigger.getAttribute('data-tooltip');
      if (!tooltipUrl) return;

      var tooltip = document.createElement('div');
      tooltip.className = 'dynamic-tooltip';
      tooltip.style.backgroundImage = 'url("' + tooltipUrl.replace(/"/g, '\\"') + '")';
      tooltip.style.position = 'absolute';
      tooltip.style.display = 'none';
      document.body.appendChild(tooltip);
      currentTooltip = tooltip;
      currentTooltipTrigger = trigger;

      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      var isMobile = viewportWidth <= 768;
      var imgWidth = isMobile ? viewportWidth * 0.85 : 750;
      var img = new Image();

      img.onload = function () {
        if (currentTooltip !== tooltip) return;
        var naturalWidth = img.naturalWidth || img.width || imgWidth;
        var naturalHeight = img.naturalHeight || img.height || imgWidth;
        if (!isMobile && naturalWidth < 750) imgWidth = naturalWidth;
        var imgHeight = (imgWidth / naturalWidth) * naturalHeight;
        var rect = trigger.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

        tooltip.style.width = imgWidth + 'px';
        tooltip.style.height = imgHeight + 'px';
        tooltip.style.top = (rect.top + scrollTop + 20) + 'px';
        tooltip.style.left = Math.max((viewportWidth - imgWidth) / 2, 0) + 'px';

        if (window.jQuery) {
          window.jQuery(tooltip).fadeIn(200);
        } else {
          tooltip.style.display = 'block';
        }
      };
      img.onerror = function () {
        if (currentTooltip === tooltip) closeCompareTooltip();
      };
      img.src = tooltipUrl;
    }

    function toggleCompareTooltip(trigger) {
      if (currentTooltipTrigger === trigger) {
        closeCompareTooltip();
        return;
      }
      closeCompareTooltip(function () {
        showCompareTooltip(trigger);
      });
    }

    function getDetailsPageHandleForSize(sizeKey) {
      var key = toLookupKey(sizeKey);
      return DETAILS_PAGE_BY_SIZE[key] || '';
    }

    function getDefaultDetailsPageHandle() {
      return getDetailsPageHandleForSize(defaultSizeKey);
    }

    function getConfiguratorShopifySection() {
      return root.closest('.shopify-section');
    }

    function getDetailsSection() {
      var host = getConfiguratorShopifySection();
      if (!host) return null;
      var sibling = host.nextElementSibling;
      while (sibling && (!sibling.classList || !sibling.classList.contains('shopify-section'))) {
        sibling = sibling.nextElementSibling;
      }
      return sibling || null;
    }

    function sectionContainsConfigurator(sectionEl) {
      if (!sectionEl || !root.id) return false;
      var idElements = sectionEl.querySelectorAll('[id]');
      for (var i = 0; i < idElements.length; i++) {
        if (idElements[i].id === root.id) return true;
      }
      return false;
    }

    function extractDetailsSectionFromHtml(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var container = doc.querySelector('#PageContainer') || doc.body;
      if (!container) return null;

      for (var i = 0; i < container.children.length; i++) {
        var child = container.children[i];
        if (child.classList && child.classList.contains('shopify-section') && !sectionContainsConfigurator(child)) {
          return child;
        }
      }

      var sections = container.querySelectorAll('.shopify-section');
      for (var j = 0; j < sections.length; j++) {
        if (!sectionContainsConfigurator(sections[j])) return sections[j];
      }
      return null;
    }

    function activateInsertedScripts(container) {
      var scripts = container.querySelectorAll('script');
      for (var i = 0; i < scripts.length; i++) {
        var source = scripts[i];
        var replacement = document.createElement('script');
        for (var j = 0; j < source.attributes.length; j++) {
          var attr = source.attributes[j];
          replacement.setAttribute(attr.name, attr.value);
        }
        replacement.text = source.text || source.textContent || '';
        source.parentNode.replaceChild(replacement, source);
      }
    }

    function markDetailsSection(detailsSection, pageHandle) {
      if (!detailsSection) return;
      detailsSection.setAttribute('data-combined-v2-dynamic-details', '');
      detailsSection.setAttribute('data-combined-v2-details-page', pageHandle);
    }

    function replaceDetailsSection(nextSection, pageHandle) {
      var host = getConfiguratorShopifySection();
      if (!host || !nextSection) return false;

      nextSection = nextSection.cloneNode(true);
      markDetailsSection(nextSection, pageHandle);

      var currentDetails = getDetailsSection();
      if (currentDetails) {
        currentDetails.replaceWith(nextSection);
      } else {
        host.insertAdjacentElement('afterend', nextSection);
      }

      activateInsertedScripts(nextSection);
      detailsCurrentPage = pageHandle;
      detailsRequestedPage = null;
      document.dispatchEvent(new CustomEvent('combined-v2:details-loaded', {
        detail: {
          page: pageHandle,
          sectionId: root.getAttribute('data-section-id') || ''
        }
      }));
      return true;
    }

    function fetchDetailsPage(pageHandle, token, urls, index) {
      if (token !== detailsFetchToken) return;
      var url = urls[index || 0];
      if (!url) {
        if (detailsRequestedPage === pageHandle) detailsRequestedPage = null;
        console.warn('[combined-v2] No details page found for "' + pageHandle + '".');
        return;
      }

      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (token !== detailsFetchToken) return;
          var nextSection = extractDetailsSectionFromHtml(html);
          if (!nextSection) {
            fetchDetailsPage(pageHandle, token, urls, (index || 0) + 1);
            return;
          }
          if (!replaceDetailsSection(nextSection, pageHandle)) {
            console.warn('[combined-v2] Could not replace details section for "' + pageHandle + '".');
          }
        })
        .catch(function (err) {
          if (token !== detailsFetchToken) return;
          if ((index || 0) + 1 < urls.length) {
            fetchDetailsPage(pageHandle, token, urls, (index || 0) + 1);
            return;
          }
          if (detailsRequestedPage === pageHandle) detailsRequestedPage = null;
          console.warn('[combined-v2] Failed to load details page "' + pageHandle + '":', err);
        });
    }

    function syncDetailsSectionForSize(sizeKey, options) {
      // The Secret Menu template keeps its existing below-fold content. Combined
      // product templates opt into replacing the adjacent details section.
      if (catalogMode) return;
      var pageHandle = getDetailsPageHandleForSize(sizeKey);
      if (!pageHandle) return;

      if (options && options.initial && pageHandle === getDefaultDetailsPageHandle()) {
        markDetailsSection(getDetailsSection(), pageHandle);
        detailsCurrentPage = pageHandle;
        detailsRequestedPage = null;
        return;
      }

      if (detailsCurrentPage === pageHandle || detailsRequestedPage === pageHandle) return;

      var token = ++detailsFetchToken;
      detailsRequestedPage = pageHandle;
      fetchDetailsPage(pageHandle, token, [
        '/pages/combined-listings?view=' + encodeURIComponent(pageHandle)
      ], 0);
    }

    function readInlineJson(elementId) {
      var el = document.getElementById(elementId);
      if (!el || !el.textContent.trim()) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.warn('[bundle-builder] JSON parse failed for #' + elementId + ': ' + e.message);
        return null;
      }
    }

    // ?size= preselects the buybox; ?notify= opens the notify form prefilled.
    // Both take <size>[:<firstColor>[:<secondColor>]].
    function parseUrlPreselect(param) {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return null;
      }
      var raw = params.get(param);
      if (!raw) return null;
      var parts = String(raw).split(':').map(function (part) { return part.trim(); });
      var sizeKey = toLookupKey(parts[0]);
      if (!sizeKey) return null;
      return {
        raw: raw,
        rawSize: parts[0] || '',
        rawFirstColor: parts[1] || '',
        rawSecondColor: parts[2] || '',
        requestedSizeKey: sizeKey,
        sizeKey: sizeKey,
        firstColorKey: toLookupKey(parts[1]),
        secondColorKey: toLookupKey(parts[2])
      };
    }

    function sizeMatchesLookupKey(size, key) {
      if (!size || !key) return false;
      return toLookupKey(size.key) === key ||
        toLookupKey(size.label) === key ||
        toLookupKey(size.display_name) === key;
    }

    function findSizeByLookupKey(key) {
      if (!key) return null;
      for (var i = 0; i < sizeCatalog.length; i++) {
        if (sizeMatchesLookupKey(sizeCatalog[i], key)) return sizeCatalog[i];
      }
      return null;
    }

    function getSizeAliasKeys(preselect) {
      var key = preselect && (preselect.requestedSizeKey || preselect.sizeKey);
      if (!key) return [];

      if (key === 'nano' || key === 'nano-case') {
        return ['nano-pill-case', 'nano-vitamin-case'];
      }
      if (key === 'mission' || key === 'mission-case') {
        return ['mission-pill-case', 'mission-vitamin-case'];
      }
      if (key === 'weekly' || key === 'weekly-case') {
        return ['weekly-pill-case', 'weekly-xs-case', 'weekly-vitamin-case', 'weekly-vitamin-xl-case', 'weekly-vitamin-2xl-case'];
      }
      if (
        key === 'weekly-am-pm' ||
        key === 'weekly-ampm' ||
        key === 'weekly-am-pm-case' ||
        key === 'weekly-ampm-case'
      ) {
        return ['weekly-am-pm-pill-case', 'weekly-am-pm-vitamin-case', 'weekly-am-pm-vitamin-xl-case'];
      }
      if (
        key === '2-week' ||
        key === '2-week-case' ||
        key === 'two-week' ||
        key === 'two-week-case'
      ) {
        return ['2-week-pill-case', '2-week-vitamin-case', '2-week-vitamin-xl-case'];
      }
      return [];
    }

    function resolvePreselectedSize(preselect) {
      if (!preselect || !preselect.sizeKey) return null;

      var direct = findSizeByLookupKey(preselect.sizeKey);
      if (direct) return direct;

      var requested = preselect.requestedSizeKey ? findSizeByLookupKey(preselect.requestedSizeKey) : null;
      if (requested) return requested;

      var aliases = getSizeAliasKeys(preselect);
      for (var i = 0; i < aliases.length; i++) {
        var matched = findSizeByLookupKey(aliases[i]);
        if (matched) return matched;
      }
      return null;
    }

    function applyResolvedUrlPreselectSize(preselect, size) {
      if (!preselect || !size || !size.key) return;
      preselect.resolvedSizeKey = size.key;
      preselect.sizeKey = size.key;
    }

    function isTwoCaseFamily() {
      return pickerState.family === 'ampm' || pickerState.family === 'two_week';
    }

    function getSizeData(key) {
      if (!key) return null;
      for (var i = 0; i < sizeCatalog.length; i++) {
        if (sizeCatalog[i] && sizeCatalog[i].key === key) return sizeCatalog[i];
      }
      return null;
    }

    function getCatalogSizeFamily(size) {
      if (!size) return 'single';
      return size.family === 'ampm' || size.family === 'two_week' ? size.family : 'single';
    }

    function getCatalogCarrierProduct(size) {
      var family = getCatalogSizeFamily(size);
      if (family === 'ampm') return secretAmpmCarrierProduct;
      if (family === 'two_week') return secretTwoWeekCarrierProduct;
      return null;
    }

    function getCatalogCarrierVariant(size) {
      var carrier = getCatalogCarrierProduct(size);
      var sourceSize = size && (size.source_size || size.label);
      if (!carrier || !sourceSize) return null;
      return findComponentVariant(carrier, [
        { matcher: isSizeOptionName, value: sourceSize, match: 'size' }
      ]);
    }

    function getCatalogRequestSizeKey(size) {
      if (!size) return '';
      if (getCatalogSizeFamily(size) === 'single') {
        return size.source_size_key || toLookupKey(size.source_size || size.label || size.key);
      }
      var carrier = getCatalogCarrierProduct(size);
      var carrierVariant = getCatalogCarrierVariant(size);
      var carrierSize = carrierVariant ? getVariantOptionValue(carrier, carrierVariant, isSizeOptionName) : '';
      return toLookupKey(carrierSize || size.source_size || size.label || size.key);
    }

    function syncCatalogFamilyUi() {
      if (!catalogMode) return;
      var showCompositePreview = isTwoCaseFamily();
      var colorEditor = root.querySelector('[data-color-editor]');
      if (colorBodyPreviewEl) colorBodyPreviewEl.classList.toggle('tw:hidden', !showCompositePreview);
      if (colorEditor) {
        colorEditor.classList.toggle('tw:sm:grid-cols-[minmax(140px,max-content)_minmax(0,1fr)]', showCompositePreview);
      }
    }

    function applyCatalogSizeContext(size) {
      if (!catalogMode || !size) return;
      pickerState.family = getCatalogSizeFamily(size);
      root.setAttribute('data-family', pickerState.family);
      twoSideCarrierProduct = getCatalogCarrierProduct(size);
      twoSideAmProduct = null;
      twoSidePmProduct = null;
      if (pickerState.family === 'single') {
        productHandle = size.target_handle || (size.component_handles && size.component_handles[0]) || catalogHostHandle;
      } else {
        productHandle = twoSideCarrierProduct && twoSideCarrierProduct.handle
          ? twoSideCarrierProduct.handle
          : catalogHostHandle;
      }
      twoSideParentTitleTemplate = pickerState.family === 'two_week'
        ? (cfg.twoWeekParentTitleTemplate || '2-Week {size} 2.0')
        : (cfg.ampmParentTitleTemplate || 'Weekly AM-PM {size} 2.0');
      syncCatalogFamilyUi();
    }

    function getSizeDisplayName(size) {
      if (!size) return '';
      if (catalogMode && size.label) return size.label;
      return size.display_name || size.label || formatKey(size.key);
    }

    function getSizePresentationName(size) {
      if (!catalogMode || !size) return getSizeDisplayName(size);
      var sizeStep = window.theme && window.theme.sizeStep;
      return sizeStep ? sizeStep.fullName(size.family_prefix, size.display_name, size.label) : getSizeDisplayName(size);
    }

    function orderCatalogSizes(sizes) {
      if (!sizeOrder.length) return sizes.slice();
      var families = [];
      var knownKeys = [];
      var ordered = sizes.map(function (size, index) {
        var key = toLookupKey(size.key);
        knownKeys.push(key);
        var familyKey = size.family_key || size.family_prefix || size.family || '';
        var family = families.indexOf(familyKey);
        if (family < 0) {
          family = families.length;
          families.push(familyKey);
        }
        var rank = sizeOrder.indexOf(key);
        return { size: size, index: index, family: family, rank: rank < 0 ? sizeOrder.length : rank };
      }).sort(function (a, b) {
        // Keep the catalog's family order; apply preferences only within each family.
        return a.family - b.family || a.rank - b.rank || a.index - b.index;
      }).map(function (entry) { return entry.size; });
      var unmatched = sizeOrder.filter(function (key) { return knownKeys.indexOf(key) < 0; });
      if (unmatched.length) console.warn('[Secret V2] Size order matches no size on this page:', unmatched.join(', '));
      return ordered;
    }

    function getSelectedSizeLabel() {
      var size = getSizeData(pickerState.size || pickerState.pendingSize);
      return size ? (size.label || size.display_name || formatKey(size.key)) : formatKey(pickerState.size || pickerState.pendingSize);
    }

    function ciEquals(a, b) {
      return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
    }

    function normalizeAddonText(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
    }

    function normalizedContainsPhrase(value, phrase) {
      var haystack = ' ' + normalizeAddonText(value) + ' ';
      var needle = ' ' + normalizeAddonText(phrase) + ' ';
      return !!needle.trim() && haystack.indexOf(needle) !== -1;
    }

    function isVariantSellable(variant) {
      if (!variant) return false;
      var hasInventoryManagement = Object.prototype.hasOwnProperty.call(variant, 'inventory_management');
      return variant.available === true
        || (hasInventoryManagement && !variant.inventory_management)
        || variant.inventory_policy === 'continue';
    }

    function getProductOptionName(product, index) {
      var option = product && product.options && product.options[index];
      if (typeof option === 'string') return option;
      if (option && option.name) return option.name;
      return '';
    }

    function getVariantOptionValue(product, variant, matcher) {
      for (var i = 0; i < 3; i++) {
        var name = getProductOptionName(product, i);
        if (name && matcher(name)) return String(variant['option' + (i + 1)] || '').trim();
      }
      return '';
    }

    function isSizeOptionName(name) {
      var normalized = normalizeAddonText(name);
      return normalized === 'size'
        || normalized === 'case size'
        || (normalized.indexOf('size') !== -1 && normalized.indexOf('pocket') === -1);
    }

    function isColorOptionName(name) {
      var normalized = normalizeAddonText(name);
      return normalized === 'color' || normalized === 'colour';
    }

    function addonVariantValueText(variant) {
      return [
        variant && variant.title,
        variant && variant.option1,
        variant && variant.option2,
        variant && variant.option3
      ].join(' ');
    }

    function getAddonSizeKey(value) {
      var normalized = normalizeAddonText(value);
      if (normalized.indexOf('2xl') !== -1 || normalized.indexOf('2 xl') !== -1) return '2xl';
      if (normalized.indexOf('vitamin xl') !== -1) return 'vitamin-xl';
      if (normalized.indexOf('vitamin') !== -1) return 'vitamin';
      if (normalized.indexOf('pill') !== -1) return 'pill';
      if (normalized.indexOf('xs') !== -1) return 'xs';
      return '';
    }

    function getAddonFamilyKey(value) {
      var normalized = normalizeAddonText(value);
      if (normalized.indexOf('2 week') !== -1) return 'two_week';
      if (normalized.indexOf('am pm') !== -1 || normalized.indexOf('ampm') !== -1) return 'ampm';
      if (normalized.indexOf('weekly') !== -1) return 'weekly';
      if (normalized.indexOf('mission') !== -1) return 'mission';
      if (normalized.indexOf('nano') !== -1) return 'nano';
      return '';
    }

    // Addon listings label multi-case packs "(Set of N)". Size labels never carry
    // that suffix, so the count has to come from the family being configured.
    function getAddonSetCount(value) {
      var match = /(^| )set of ([0-9]+|two)( |$)/.exec(normalizeAddonText(value));
      if (!match) return 0;
      return match[2] === 'two' ? 2 : parseInt(match[2], 10);
    }

    function variantMatchesAddonSize(product, variant, sizeLabel) {
      if (!variant || !sizeLabel) return false;
      var sizeOption = getVariantOptionValue(product, variant, isSizeOptionName);
      var valueText = addonVariantValueText(variant);
      if (sizeOption && ciEquals(sizeOption, sizeLabel)) return true;

      // Drop wrong-size packs before any fuzzy match. The lid listing also sells
      // Magnetic Set packs as "… Case (Set of 1|3|4)", which contain a two-case
      // size label as a phrase and then tie with the correct row on score.
      var variantSetCount = getAddonSetCount(sizeOption || valueText);
      if (variantSetCount && variantSetCount !== (isTwoCaseFamily() ? 2 : 1)) return false;

      if (normalizedContainsPhrase(valueText, sizeLabel)) return true;

      var selectedFamily = getAddonFamilyKey(sizeLabel);
      var variantFamily = getAddonFamilyKey(sizeOption || valueText);
      var selectedSize = getAddonSizeKey(sizeLabel);
      var variantSize = getAddonSizeKey(sizeOption || valueText);
      if (!selectedSize || !variantSize || selectedSize !== variantSize) return false;
      if (!selectedFamily || !variantFamily) return false;
      return selectedFamily === variantFamily;
    }

    function scoreAddonVariant(product, variant, sizeLabel) {
      var score = 0;
      var sizeOption = getVariantOptionValue(product, variant, isSizeOptionName);
      var valueText = addonVariantValueText(variant);
      if (sizeOption) score += 8;
      if (sizeOption && ciEquals(sizeOption, sizeLabel)) score += 20;
      if (normalizedContainsPhrase(valueText, sizeLabel)) score += 15;
      if (getAddonFamilyKey(sizeOption || valueText) === getAddonFamilyKey(sizeLabel)) score += 5;
      if (getAddonSizeKey(sizeOption || valueText) === getAddonSizeKey(sizeLabel)) score += 4;
      return score;
    }

    function findAddonVariant(product) {
      var sizeLabel = getSelectedSizeLabel();
      if (!product || !Array.isArray(product.variants) || !sizeLabel) return null;
      // Exact size first: the shared engraving listings also sell "Ultem Lid - …" and $0
      // "Monthly Bundle - …" variants that contain the size and score the same, so otherwise
      // variant order alone would decide.
      var exactKey = normalizeAddonText(sizeLabel);
      var exact = product.variants.filter(function (variant) {
        return variant && (normalizeAddonText(variant.title) === exactKey || normalizeAddonText(variant.option1) === exactKey);
      });
      if (exact.length) return exact.find(isVariantSellable) || null;
      var matches = product.variants.filter(function (variant) {
        return isVariantSellable(variant) && variantMatchesAddonSize(product, variant, sizeLabel);
      });
      matches.sort(function (a, b) {
        return scoreAddonVariant(product, b, sizeLabel) - scoreAddonVariant(product, a, sizeLabel);
      });
      return matches[0] || null;
    }

    function isUltemConfigured() {
      return !!(ultemEnabledBySetting && ultemProduct && Array.isArray(ultemProduct.variants) && ultemProduct.variants.length);
    }

    function shouldSkipUltemStep() {
      // The step shows when either choice is on offer: an extra lid to add, or
      // an Ultem case to swap to. Swap is never hidden for being sold out, so
      // this asks whether the size has an Ultem case at all, not whether it is
      // in stock.
      if (isSwapSupportedForSize()) return false;
      return !isUltemConfigured() || (!!pickerState.size && !ultemVariant);
    }

    function findUltemVariant() {
      var sizeLabel = getSelectedSizeLabel();
      if (!isUltemConfigured() || !sizeLabel) return null;
      var exact = ultemProduct.variants.find(function (variant) {
        return isVariantSellable(variant) && ciEquals(variant.option1, sizeLabel);
      });
      if (exact) return exact;
      // The lid listing also sells Magnetic Set packs as "(Set of 1|3|4)" under
      // this same family and size, and they all tie in findAddonVariant's score.
      // A two-case PDP only ever wants the Set of 2 row.
      if (isTwoCaseFamily()) {
        var pair = ultemProduct.variants.find(function (variant) {
          return isVariantSellable(variant) && ciEquals(variant.option1, sizeLabel + ' (Set of 2)');
        });
        if (pair) return pair;
      }
      return findAddonVariant(ultemProduct);
    }

    // ---- Swapped: an Ultem-lid case instead of aluminum + a separate lid ----
    //
    // Pieces live on the Ultem case listing, which has more variants than
    // Liquid or the search payloads can see, so they are resolved through
    // theme.ultemCaseCatalog. Everything fails closed: if a piece, a color or
    // the matching engraving variant can't be resolved, Swap cannot be picked
    // and the shopper keeps the aluminum case.
    var swapState = {
      key: '',
      loading: false,
      ready: false,
      reason: 'unsupported',
      detail: '',
      variants: null,
      engravingVariant: null,
      promise: null
    };

    function getUltemCatalog() {
      var catalog = window.theme && window.theme.ultemCaseCatalog;
      if (!catalog || !ultemSwapEnabledBySetting || !ultemCaseHandle) return null;
      catalog.configure({ handle: ultemCaseHandle, url: ultemCaseUrl });
      return catalog;
    }

    function getUltemMode() {
      return (pickerState.ultem && pickerState.ultem.mode) || 'NONE';
    }

    function setUltemMode(mode) {
      if (!pickerState.ultem) pickerState.ultem = { mode: 'NONE', variantId: null };
      pickerState.ultem.mode = mode;
      pickerState.ultem.variantId = mode === 'ADD' && ultemVariant ? String(ultemVariant.id || '') : null;
    }

    function isSwapSupportedForSize() {
      // Whether an Ultem case exists for this size at all, ignoring color and
      // stock. Weekly XS has none, so its step keeps today's behavior, while a
      // sold-out color still shows Swap as Sold out.
      var catalog = getUltemCatalog();
      var sizeLabel = getSelectedSizeLabel();
      if (!catalog || !sizeLabel) return false;
      if (isTwoCaseFamily()) {
        return !!catalog.labelFor({ role: 'left', size: sizeLabel })
          && !!catalog.labelFor({ role: 'right', size: sizeLabel });
      }
      return !!catalog.labelFor({ size: sizeLabel });
    }

    function getSwapSlots() {
      // Two-case families reuse the physical left/right colors the component
      // resolution already worked out, so the 2-Week Week 1 = right rule is
      // never re-derived here.
      var catalog = getUltemCatalog();
      var sizeLabel = getSelectedSizeLabel();
      if (!catalog || !sizeLabel) return null;

      if (isTwoSideComponentFlow()) {
        var components = pickerState.twoSideComponents;
        if (!components || !components.ready || !components.amColorLabel || !components.pmColorLabel) return null;
        return [
          { role: 'left', spec: { role: 'left', size: sizeLabel }, color: components.amColorLabel },
          { role: 'right', spec: { role: 'right', size: sizeLabel }, color: components.pmColorLabel }
        ];
      }

      var colorName = getSelectedFirstColorName();
      if (!pickerState.selectedVariant || !colorName) return null;
      return [{ role: 'single', spec: { size: sizeLabel }, color: colorName }];
    }

    function getSwapKey(slots) {
      var catalog = getUltemCatalog();
      if (!catalog || !slots) return '';
      return slots.map(function (slot) {
        return slot.role + '::' + (catalog.labelFor(slot.spec) || '?') + '::' + catalog.colorKey(slot.color);
      }).join('|');
    }

    function resetSwapResolution() {
      swapState.key = '';
      swapState.loading = false;
      swapState.ready = false;
      swapState.reason = 'unsupported';
      swapState.detail = '';
      swapState.variants = null;
      swapState.engravingVariant = null;
      swapState.promise = null;
    }

    function findUltemLidEngravingVariant() {
      // The engraving listing sells an "Ultem Lid - <size>" row for every size,
      // priced the same as the aluminum row. Match the label exactly and
      // confirm the SKU family, then fail closed on anything ambiguous.
      var sizeLabel = getSelectedSizeLabel();
      if (!lidProduct || !Array.isArray(lidProduct.variants) || !sizeLabel) return null;
      var wanted = normalizeAddonText('Ultem Lid - ' + sizeLabel);
      var matches = lidProduct.variants.filter(function (variant) {
        if (!variant || !isVariantSellable(variant)) return false;
        if (String(variant.sku || '').trim().toUpperCase().indexOf('ENG-LID-ULTEM-') !== 0) return false;
        return normalizeAddonText(variant.option1) === wanted || normalizeAddonText(variant.title) === wanted;
      });
      return matches.length === 1 ? matches[0] : null;
    }

    function applySwapEntries(slots, entries) {
      var catalog = getUltemCatalog();
      var variants = [];
      var reason = '';
      var detail = '';

      for (var i = 0; i < slots.length; i++) {
        var entry = entries[i];
        if (!catalog || !entry || !entry.ok) {
          reason = 'error';
          detail = (entry && entry.error) || '';
          break;
        }
        var variant = entry.variantFor(slots[i].color);
        if (!variant) {
          reason = 'color';
          detail = slots[i].color;
          break;
        }
        if (!catalog.isSellable(variant)) {
          reason = 'soldout';
          detail = slots[i].color;
          break;
        }
        variants.push({ role: slots[i].role, variant: variant });
      }

      swapState.loading = false;
      swapState.promise = null;
      swapState.ready = !reason;
      swapState.reason = reason;
      swapState.detail = detail;
      swapState.variants = reason ? null : variants;
      swapState.engravingVariant = reason ? null : findUltemLidEngravingVariant();
      return swapState;
    }

    function ensureSwapResolution(options) {
      options = options || {};
      var catalog = getUltemCatalog();
      var slots = getSwapSlots();
      if (!catalog || !slots) {
        resetSwapResolution();
        return Promise.resolve(swapState);
      }

      var key = getSwapKey(slots);
      if (!options.force && swapState.key === key) {
        if (swapState.promise) return swapState.promise;
        if (swapState.ready || swapState.reason) return Promise.resolve(swapState);
      }

      resetSwapResolution();
      swapState.key = key;
      swapState.loading = true;
      swapState.reason = 'checking';

      var specs = slots.map(function (slot) { return slot.spec; });
      var load = options.force
        ? Promise.all(slots.map(function (slot) { return catalog.refresh(slot.spec); }))
        : catalog.loadMany(specs);

      var promise = load.then(function (entries) {
        // A newer size or color selection already replaced this request.
        if (swapState.key !== key) return swapState;
        return applySwapEntries(slots, entries);
      }).catch(function () {
        if (swapState.key !== key) return swapState;
        swapState.loading = false;
        swapState.promise = null;
        swapState.ready = false;
        swapState.reason = 'error';
        return swapState;
      });

      swapState.promise = promise;
      return promise;
    }

    function prefetchSwapSizeState() {
      // Colors aren't chosen yet, so this only warms the size's catalog entry.
      var catalog = getUltemCatalog();
      var sizeLabel = getSelectedSizeLabel();
      if (!catalog || !sizeLabel) return;
      var specs = isTwoCaseFamily()
        ? [{ role: 'left', size: sizeLabel }, { role: 'right', size: sizeLabel }]
        : [{ size: sizeLabel }];
      catalog.loadMany(specs).catch(function () {});
    }

    function getSwapBlockReason() {
      if (!isSwapSupportedForSize()) return 'unsupported';
      if (!getSwapSlots()) return 'incomplete';
      if (swapState.loading) return 'checking';
      if (!swapState.ready) return swapState.reason || 'unavailable';
      if (countNonEmpty(getConfirmedLidLabels()) > 0 && !swapState.engravingVariant) return 'engraving';
      return '';
    }

    function isSwapSelectable() {
      return getSwapBlockReason() === '';
    }

    function getSwapVariantsByRole() {
      if (getUltemMode() !== 'SWAP' || !swapState.ready || !swapState.variants) return null;
      var byRole = {};
      swapState.variants.forEach(function (slot) { byRole[slot.role] = slot.variant; });
      return byRole;
    }

    function getSwapTotalCents() {
      if (!swapState.ready || !swapState.variants) return null;
      var total = 0;
      swapState.variants.forEach(function (slot) { total += parseMoneyCents(slot.variant.price); });
      return total;
    }

    function getLidEngravingVariantForCart() {
      return getUltemMode() === 'SWAP' && swapState.engravingVariant
        ? swapState.engravingVariant
        : lidVariant;
    }

    function clearTwoSideComponentAttributes() {
      root.removeAttribute('data-two-side-components-ready');
      root.removeAttribute('data-two-side-components-error');
      root.removeAttribute('data-two-side-carrier-variant-id');
      root.removeAttribute('data-two-side-am-variant-id');
      root.removeAttribute('data-two-side-pm-variant-id');
      root.removeAttribute('data-two-side-parent-title');
    }

    function syncTwoSideComponentAttributes(state) {
      if (!state) {
        clearTwoSideComponentAttributes();
        return;
      }

      root.setAttribute('data-two-side-components-ready', state.ready ? 'true' : 'false');
      if (state.error) {
        root.setAttribute('data-two-side-components-error', state.error);
      } else {
        root.removeAttribute('data-two-side-components-error');
      }
      if (state.carrierVariant && state.carrierVariant.id) {
        root.setAttribute('data-two-side-carrier-variant-id', state.carrierVariant.id);
      } else {
        root.removeAttribute('data-two-side-carrier-variant-id');
      }
      if (state.amVariant && state.amVariant.id) {
        root.setAttribute('data-two-side-am-variant-id', state.amVariant.id);
      } else {
        root.removeAttribute('data-two-side-am-variant-id');
      }
      if (state.pmVariant && state.pmVariant.id) {
        root.setAttribute('data-two-side-pm-variant-id', state.pmVariant.id);
      } else {
        root.removeAttribute('data-two-side-pm-variant-id');
      }
      if (state.parentTitle) {
        root.setAttribute('data-two-side-parent-title', state.parentTitle);
      } else {
        root.removeAttribute('data-two-side-parent-title');
      }
    }

    function clearTwoSideComponentSelection() {
      pickerState.twoSideComponents = null;
      galleryPreviewState.componentPreview = null;
      clearTwoSideComponentAttributes();
    }

    function isTwoSideComponentFlow() {
      return pickerState.family === 'ampm' || pickerState.family === 'two_week';
    }

    function getTwoWeekV3CaseLabels() {
      return [
        'Week #1 - Top & Right Side',
        'Week #2 - Bottom & Left Side'
      ];
    }

    function getTwoSideComponentLabels() {
      if (pickerState.family === 'two_week') {
        var caseLabels = getTwoWeekV3CaseLabels();
        return {
          left: caseLabels[1],
          right: caseLabels[0]
        };
      }
      return {
        left: 'AM / Left Side',
        right: 'PM / Right Side'
      };
    }

    function getTwoSidePhysicalColorLabels() {
      var firstColorLabel = getSelectedFirstColorName();
      var secondColorLabel = getSelectedSecondColorName();
      if (pickerState.family === 'two_week') {
        return {
          left: secondColorLabel,
          right: firstColorLabel
        };
      }
      return {
        left: firstColorLabel,
        right: secondColorLabel
      };
    }

    function componentOptionMatches(actual, expected, rule) {
      var actualKey = toLookupKey(actual);
      var expectedKey = toLookupKey(expected);
      if (!!actualKey && !!expectedKey && actualKey === expectedKey) return true;
      if (rule && rule.match === 'size') {
        var actualSize = getAddonSizeKey(actual);
        var expectedSize = getAddonSizeKey(expected);
        return !!actualSize && !!expectedSize && actualSize === expectedSize;
      }
      return false;
    }

    function variantMatchesComponentOptions(product, variant, rules) {
      if (!variant || !Array.isArray(rules)) return false;
      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        var expected = String(rule.value || '').trim();
        if (!expected) return false;
        var actual = getVariantOptionValue(product, variant, rule.matcher);
        if (!componentOptionMatches(actual, expected, rule)) return false;
      }
      return true;
    }

    function findComponentVariant(product, rules) {
      if (!product || !Array.isArray(product.variants)) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (!isVariantSellable(variant)) continue;
        if (variantMatchesComponentOptions(product, variant, rules)) return variant;
      }
      return null;
    }

    function getTwoSideTitleSizeLabel(value) {
      var sizeKey = getAddonSizeKey(value);
      if (sizeKey === 'pill') return 'Pill Case';
      if (sizeKey === 'vitamin') return 'Vitamin Case';
      if (sizeKey === 'vitamin-xl') return 'Vitamin XL Case';
      if (sizeKey === '2xl') return 'Vitamin 2XL Case';
      if (sizeKey === 'xs') return 'XS Case';
      return String(value || '').trim();
    }

    function buildTwoSideParentTitle(sizeLabel, carrierVariant) {
      var selectedSize = getSizeData(pickerState.size);
      var carrierSize = carrierVariant ? getVariantOptionValue(twoSideCarrierProduct, carrierVariant, isSizeOptionName) : '';
      var rawSize = carrierSize || sizeLabel || (selectedSize ? getSizeDisplayName(selectedSize) : getSelectedSizeLabel());
      var displaySize = getTwoSideTitleSizeLabel(rawSize);
      return String(twoSideParentTitleTemplate || 'Weekly AM-PM {size} 2.0').replace('{size}', displaySize || '');
    }

    function resolveTwoSideComponentVariants() {
      if (!isTwoSideComponentFlow()) {
        clearTwoSideComponentSelection();
        return null;
      }

      if (catalogMode) {
        var catalogSize = getSizeData(pickerState.size || pickerState.pendingSize);
        var firstColor = getFirstColorData(pickerState.firstColor);
        var secondColor = getSecondColorData(pickerState.secondColor);
        var carrierVariant = getCatalogCarrierVariant(catalogSize);
        var firstVariant = firstColor && firstColor.variant
          ? Object.assign({}, firstColor.variant, {
              option1: catalogSize && catalogSize.source_size ? catalogSize.source_size : firstColor.variant.option1,
              option2: firstColor.name || firstColor.variant.option2
            })
          : null;
        var secondVariant = secondColor && secondColor.variant
          ? Object.assign({}, secondColor.variant, {
              option1: catalogSize && catalogSize.source_size ? catalogSize.source_size : secondColor.variant.option1,
              option2: secondColor.name || secondColor.variant.option2,
              option3: null
            })
          : null;
        var catalogLabels = getTwoSideComponentLabels();
        var catalogAmVariant = pickerState.family === 'two_week' ? secondVariant : firstVariant;
        var catalogPmVariant = pickerState.family === 'two_week' ? firstVariant : secondVariant;
        var catalogMissing = [];
        if (!carrierVariant) catalogMissing.push('carrier');
        if (!catalogAmVariant) catalogMissing.push('left');
        if (!catalogPmVariant) catalogMissing.push('right');
        var catalogState = {
          ready: catalogMissing.length === 0,
          error: catalogMissing.length ? 'Missing two-side component variants: ' + catalogMissing.join(', ') : '',
          carrierVariant: carrierVariant,
          amVariant: catalogAmVariant,
          pmVariant: catalogPmVariant,
          sizeLabel: getSelectedSizeLabel(),
          amColorLabel: catalogAmVariant ? catalogAmVariant.option2 : '',
          pmColorLabel: catalogPmVariant ? catalogPmVariant.option2 : '',
          parentTitle: carrierVariant ? buildTwoSideParentTitle(getSelectedSizeLabel(), carrierVariant) : '',
          amLabel: catalogLabels.left,
          pmLabel: catalogLabels.right
        };
        pickerState.twoSideComponents = catalogState;
        syncTwoSideComponentAttributes(catalogState);
        return catalogState;
      }

      var missingProducts = [];
      if (!twoSideCarrierProduct) missingProducts.push('carrier');
      if (!twoSideAmProduct) missingProducts.push('left');
      if (!twoSidePmProduct) missingProducts.push('right');
      var componentLabels = getTwoSideComponentLabels();
      if (missingProducts.length) {
        var productState = {
          ready: false,
          error: 'Missing two-side component products: ' + missingProducts.join(', '),
          carrierVariant: null,
          amVariant: null,
          pmVariant: null,
          sizeLabel: '',
          amColorLabel: '',
          pmColorLabel: '',
          parentTitle: '',
          amLabel: componentLabels.left,
          pmLabel: componentLabels.right
        };
        pickerState.twoSideComponents = productState;
        syncTwoSideComponentAttributes(productState);
        return productState;
      }

      var sizeLabel = getSelectedSizeLabel();
      var componentColorLabels = getTwoSidePhysicalColorLabels();
      var amColorLabel = componentColorLabels.left;
      var pmColorLabel = componentColorLabels.right;
      if (!pickerState.size || !pickerState.firstColor || !pickerState.secondColor || !sizeLabel || !amColorLabel || !pmColorLabel) {
        clearTwoSideComponentSelection();
        return null;
      }

      var carrierVariant = findComponentVariant(twoSideCarrierProduct, [
        { matcher: isSizeOptionName, value: sizeLabel, match: 'size' }
      ]);
      var amVariant = findComponentVariant(twoSideAmProduct, [
        { matcher: isSizeOptionName, value: sizeLabel, match: 'size' },
        { matcher: isColorOptionName, value: amColorLabel }
      ]);
      var pmVariant = findComponentVariant(twoSidePmProduct, [
        { matcher: isSizeOptionName, value: sizeLabel, match: 'size' },
        { matcher: isColorOptionName, value: pmColorLabel }
      ]);

      var missing = [];
      if (!carrierVariant) missing.push('carrier');
      if (!amVariant) missing.push('left');
      if (!pmVariant) missing.push('right');

      var state = {
        ready: missing.length === 0,
        error: missing.length ? 'Missing two-side component variants: ' + missing.join(', ') : '',
        carrierVariant: carrierVariant,
        amVariant: amVariant,
        pmVariant: pmVariant,
        sizeLabel: sizeLabel,
        amColorLabel: amColorLabel,
        pmColorLabel: pmColorLabel,
        parentTitle: buildTwoSideParentTitle(sizeLabel, carrierVariant),
        amLabel: componentLabels.left,
        pmLabel: componentLabels.right
      };

      pickerState.twoSideComponents = state;
      syncTwoSideComponentAttributes(state);
      return state;
    }

    function resolveAddOnVariants() {
      lidVariant = findAddonVariant(lidProduct);
      pocketVariant = findAddonVariant(pocketProduct);
      ultemVariant = findUltemVariant();
    }

    function updatePriceForSize(size) {
      if (!size) return;
      var price = size.base_price;
      var compare = size.compare_at_price;
      if (price === null || price === undefined) return;
      renderPriceWithAddons(price, compare);
    }

    function updatePriceForVariant(variant) {
      if (!variant) return;
      var price = variant.price;
      var compare = variant.compare_at_price;
      renderPriceWithAddons(price, compare);
    }

    function findTwoSidePriceVariant(product) {
      var sizeLabel = getSelectedSizeLabel();
      if (!product || !sizeLabel) return null;
      return findComponentVariant(product, [
        { matcher: isSizeOptionName, value: sizeLabel, match: 'size' }
      ]);
    }

    function getTwoSidePricePair(components) {
      if (!isTwoSideComponentFlow()) return null;
      components = components || pickerState.twoSideComponents || {};
      var amVariant = components.amVariant || findTwoSidePriceVariant(twoSideAmProduct);
      var pmVariant = components.pmVariant || findTwoSidePriceVariant(twoSidePmProduct);
      if (!amVariant || !pmVariant) return null;
      return {
        am: amVariant,
        pm: pmVariant
      };
    }

    function updateTwoSidePrice(components) {
      var pair = getTwoSidePricePair(components);
      if (!pair) return false;
      var price = parseMoneyCents(pair.am.price) + parseMoneyCents(pair.pm.price);
      var amCompare = parseMoneyCents(pair.am.compare_at_price);
      var pmCompare = parseMoneyCents(pair.pm.compare_at_price);
      var hasCompare = amCompare > parseMoneyCents(pair.am.price) || pmCompare > parseMoneyCents(pair.pm.price);
      var compare = hasCompare
        ? (amCompare || parseMoneyCents(pair.am.price)) + (pmCompare || parseMoneyCents(pair.pm.price))
        : null;
      renderPriceWithAddons(price, compare);
      return true;
    }

    function parseMoneyCents(value) {
      var cents = parseInt(value, 10);
      return isFinite(cents) ? cents : 0;
    }

    function formatAddonButtonPrice(variant, suffix = '') {
      var cents = variant ? parseMoneyCents(variant.price) : 0;
      return cents > 0 ? '(+' + formatMoneySafe(cents) + (suffix || '') + ')' : '';
    }

    function getCurrentAddonTotalCents() {
      resolveAddOnVariants();

      var total = 0;
      var lidLabels = getConfirmedLidLabels();
      var lidCount = countNonEmpty(lidLabels);
      if (lidCount > 0 && lidVariant) {
        total += parseMoneyCents(lidVariant.price) * lidCount;
      }

      if (
        pocketVariant
        && pickerState.pocketEngraving
        && pickerState.pocketEngraving.mode !== 'NONE'
        && String(pickerState.pocketEngraving.value || '').trim()
      ) {
        total += parseMoneyCents(pocketVariant.price);
      }

      if (ultemVariant && getUltemMode() === 'ADD') {
        total += parseMoneyCents(ultemVariant.price);
      }

      return total;
    }

    function getAluminumBaseCents() {
      // What the case costs without a Swap, for the difference shown on the
      // Swap button. Mirrors what refreshPriceDisplay would pass as the base.
      if (isTwoSideComponentFlow()) {
        var pair = getTwoSidePricePair();
        if (pair) return parseMoneyCents(pair.am.price) + parseMoneyCents(pair.pm.price);
      }
      if (pickerState.selectedVariant) return parseMoneyCents(pickerState.selectedVariant.price);
      var size = getSizeData(pickerState.size || pickerState.pendingSize);
      return size ? parseMoneyCents(size.base_price) : 0;
    }

    function getSwapDeltaCents() {
      var swapTotal = getSwapTotalCents();
      if (swapTotal === null) return null;
      return swapTotal - getAluminumBaseCents();
    }

    function renderPriceWithAddons(price, compare) {
      var basePrice = parseMoneyCents(price);
      // A Swapped case replaces the aluminum case, so its price replaces the
      // base rather than adding to it. Ultem pieces carry no compare-at price,
      // so no strikethrough is shown.
      if (getUltemMode() === 'SWAP') {
        var swapTotal = getSwapTotalCents();
        if (swapTotal !== null) {
          basePrice = swapTotal;
          price = swapTotal;
          compare = null;
        }
      }
      var addonTotal = getCurrentAddonTotalCents();
      var totalPrice = basePrice + addonTotal;

      if (priceEl && price !== null && price !== undefined) {
        priceEl.textContent = formatMoneySafe(totalPrice);
      }
      if (comparePriceEl) {
        var compareCents = parseMoneyCents(compare);
        var showCompare = compare !== null && compare !== undefined && compareCents > basePrice;
        comparePriceEl.textContent = showCompare ? formatMoneySafe(compareCents + addonTotal) : '';
        comparePriceEl.classList.toggle('tw:hidden', !showCompare);
      }
    }

    function refreshPriceDisplay() {
      if (updateTwoSidePrice()) return;

      if (pickerState.selectedVariant) {
        updatePriceForVariant(pickerState.selectedVariant);
        return;
      }

      var selectedSize = getSizeData(pickerState.size || pickerState.pendingSize);
      if (selectedSize) {
        updatePriceForSize(selectedSize);
      }
    }

    function setStockDisplay(status, label) {
      if (!stockEl) return;
      stockEl.setAttribute('data-stock-status', status);
      if (stockLabelEl) {
        stockLabelEl.textContent = label;
      } else {
        stockEl.textContent = label;
      }
    }

    function refreshStockDisplay() {
      if (!sizeCatalog.length) return;
      var hasAvailableSize = sizeCatalog.some(function (size) {
        return size && !size.sold_out;
      });
      if (hasAvailableSize) {
        setStockDisplay('instock', 'In stock');
      } else {
        setStockDisplay('outstock', 'Out of stock');
      }
    }

    function renderCaseSpecs() {
      var selectedSizeKey = pickerState.pendingSize || pickerState.size || defaultSizeKey;
      var matched = false;
      for (var i = 0; i < caseSpecPanels.length; i++) {
        var panel = caseSpecPanels[i];
        var isMatch = !!selectedSizeKey && panel.getAttribute('data-case-spec-size-key') === selectedSizeKey;
        panel.classList.toggle('tw:hidden', !isMatch);
        if (isMatch) matched = true;
      }
      if (caseSpecsEl) caseSpecsEl.classList.toggle('tw:hidden', !matched);
    }

    function getGallerySlideCount() {
      return root.querySelectorAll('[data-gallery-slide]').length;
    }

    function normalizeGalleryIndex(index) {
      var count = getGallerySlideCount();
      if (!count) return 0;
      var parsed = parseInt(index, 10);
      if (!isFinite(parsed)) parsed = 0;
      if (galleryV2) return Math.max(0, Math.min(count - 1, Math.max(galleryPreviewReady() ? 0 : 1, parsed)));
      if (parsed < 0) return count - 1;
      if (parsed >= count) return 0;
      return parsed;
    }

    function updateGalleryControls() {
      var count = getGallerySlideCount();
      var focusedControl = galleryV2 ? document.activeElement : null;
      var disabled = count <= 1;
      if (galleryPrevButton) galleryPrevButton.disabled = disabled;
      if (galleryNextButton) galleryNextButton.disabled = disabled;
      if (galleryStage) galleryStage.setAttribute('data-gallery-count', String(count));
      if (galleryV2) {
        if (galleryPrevButton) galleryPrevButton.hidden = activeGalleryIndex <= (galleryPreviewReady() ? 0 : 1);
        if (galleryNextButton) galleryNextButton.hidden = activeGalleryIndex >= count - 1;
        if (galleryStage && ((focusedControl === galleryPrevButton && galleryPrevButton.hidden) || (focusedControl === galleryNextButton && galleryNextButton.hidden))) {
          galleryStage.focus({ preventScroll: true });
        }
        // The preview is not numbered: slides read 1 / N from the product photo onward.
        if (galleryCounterCurrent) galleryCounterCurrent.textContent = String(Math.max(1, activeGalleryIndex));
        if (galleryCounterTotal) galleryCounterTotal.textContent = String(count - 1);
        root.setAttribute('data-gallery-index', String(activeGalleryIndex));
      }
    }

    // Gallery v2: slide 0 is the shopper's own case preview. It stays hidden until the first
    // customisation; until then the gallery opens on the product photo (slide 1).
    function galleryPreviewReady() {
      return !galleryV2 || root.hasAttribute('data-preview-ready');
    }

    function returnToGalleryPreview() {
      if (!galleryV2 || !galleryPreviewReady() || !galleryPreviewState.imageUrl) return;
      if (activeGalleryIndex !== 0) setActiveGallerySlide(0);
    }

    // Shows the arrows (and counter) for GALLERY_UI_STEP_MS after each move or touch, then fades them.
    function revealGalleryUi() {
      if (!galleryV2 || galleryDisposed) return;
      root.setAttribute('data-gallery-ui', 'on');
      if (galleryUiTimer) clearTimeout(galleryUiTimer);
      galleryUiTimer = setTimeout(function () {
        galleryUiTimer = null;
        if (!galleryUiHover) root.setAttribute('data-gallery-ui', 'off');
      }, GALLERY_UI_STEP_MS);
    }

    // Gallery v2 deferred loading: the preview background and slides 2+ carry data-gallery-src(set)
    // and the video a data-gallery-poster, so the product photo downloads alone and instantly.
    // near = the shopper is on or next to the slide (video may buffer); otherwise idle prefetch
    // (images and the poster only, never the video file).
    function loadGallerySlide(index, near) {
      var slide = root.querySelector('[data-gallery-slide][data-slide-index="' + index + '"]');
      if (!slide) return;
      var img = slide.querySelector('img[data-gallery-src]');
      if (img) {
        // The builder may already have drawn its own image here (slide 0); never overwrite it.
        if (!img.getAttribute('src')) {
          if (img.getAttribute('data-gallery-srcset')) img.srcset = img.getAttribute('data-gallery-srcset');
          img.src = img.getAttribute('data-gallery-src');
        }
        img.removeAttribute('data-gallery-src');
        img.removeAttribute('data-gallery-srcset');
      }
      var video = slide.querySelector('[data-gallery-video]');
      if (video) {
        if (video.hasAttribute('data-gallery-poster')) {
          video.poster = video.getAttribute('data-gallery-poster');
          video.removeAttribute('data-gallery-poster');
        }
        if (near && video.preload !== 'auto') video.preload = 'auto';
      }
    }

    function loadGalleryNeighbours() {
      if (!galleryV2) return;
      var first = galleryPreviewReady() ? 0 : 1;
      [activeGalleryIndex, activeGalleryIndex + 1, activeGalleryIndex - 1, galleryResumeIndex].forEach(function (index) {
        if (index >= first) loadGallerySlide(index, true);
      });
    }

    function loadAllGallerySlides() {
      var count = getGallerySlideCount();
      for (var i = 0; i < count; i++) loadGallerySlide(i, false);
    }

    function updateGalleryVideoButton(video) {
      if (galleryDisposed) return;
      var slide = video.closest('[data-gallery-slide]');
      var button = slide && slide.querySelector('[data-gallery-video-play]');
      if (!button) return;
      var active = slide.getAttribute('data-active') === 'true';
      button.hidden = !active;
      button.disabled = !active;
      button.setAttribute('aria-label', video.paused
        ? (button.getAttribute('data-play-label') || 'Play video')
        : (button.getAttribute('data-pause-label') || 'Pause video'));
      var playIcon = button.querySelector('[data-gallery-video-play-icon]');
      var pauseIcon = button.querySelector('[data-gallery-video-pause-icon]');
      if (playIcon) playIcon.hidden = !video.paused;
      if (pauseIcon) pauseIcon.hidden = video.paused;
    }

    function playGalleryVideo(video) {
      try {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () { updateGalleryVideoButton(video); });
      } catch (error) { /* Keep the play control available if playback is refused. */ }
      updateGalleryVideoButton(video);
    }

    function syncGalleryVideos(previousIndex) {
      if (!galleryV2) return;
      var slides = root.querySelectorAll('[data-gallery-slide]');
      for (var i = 0; i < slides.length; i++) {
        var video = slides[i].querySelector('[data-gallery-video]');
        if (!video) continue;
        if (slides[i].getAttribute('data-active') === 'true') {
          updateGalleryVideoButton(video);
          if (previousIndex === activeGalleryIndex) continue;
          try { video.currentTime = 0; } catch (error) { /* metadata not loaded yet */ }
          // Reduced motion: no autoplay; the play button starts it.
          if (galleryReducedMotion) {
            video.pause();
            updateGalleryVideoButton(video);
            continue;
          }
          playGalleryVideo(video);
        } else {
          video.pause();
          updateGalleryVideoButton(video);
        }
      }
    }

    function scrollActiveThumbIntoView() {
      if (!galleryV2 || !galleryThumbsRest) return;
      var active = galleryThumbsRest.querySelector('[data-gallery-thumb][data-active="true"]');
      if (!active) return;
      var box = galleryThumbsRest.getBoundingClientRect();
      var r = active.getBoundingClientRect();
      var pad = 16;
      if (r.left < box.left + pad) {
        galleryThumbsRest.scrollLeft -= (box.left + pad - r.left);
      } else if (r.right > box.right - pad) {
        galleryThumbsRest.scrollLeft += (r.right - (box.right - pad));
      }
    }

    function setActiveGallerySlide(index) {
      var previousGalleryIndex = activeGalleryIndex;
      activeGalleryIndex = normalizeGalleryIndex(index);
      if (galleryV2 && activeGalleryIndex === 0 && previousGalleryIndex > 0) {
        // Remember where the shopper was, so the next arrow returns them there.
        galleryResumeIndex = previousGalleryIndex;
      } else if (galleryV2 && activeGalleryIndex > 0) {
        galleryResumeIndex = 0;
      }
      var targetIndex = String(activeGalleryIndex);
      var slides = root.querySelectorAll('[data-gallery-slide]');
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      for (var i = 0; i < slides.length; i++) {
        var slide = slides[i];
        var slideActive = slide.getAttribute('data-slide-index') === targetIndex;
        if (galleryV2) {
          if (!slideActive && galleryStage && slide.contains(document.activeElement)) {
            galleryStage.focus({ preventScroll: true });
          }
          if (slideActive) slide.removeAttribute('inert'); else slide.setAttribute('inert', '');
          slide.setAttribute('aria-hidden', slideActive ? 'false' : 'true');
        }
        slide.setAttribute('data-active', slideActive ? 'true' : 'false');
      }
      for (var j = 0; j < thumbs.length; j++) {
        var thumb = thumbs[j];
        var isActive = thumb.getAttribute('data-slide-target') === targetIndex;
        thumb.setAttribute('data-active', isActive ? 'true' : 'false');
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      }
      updateGalleryControls();
      if (galleryV2) {
        loadGalleryNeighbours();
        syncGalleryVideos(previousGalleryIndex);
        scrollActiveThumbIntoView();
        // Only a shopper's own action brings the arrows back; programmatic resets on load do not.
        if (galleryReady && Date.now() - galleryLastUserAt < 1500) revealGalleryUi();
      }
    }

    function moveGallery(delta) {
      if (galleryV2 && delta > 0 && activeGalleryIndex === 0 && galleryResumeIndex > 0) {
        setActiveGallerySlide(galleryResumeIndex);
        return;
      }
      setActiveGallerySlide(activeGalleryIndex + delta);
    }

    function galleryPageZoomed() {
      return !!window.visualViewport && window.visualViewport.scale > 1.01;
    }

    function beginGallerySwipe(event) {
      if (!galleryStage || getGallerySlideCount() <= 1) return;
      // Gallery v2: a second finger or a pinched-in page is the shopper zooming the page, never a swipe.
      if (galleryV2 && (event.isPrimary === false || galleryPageZoomed())) {
        gallerySwipeState = null;
        return;
      }
      if (event.pointerType && event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
      if (typeof event.button === 'number' && event.button !== 0) return;

      gallerySwipeState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY
      };

      if (galleryStage.setPointerCapture && event.pointerId !== undefined) {
        try {
          galleryStage.setPointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture can fail if the browser has already claimed the gesture.
        }
      }
    }

    function endGallerySwipe(event) {
      if (!gallerySwipeState) return;
      if (event.pointerId !== undefined && gallerySwipeState.pointerId !== event.pointerId) return;

      var deltaX = event.clientX - gallerySwipeState.startX;
      var deltaY = event.clientY - gallerySwipeState.startY;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);

      if (
        absX >= GALLERY_SWIPE_THRESHOLD &&
        absX > absY * GALLERY_SWIPE_AXIS_RATIO
      ) {
        moveGallery(deltaX < 0 ? 1 : -1);
      }

      if (galleryStage && galleryStage.releasePointerCapture && event.pointerId !== undefined) {
        try {
          galleryStage.releasePointerCapture(event.pointerId);
        } catch (error) {
          // The browser may release pointer capture before pointerup.
        }
      }

      gallerySwipeState = null;
    }

    function cancelGallerySwipe(event) {
      if (!gallerySwipeState) return;
      if (event && event.pointerId !== undefined && gallerySwipeState.pointerId !== event.pointerId) return;
      gallerySwipeState = null;
    }

    // Gallery v2 tap zones (snippets/pdp-gallery-v2-tap-zones.liquid): once the arrows fade, a tap on
    // the image edge works as that arrow. A tap is one finger, under 10px of movement and 500ms.
    // Touch taps act on pointerup, not click: iOS Safari drops the click of a tap that brings the
    // faded arrows back (it reads the tap as a hover), which made every first tap a no-op.
    // A side tap (zone or faded arrow) moves; a centre tap only shows the arrows and counter,
    // or plays / pauses the video. The click the browser may still send for that tap is swallowed.
    var GALLERY_TAP_MAX_MOVE = 10;
    var GALLERY_TAP_MAX_MS = 500;
    var galleryTap = null;
    var galleryTapHandledAt = 0;

    function beginGalleryTap(event) {
      if (event.isPrimary === false) {
        if (galleryTap) galleryTap.multi = true;
        return;
      }
      galleryTapHandledAt = 0;
      galleryTap = { x: event.clientX, y: event.clientY, at: Date.now(), moved: 0, multi: false, ready: false };
    }

    function trackGalleryTap(event) {
      if (!galleryTap || event.isPrimary === false) return;
      galleryTap.moved = Math.max(galleryTap.moved, Math.abs(event.clientX - galleryTap.x), Math.abs(event.clientY - galleryTap.y));
    }

    function endGalleryTap(event) {
      if (!galleryTap || event.isPrimary === false) return;
      trackGalleryTap(event);
      galleryTap.ready = !galleryTap.multi && !galleryPageZoomed() && galleryTap.moved < GALLERY_TAP_MAX_MOVE && Date.now() - galleryTap.at < GALLERY_TAP_MAX_MS;
      if (galleryTap.ready && event.pointerType !== 'mouse') {
        galleryTap = null;
        galleryTapHandledAt = Date.now();
        handleGalleryTouchTap(event.clientX, event.clientY);
      }
    }

    function isInsideRect(element, x, y) {
      var rect = element.getBoundingClientRect();
      return rect.width && x >= rect.left && x < rect.right && y >= rect.top && y < rect.bottom;
    }

    // Moves as the arrow on that side would: nothing where the arrow is hidden (first / last slide).
    function moveGalleryLikeArrow(side) {
      var arrow = side === 'prev' ? galleryPrevButton : galleryNextButton;
      if (!arrow || arrow.hidden || arrow.disabled) return;
      moveGallery(side === 'prev' ? -1 : 1);
    }

    function handleGalleryTouchTap(x, y) {
      var slide = root.querySelector('[data-gallery-slide][data-active="true"]');
      var video = slide && slide.querySelector('[data-gallery-video]');
      var button = slide && slide.querySelector('[data-gallery-video-play]');
      if (video && button && !button.hidden && isInsideRect(button, x, y)) {
        toggleGalleryVideo(video);
        return;
      }
      var side = '';
      if (galleryPrevButton && !galleryPrevButton.hidden && isInsideRect(galleryPrevButton, x, y)) side = 'prev';
      else if (galleryNextButton && !galleryNextButton.hidden && isInsideRect(galleryNextButton, x, y)) side = 'next';
      else side = galleryTapZoneAt(x, y);
      if (side) {
        moveGalleryLikeArrow(side);
        return;
      }
      if (video) toggleGalleryVideo(video);
      // Anywhere else in the centre: the pointerdown already brought the arrows and counter back.
    }

    // Tap toggles play / pause (moving content must be pausable).
    function toggleGalleryVideo(video) {
      if (video.paused) {
        playGalleryVideo(video);
      } else {
        video.pause();
        updateGalleryVideoButton(video);
      }
    }

    // Capture phase: the click for a touch tap already handled on pointerup never reaches the arrows,
    // the zones or the video, so nothing moves twice.
    function swallowHandledGalleryTapClick(event) {
      if (!galleryTapHandledAt || Date.now() - galleryTapHandledAt > 800) return;
      galleryTapHandledAt = 0;
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    // Measured from coordinates, since pointer capture can retarget the click to the stage.
    function galleryTapZoneAt(x, y) {
      var zones = galleryStage.querySelectorAll('[data-gallery-tap-zone]');
      for (var i = 0; i < zones.length; i++) {
        var rect = zones[i].getBoundingClientRect();
        if (rect.width && x >= rect.left && x < rect.right && y >= rect.top && y < rect.bottom) return zones[i].getAttribute('data-gallery-tap-zone');
      }
      return '';
    }

    function handleGalleryTapClick(event) {
      var tapped = galleryTap && galleryTap.ready;
      galleryTap = null;
      var playButton = event.target.closest('[data-gallery-video-play]');
      var video = event.target.closest('[data-gallery-video]') || (playButton && playButton.parentElement.querySelector('[data-gallery-video]'));
      if (video) {
        // Touch playback is handled on pointerup. Only a valid mouse tap or the
        // button's keyboard/programmatic activation may reach playback here.
        var keyboardClick = playButton && event.detail === 0 && !event.pointerType && !(event.sourceCapabilities && event.sourceCapabilities.firesTouchEvents);
        var slide = video.closest('[data-gallery-slide]');
        if ((!tapped && !keyboardClick) || !slide || slide.getAttribute('data-active') !== 'true') return;
        event.preventDefault();
        toggleGalleryVideo(video);
        return;
      }
      if (!tapped || event.target.closest('button, a, input, select, textarea, label')) return;
      var zone = galleryTapZoneAt(event.clientX, event.clientY);
      var arrow = zone === 'prev' ? galleryPrevButton : zone === 'next' ? galleryNextButton : null;
      if (arrow && !arrow.hidden && !arrow.disabled) arrow.click();
    }

    // A pinched-in page lets one finger pan it over the gallery (pdp-gallery-v2.css).
    function syncGalleryPageZoom() {
      if (galleryPageZoomed()) root.setAttribute('data-gallery-page-zoomed', '');
      else root.removeAttribute('data-gallery-page-zoomed');
    }

    function ensurePreviewImage(container, selector, attrs) {
      var image = container ? container.querySelector(selector) : null;
      if (image || !container) return image;

      image = document.createElement('img');
      Object.keys(attrs || {}).forEach(function (name) {
        if (attrs[name] !== null) image.setAttribute(name, attrs[name]);
      });
      container.appendChild(image);
      return image;
    }

    function ensurePreviewFrame(container, selector, attrs) {
      var frame = container ? container.querySelector(selector) : null;
      if (frame || !container) return frame;

      frame = document.createElement('span');
      Object.keys(attrs || {}).forEach(function (name) {
        if (attrs[name] !== null) frame.setAttribute(name, attrs[name]);
      });
      container.appendChild(frame);
      return frame;
    }

    function resetCaseImageSize(image) {
      if (!image) return;
      image.style.position = '';
      image.style.top = '';
      image.style.right = '';
      image.style.bottom = '';
      image.style.left = '';
      image.style.transform = '';
      image.style.width = '';
      image.style.height = '';
      image.style.maxWidth = '';
      image.style.maxHeight = '';
    }

    function isNarrowPreview() {
      return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    }

    function getLidPreviewLabels() {
      if (!pickerState.lidEngraving || pickerState.lidEngraving.mode === 'NONE') {
        return normalizeLidLabels([], getLidInputCount(), getLidMaxLength());
      }
      return normalizeLidLabels(pickerState.lidEngraving.labels || [], getLidInputCount(), getLidMaxLength());
    }

    function updateGalleryLidPreview() {
      var labels = getLidPreviewLabels();
      var componentPreview = isTwoSideComponentFlow() ? (galleryPreviewState.componentPreview || getTwoSideComponentPreview()) : null;
      renderLidPreviewMount(mainPreviewFrame, {
        context: 'gallery',
        labels: labels,
        variant: galleryPreviewState.variant || pickerState.selectedVariant,
        imageSrc: galleryPreviewState.imageUrl,
        componentPreview: componentPreview,
        ariaLabel: galleryPreviewState.altText || 'Lid engraving preview',
        absolute: true
      });
      renderLidPreviewMount(thumbPreviewFrame, {
        context: 'thumb',
        hideLabels: galleryV2,
        labels: labels,
        variant: galleryPreviewState.variant || pickerState.selectedVariant,
        imageSrc: galleryPreviewState.imageUrl,
        componentPreview: componentPreview,
        ariaLabel: galleryPreviewState.altText || 'Lid engraving preview',
        absolute: true
      });
    }

    function refreshGalleryPreviewWidths() {
      updateGalleryLidPreview();
    }

    function setBaseImage(image, imageUrl, altText) {
      if (!image || !imageUrl) return;
      image.src = imageUrl;
      image.alt = altText || image.alt || '';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      resetCaseImageSize(image);
    }

    function getCaseSize(variant) {
      var sizeKey = getCaseKey(variant);
      if (sizeKey && CASE_SIZES[sizeKey]) return CASE_SIZES[sizeKey];
      return null;
    }

    function getCaseKey(variant) {
      return toLookupKey((variant && variant.option1) || getSelectedSizeLabel());
    }

    function getCaseImageSrc(color, side) {
      var resolver = window.theme && window.theme.caseImages;
      if (!color || !resolver) return '';
      var variant = color.variant;
      if (isTwoSideComponentFlow() && !side) {
        var components = pickerState.twoSideComponents;
        // Payload rows retain the real component ID even when their option labels
        // follow logical Week 1 / Week 2 ordering. Resolve the physical product.
        if (variant && variant.id && components) {
          if (components.amVariant && String(components.amVariant.id) === String(variant.id)) side = 'left';
          else if (components.pmVariant && String(components.pmVariant.id) === String(variant.id)) side = 'right';
        }
        if (!side) return '';
      }
      // Secret catalog sizes include their family prefix; source variants may
      // carry only "Pill Case" or "Vitamin Case" in option1.
      var sizeKey = catalogMode && (pickerState.size || pickerState.pendingSize);
      if (!sizeKey) sizeKey = side ? toLookupKey(getSelectedSizeLabel() || (variant && variant.option1)) : getCaseKey(variant);
      return resolver.resolve(caseImagesByColor, {
        colorKey: getCaseColorKey(color),
        sizeKey: sizeKey,
        side: side
      });
    }

    function getTwoSideComponentPreview() {
      if (!isTwoSideComponentFlow()) return null;
      var components = pickerState.twoSideComponents || resolveTwoSideComponentVariants();
      if (!components || !components.ready) return null;

      var fallbackVariant = components.carrierVariant || components.pmVariant || components.amVariant || pickerState.selectedVariant || null;
      var labels = getTwoSideComponentLabels();
      var leftImage = getCaseSrc({ key: components.amColorLabel, variant: components.amVariant }, 'left');
      var rightImage = getCaseSrc({ key: components.pmColorLabel, variant: components.pmVariant }, 'right');
      if (!leftImage && !rightImage) return null;

      return {
        left: {
          role: 'left_case',
          label: components.amLabel || labels.left,
          variant: components.amVariant || fallbackVariant,
          image: leftImage
        },
        right: {
          role: 'right_case',
          label: components.pmLabel || labels.right,
          variant: components.pmVariant || fallbackVariant,
          image: rightImage
        },
        fallbackVariant: fallbackVariant
      };
    }

    function getTwoSideComponentPreviewVariant(preview) {
      preview = preview || getTwoSideComponentPreview();
      return preview && (
        (preview.right && preview.right.variant)
        || (preview.left && preview.left.variant)
        || preview.fallbackVariant
      );
    }

    function getTwoSidePreviewCaseKey(variant) {
      var sizeKey = getAddonSizeKey(getSelectedSizeLabel() || (variant && variant.option1));
      var prefix = pickerState.family === 'two_week' ? '2-week' : 'weekly-am-pm';
      if (sizeKey === 'vitamin-xl' || sizeKey === '2xl') return prefix + '-vitamin-xl-case';
      if (sizeKey === 'vitamin') return prefix + '-vitamin-case';
      return prefix + '-pill-case';
    }

    function getTwoSideComponentCaseSize(variant) {
      var caseKey = getTwoSidePreviewCaseKey(variant);
      return (caseKey && TWO_SIDE_COMPONENT_CASE_SIZES[caseKey]) || getCaseSize(variant);
    }

    function getTwoSideComponentLidConfig(variant) {
      var caseKey = getTwoSidePreviewCaseKey(variant);
      return (caseKey && TWO_SIDE_COMPONENT_LID_PREVIEW_CONFIG[caseKey]) || getLidPreviewConfig(variant);
    }

    function getTwoSideComponentPreviewWidth(variant, context) {
      var size = getTwoSideComponentCaseSize(variant);
      if (context === 'colorHeader') return (size && (size.color || size.thumb)) || '64px';
      if (context === 'colorBody') return (size && size.color) || '96px';
      if (!size) return getLidPreviewImageWidth(variant, context);
      var contextKey = getLidPreviewContextKey(context);
      if (contextKey === 'galleryMobile') return size.main_mb || size.main || '150px';
      if (context === 'gallery') return size.main || '150px';
      if (context === 'thumb' && galleryV2) {
        var v2Thumb = getGalleryV2ThumbWidth(isNarrowPreview() ? (size.main_mb || size.main) : size.main);
        if (v2Thumb) return v2Thumb;
      }
      if (context === 'thumb') return size.thumb || '48px';
      if (context === 'body') return size.lidBody || size.lid || '150px';
      return size.lid || '150px';
    }

    function getTwoSideComponentPreviewContext(context) {
      if (context === 'colorHeader') return 'header';
      if (context === 'colorBody') return 'body';
      return context || 'header';
    }

    function hasTwoSideShadow(context) {
      return context === 'gallery';
    }

    function getTwoSideShadowClip(index, count, context) {
      if (!hasTwoSideShadow(context)) return '';
      var bleed = '28px';
      if (count <= 1) return 'inset(-' + bleed + ')';
      if (index === 0) return 'inset(-' + bleed + ' -' + bleed + ' 0 -' + bleed + ')';
      if (index === count - 1) return 'inset(0 -' + bleed + ' -' + bleed + ' -' + bleed + ')';
      return 'inset(0 -' + bleed + ')';
    }

    function getTwoSideRadius(variant) {
      var sizeKey = getAddonSizeKey(getSelectedSizeLabel() || (variant && variant.option1));
      return sizeKey === 'vitamin' || sizeKey === 'vitamin-xl' ? '8px' : '6px';
    }

    function createTwoSideImg(side, imageWidth, context, index, count) {
      if (!side || !side.image) return null;
      var img = document.createElement('img');
      img.src = side.image;
      img.alt = '';
      img.loading = context === 'gallery' ? 'eager' : 'lazy';
      img.className = 'tw:block tw:h-auto tw:max-w-none tw:object-contain';
      img.style.width = imageWidth;
      img.style.height = 'auto';
      img.style.maxWidth = 'none';
      if (hasTwoSideShadow(context)) {
        img.style.borderRadius = getTwoSideRadius(side.variant);
        img.style.boxShadow = '5px 5px 15px rgba(0, 0, 0, 0.8)';
      }
      if (hasTwoSideShadow(context)) {
        var clip = document.createElement('span');
        clip.className = 'tw:block tw:relative';
        clip.style.width = imageWidth;
        clip.style.lineHeight = '0';
        clip.style.clipPath = getTwoSideShadowClip(index || 0, count || 1, context);
        clip.appendChild(img);
        return clip;
      }
      return img;
    }

    function createTwoSideComponentPreviewFrame(options) {
      options = options || {};
      var preview = options.componentPreview || getTwoSideComponentPreview();
      if (!preview) return null;

      var context = options.context || 'header';
      var layoutContext = getTwoSideComponentPreviewContext(context);
      var variant = options.variant || getTwoSideComponentPreviewVariant(preview) || pickerState.selectedVariant;
      var config = getTwoSideComponentLidConfig(variant);
      var imageWidth = options.imageWidth || getTwoSideComponentPreviewWidth(variant, context);
      var frameWidth = options.frameWidth || getLidPreviewFrameWidth(variant, config, layoutContext, imageWidth);
      var labels = Array.isArray(options.labels) ? options.labels : [];
      var frame = document.createElement('span');
      var stack = document.createElement('span');

      frame.setAttribute('data-two-side-component-preview', '');
      frame.setAttribute('role', 'img');
      frame.setAttribute('aria-label', options.ariaLabel || 'Selected two-side case preview');
      frame.className = 'tw:relative tw:inline-flex tw:flex-shrink-0 tw:items-center tw:justify-center';
      frame.style.width = frameWidth;
      frame.style.overflow = 'visible';

      stack.className = 'tw:flex tw:flex-col tw:items-center tw:justify-center';
      stack.style.width = imageWidth;
      stack.style.transformOrigin = 'center center';
      if (context === 'colorBody') {
        stack.style.transform = 'rotate(90deg)';
      }

      var previewSides = [preview.right, preview.left].filter(function (side) {
        return side && side.image;
      });
      previewSides.forEach(function (side, index) {
        var img = createTwoSideImg(side, imageWidth, context, index, previewSides.length);
        if (img) stack.appendChild(img);
      });

      if (!stack.childNodes.length) return null;

      frame.appendChild(stack);

      if (labels.length && !options.hideLabels) {
        var slots = getLidPreviewSlots(config);
        var fontSize = getLidPreviewFontSize(config, layoutContext);
        var useStroke = !!config.stroke && context !== 'thumb';
        slots.forEach(function (slot) {
          frame.appendChild(createLidPreviewLabel(labels[slot.slot], slot, {
            context: layoutContext,
            fontSize: fontSize,
            stroke: useStroke,
            colorName: getTwoSideLidPreviewColorName(preview, slot.slot)
          }));
        });
      }

      return frame;
    }

    function getTransparentPreviewSrc() {
      return 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
    }

    function setComponentPreviewBaseImages() {
      var transparentSrc = getTransparentPreviewSrc();
      setBaseImage(mainImg, galleryBgSrc || transparentSrc, productHandle || '');
      setBaseImage(thumbImg, galleryBgThumbSrc || galleryBgSrc || transparentSrc, productHandle || '');
    }

    function resetGallerySelectionPreview() {
      galleryPreviewState = {
        imageUrl: '',
        altText: productHandle || '',
        variant: null,
        componentPreview: null
      };
      setComponentPreviewBaseImages();
      updateGalleryLidPreview();
      root.removeAttribute('data-preview-mode');
      root.removeAttribute('data-selected-variant-id');
      // Gallery v2: once shown, the preview stays pinned and the shopper keeps their place
      // (it redraws when the next colour is chosen).
      if (galleryV2 && activeGalleryIndex !== 0) return;
      setActiveGallerySlide(0);
    }

    function updateProductMedia(imageUrl, altText, variant, options) {
      options = options || {};
      var primaryPlaceholder = mainSlide ? mainSlide.querySelector('[data-primary-placeholder]') : null;
      if (primaryPlaceholder) primaryPlaceholder.classList.add('tw:hidden');
      mainImg = ensurePreviewImage(mainSlide, '[data-primary-media]', {
        'data-primary-media': '',
        alt: productHandle || '',
        loading: 'eager',
        class: 'tw:h-full tw:w-full tw:object-contain'
      });
      thumbImg = ensurePreviewImage(mainThumb, '[data-primary-thumb-image]', {
        'data-primary-thumb-image': '',
        alt: productHandle || '',
        loading: 'lazy',
        class: 'tw:absolute tw:inset-0 tw:h-full tw:w-full tw:object-contain'
      });
      mainPreviewFrame = ensurePreviewFrame(mainSlide, '[data-primary-preview-frame]', {
        'data-primary-preview-frame': '',
        class: 'tw:hidden tw:pointer-events-none tw:absolute tw:z-10'
      });
      thumbPreviewFrame = ensurePreviewFrame(mainThumb, '[data-primary-thumb-preview-frame]', {
        'data-primary-thumb-preview-frame': '',
        class: 'tw:hidden tw:pointer-events-none tw:absolute tw:z-10'
      });
      // A missing canvas must clear the previous selection, never retain its
      // image or promote the initial merchandising photo into a case preview.
      var baseSrc = options.transparentBase ? (imageUrl || getTransparentPreviewSrc()) : (galleryBgSrc || getTransparentPreviewSrc());
      var baseThumbSrc = options.transparentBase ? imageUrl : (galleryBgThumbSrc || baseSrc);
      setBaseImage(mainImg, baseSrc, productHandle || '');
      setBaseImage(thumbImg, baseThumbSrc, productHandle || '');
      galleryPreviewState = {
        imageUrl: imageUrl || '',
        altText: altText || productHandle || '',
        variant: variant || null,
        componentPreview: null
      };
      // Show the pinned preview before drawing it, so the thumbnail has a width to scale to.
      if (galleryV2 && imageUrl) root.setAttribute('data-preview-ready', '');
      updateGalleryLidPreview();
      setActiveGallerySlide(0);
    }

    function getVariantPreviewAlt(variant) {
      if (!variant) return productHandle || '';
      return [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' - ');
    }

    function getMediaSrc(variant) {
      return getCaseSrc({ variant: variant });
    }

    function applyVariantDisplay(variant, previewMode) {
      if (!variant) return;
      updatePriceForVariant(variant);
      updateProductMedia(getMediaSrc(variant), getVariantPreviewAlt(variant), variant);
      root.setAttribute('data-preview-mode', previewMode || 'variant');
      root.setAttribute('data-selected-variant-id', variant.id || '');
    }

    function applySingleCaseVariantDisplay(variant) {
      applyVariantDisplay(variant, 'single-variant');
    }

    function applyTwoCaseCompositeVariantDisplay(variant) {
      if (isTwoSideComponentFlow()) {
        var components = pickerState.twoSideComponents || resolveTwoSideComponentVariants();
        var componentPreview = getTwoSideComponentPreview();
        var displayVariant = (components && components.carrierVariant) || variant;
        var imageUrl = galleryBgSrc || getTransparentPreviewSrc();
        if (!displayVariant && componentPreview) displayVariant = getTwoSideComponentPreviewVariant(componentPreview);
        if (!displayVariant) return;
        if (!updateTwoSidePrice(components)) updatePriceForVariant(displayVariant);
        updateProductMedia(imageUrl, getVariantPreviewAlt(displayVariant), displayVariant, { transparentBase: true });
        galleryPreviewState.componentPreview = componentPreview;
        setComponentPreviewBaseImages();
        updateGalleryLidPreview();
        root.setAttribute('data-preview-mode', 'component-variant');
        root.setAttribute('data-selected-variant-id', displayVariant.id || '');
        return;
      }
      applyVariantDisplay(variant, 'composite-variant');
    }

    function getColorData(key) {
      if (!key) return null;
      for (var i = 0; i < colorCatalog.length; i++) {
        if (colorCatalog[i] && colorCatalog[i].key === key) return colorCatalog[i];
      }
      return null;
    }

    function getFirstColorData(key) {
      if (!key) return null;
      for (var i = 0; i < firstColorCatalog.length; i++) {
        if (firstColorCatalog[i] && firstColorCatalog[i].key === key) return firstColorCatalog[i];
      }
      return null;
    }

    function getSecondColorData(key) {
      if (!key) return null;
      for (var i = 0; i < secondColorCatalog.length; i++) {
        if (secondColorCatalog[i] && secondColorCatalog[i].key === key) return secondColorCatalog[i];
      }
      return null;
    }

    function getColorDisplayName(color) {
      if (!color) return '';
      return color.name || formatKey(color.key);
    }

    function getColorSortIndex(color) {
      if (!color || color.sort_index === null || color.sort_index === undefined) return null;
      var raw = String(color.sort_index).trim();
      if (!raw) return null;
      var parsed = Number(raw);
      return isFinite(parsed) ? parsed : null;
    }

    function getSortedColorList(catalog) {
      return catalog.map(function (color, sourceIndex) {
        return {
          color: color,
          sourceIndex: sourceIndex,
          sortIndex: getColorSortIndex(color)
        };
      }).sort(function (a, b) {
        var aUnavailable = !!a.color.sold_out || !a.color.variant;
        var bUnavailable = !!b.color.sold_out || !b.color.variant;
        if (aUnavailable !== bUnavailable) return aUnavailable ? 1 : -1;
        var aSecretPriority = !!a.color.secret_menu_priority;
        var bSecretPriority = !!b.color.secret_menu_priority;
        if (cfg.prioritizeSecretColors !== false && aSecretPriority !== bSecretPriority) return aSecretPriority ? -1 : 1;
        if (a.sortIndex !== null && b.sortIndex !== null && a.sortIndex !== b.sortIndex) {
          return a.sortIndex - b.sortIndex;
        }
        if (a.sortIndex !== null && b.sortIndex === null) return -1;
        if (a.sortIndex === null && b.sortIndex !== null) return 1;
        return a.sourceIndex - b.sourceIndex;
      }).map(function (entry) {
        return entry.color;
      });
    }

    function getSortedColors() {
      return getSortedColorList(colorCatalog);
    }

    function getFirstSelectableFromCatalog(catalog) {
      var sortedCatalog = getSortedColorList(catalog || []);
      for (var i = 0; i < sortedCatalog.length; i++) {
        if (sortedCatalog[i] && !sortedCatalog[i].sold_out && sortedCatalog[i].variant) return sortedCatalog[i];
      }
      return null;
    }

    function getFirstSelectableColor() {
      return getFirstSelectableFromCatalog(colorCatalog);
    }

    function getPrefetchProductDataPromise(args) {
      if (!window.theme || !theme.productDataFetcher) return null;
      var fetcher = typeof theme.productDataFetcher.prefetch === 'function'
        ? theme.productDataFetcher.prefetch
        : theme.productDataFetcher.fetch;
      if (typeof fetcher !== 'function') return null;
      return fetcher.apply(theme.productDataFetcher, args);
    }

    function getTwoSideColorProductHandles(size) {
      if (catalogMode) {
        var handles = size && Array.isArray(size.two_side_handles) ? size.two_side_handles : [];
        return handles.length === 2 ? handles.slice(0, 2) : ['', ''];
      }
      if (!isTwoSideComponentFlow() || !twoSideAmProduct || !twoSidePmProduct) return ['', ''];
      if (!twoSideAmProduct.handle || !twoSidePmProduct.handle) return ['', ''];
      return [twoSideAmProduct.handle, twoSidePmProduct.handle];
    }

    function requireMatchingListingContext(payload, context) {
      var expectedFamily = catalogMode && context === 'sizes' ? 'catalog' : pickerState.family;
      var expectedTwoSideListingContext = expectedFamily === 'single'
        ? listingContext
        : twoSideListingContext;
      if (
        !payload ||
        payload.error ||
        (
          payload.listing_context === listingContext &&
          payload.two_side_listing_context === expectedTwoSideListingContext &&
          payload.family === expectedFamily
        )
      ) return payload;
      console.warn(
        '[combined-v2] ' + context + ' request context mismatch.',
        {
          requested: {
            family: expectedFamily,
            primary: listingContext,
            twoSide: expectedTwoSideListingContext
          },
          received: {
            family: payload && payload.family,
            primary: payload && payload.listing_context,
            twoSide: payload && payload.two_side_listing_context
          }
        }
      );
      return { error: 'request_context_mismatch', reason: 'request_context_mismatch' };
    }

    function buildSizeFetchArgs() {
      if (catalogMode) {
        return ['secret', catalogHostHandle, 'sizes', fetchTier, listingContext, twoSideListingContext];
      }
      return ['combined', productHandle, 'sizes', fetchTier, listingContext, pickerState.family]
        .concat(getTwoSideColorProductHandles())
        .concat([twoSideListingContext]);
    }

    function buildColorFetchArgs(action, sizeKey, firstColorKey) {
      var size = getSizeData(sizeKey);
      var requestHandle = catalogMode
        ? (getCatalogSizeFamily(size) === 'single'
          ? (size && (size.target_handle || (size.component_handles && size.component_handles[0])))
          : ((getCatalogCarrierProduct(size) && getCatalogCarrierProduct(size).handle) || productHandle))
        : productHandle;
      var requestSizeKey = catalogMode ? getCatalogRequestSizeKey(size) : sizeKey;
      var requestFamily = catalogMode ? getCatalogSizeFamily(size) : pickerState.family;
      var args = ['combined', requestHandle, action, requestSizeKey];
      if (action === 'secondcolors') args.push(firstColorKey);
      args.push(fetchTier, colorMode, listingContext, requestFamily);
      args = args.concat(getTwoSideColorProductHandles(size));
      args.push(twoSideListingContext);
      return args;
    }

    function hasIndependentSecondColors() {
      return isTwoSideComponentFlow();
    }

    function getSecondColorCacheKey(firstColorKey) {
      return hasIndependentSecondColors() ? '__two_side_child_colors__' : (firstColorKey || '');
    }

    function getInitialTwoCaseFirstColorKeyForPrefetch(catalog) {
      var candidateKey = colorCandidateForSizeChange || pickerState.firstColor;
      var candidate = getCatalogColorByKey(catalog, candidateKey);
      if (candidate && !candidate.sold_out && candidate.variant) return candidate.key;

      var preselect = !ignoreUrlColorPreselectOnce ? pickerState.urlPreselect : null;
      var preselected = preselect && preselect.firstColorKey
        ? getCatalogColorByKey(catalog, preselect.firstColorKey)
        : null;
      if (preselected && !preselected.sold_out && preselected.variant) return preselected.key;

      var fallback = getFirstSelectableFromCatalog(catalog || []);
      return fallback ? fallback.key : '';
    }

    function prefetchSingleColorsForSize(sizeKey) {
      if (!sizeKey) return;
      if (colorPayload && colorFetchSize === sizeKey) return;
      if (colorPrefetchPayload && colorPrefetchSize === sizeKey) return;
      if (colorPrefetchPromise && colorPrefetchSize === sizeKey) return;

      var args = buildColorFetchArgs('colors', sizeKey);
      var promise = getPrefetchProductDataPromise(args);
      if (!promise) return;

      colorPrefetchSize = sizeKey;
      colorPrefetchPayload = null;
      colorPrefetchPromise = promise
        .then(function (payload) {
          payload = requireMatchingListingContext(payload, 'colors prefetch');
          if (colorPrefetchSize === sizeKey) {
            colorPrefetchPayload = payload;
            colorPrefetchPromise = null;
          }
          return payload;
        })
        .catch(function () {
          if (colorPrefetchSize === sizeKey) colorPrefetchPromise = null;
          return null;
        });
    }

    function prefetchSecondColorsForSize(sizeKey, firstColorKey) {
      if (!sizeKey || !firstColorKey || !pickerState.tier) return;
      var secondColorCacheKey = getSecondColorCacheKey(firstColorKey);
      if (
        secondColorPayload &&
        secondColorFetchSize === sizeKey &&
        secondColorFetchFirstColor === secondColorCacheKey
      ) return;
      if (
        secondColorPrefetchPayload &&
        secondColorPrefetchSize === sizeKey &&
        secondColorPrefetchFirstColor === secondColorCacheKey
      ) return;
      if (
        secondColorPrefetchPromise &&
        secondColorPrefetchSize === sizeKey &&
        secondColorPrefetchFirstColor === secondColorCacheKey
      ) return;

      var args = buildColorFetchArgs('secondcolors', sizeKey, firstColorKey);
      var promise = getPrefetchProductDataPromise(args);
      if (!promise) return;

      secondColorPrefetchSize = sizeKey;
      secondColorPrefetchFirstColor = secondColorCacheKey;
      secondColorPrefetchPayload = null;
      secondColorPrefetchPromise = promise
        .then(function (payload) {
          payload = requireMatchingListingContext(payload, 'second colors prefetch');
          if (secondColorPrefetchSize === sizeKey && secondColorPrefetchFirstColor === secondColorCacheKey) {
            secondColorPrefetchPayload = payload;
            secondColorPrefetchPromise = null;
          }
          return payload;
        })
        .catch(function () {
          if (secondColorPrefetchSize === sizeKey && secondColorPrefetchFirstColor === secondColorCacheKey) {
            secondColorPrefetchPromise = null;
          }
          return null;
        });
    }

    function prefetchFirstColorsForSize(sizeKey) {
      if (!sizeKey || !pickerState.tier) return;
      if (firstColorPayload && firstColorFetchSize === sizeKey) return;
      if (firstColorPrefetchPayload && firstColorPrefetchSize === sizeKey) {
        if (firstColorPrefetchPayload && !firstColorPrefetchPayload.error && Array.isArray(firstColorPrefetchPayload.colors)) {
          prefetchSecondColorsForSize(sizeKey, getInitialTwoCaseFirstColorKeyForPrefetch(firstColorPrefetchPayload.colors));
        }
        return;
      }
      if (firstColorPrefetchPromise && firstColorPrefetchSize === sizeKey) return;

      var args = buildColorFetchArgs('firstcolors', sizeKey);
      var promise = getPrefetchProductDataPromise(args);
      if (!promise) return;

      firstColorPrefetchSize = sizeKey;
      firstColorPrefetchPayload = null;
      firstColorPrefetchPromise = promise
        .then(function (payload) {
          payload = requireMatchingListingContext(payload, 'first colors prefetch');
          if (firstColorPrefetchSize === sizeKey) {
            firstColorPrefetchPayload = payload;
            firstColorPrefetchPromise = null;
            if (payload && !payload.error && Array.isArray(payload.colors)) {
              prefetchSecondColorsForSize(sizeKey, getInitialTwoCaseFirstColorKeyForPrefetch(payload.colors));
            }
          }
          return payload;
        })
        .catch(function () {
          if (firstColorPrefetchSize === sizeKey) firstColorPrefetchPromise = null;
          return null;
        });
    }

    function prefetchColorsForSize(sizeKey) {
      var size = getSizeData(sizeKey);
      if (!size || size.sold_out) return;
      var family = catalogMode ? getCatalogSizeFamily(size) : ((sizePayload && sizePayload.family) || pickerState.family);
      if (family === 'single') {
        prefetchSingleColorsForSize(size.key);
      } else if (family === 'ampm' || family === 'two_week') {
        prefetchFirstColorsForSize(size.key);
      }
    }

    function getStepEl(step) {
      return root.querySelector('[data-step="' + step + '"]');
    }

    function getStepHeader(step) {
      return root.querySelector('[data-step-header="' + step + '"]');
    }

    function getStepBody(step) {
      return root.querySelector('[data-step-body="' + step + '"]');
    }

    function setStepBodyVisible(step, visible) {
      var body = getStepBody(step);
      var header = getStepHeader(step);
      if (!body) return;
      if (!visible && body.contains(document.activeElement)) {
        if (header && typeof header.focus === 'function' && !header.disabled) {
          header.focus();
        } else if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
      }
      body.hidden = false;
      body.classList.toggle('tw:grid-rows-[1fr]', visible);
      body.classList.toggle('tw:grid-rows-[0fr]', !visible);
      body.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) {
        body.removeAttribute('inert');
      } else {
        body.setAttribute('inert', '');
      }
      if (header) header.setAttribute('aria-expanded', visible ? 'true' : 'false');
    }

    function getStepVisualState(el) {
      if (!el) return 'pending';
      var active = el.getAttribute('data-active') === 'true';
      var touched = el.getAttribute('data-touched') === 'true';
      var locked = el.getAttribute('data-locked') === 'true';
      if (active && !locked) return 'active';
      if (touched && !locked) return 'confirmed';
      return 'pending';
    }

    function applyStepVisualState(step) {
      var el = getStepEl(step);
      if (!el) return;
      var state = getStepVisualState(el);
      var active = state === 'active';
      var confirmed = state === 'confirmed';
      var pending = state === 'pending';
      var locked = el.getAttribute('data-locked') === 'true';
      var header = getStepHeader(step);
      var badge = el.querySelector('[data-step-badge]');
      var chevron = el.querySelector('[data-step-chevron]');

      el.classList.toggle('tw:border-blue-300', active);
      el.classList.toggle('tw:border-green-300', confirmed);
      el.classList.toggle('tw:border-gray-300', pending);
      el.classList.toggle('tw:ring-1', active || confirmed);
      el.classList.toggle('tw:ring-blue-300', active);
      el.classList.toggle('tw:ring-green-300', confirmed);
      el.classList.toggle('tw:shadow-sm', active || confirmed);

      if (header) {
        header.disabled = locked;
        header.classList.toggle('tw:opacity-50', locked);
        header.classList.toggle('tw:cursor-not-allowed', locked);
        header.classList.toggle('tw:bg-blue-50', active);
        header.classList.toggle('tw:bg-green-50', confirmed);
        header.classList.toggle('tw:bg-gray-50', pending);
        header.classList.toggle('tw:text-gray-800', active || confirmed);
        header.classList.toggle('tw:text-gray-700', pending);
      }
      if (badge) {
        badge.setAttribute('data-state', state);
        badge.classList.toggle('tw:text-gray-800', active || confirmed);
        badge.classList.toggle('tw:text-gray-700', pending);
        var check = badge.querySelector('[data-badge-check]');
        if (check) {
          check.classList.toggle('tw:hidden', !confirmed);
          check.classList.toggle('tw:inline-flex', confirmed);
        }
      }
      if (chevron) {
        chevron.classList.toggle('tw:rotate-180', active);
        chevron.classList.toggle('tw:text-blue-700', active);
        chevron.classList.toggle('tw:text-green-700', confirmed);
        chevron.classList.toggle('tw:text-gray-500', pending);
      }
    }

    function setStepLocked(step, locked) {
      var el = getStepEl(step);
      if (!el) return;
      el.setAttribute('data-locked', locked ? 'true' : 'false');
      if (locked) {
        setStepBodyVisible(step, false);
        el.setAttribute('data-active', 'false');
        if (pickerState.expandedStep === step) pickerState.expandedStep = null;
      }
      applyStepVisualState(step);
    }

    function setStepTouched(step, touched) {
      var el = getStepEl(step);
      if (!el) return;
      pickerState.touchedSteps[step] = !!touched;
      el.setAttribute('data-touched', touched ? 'true' : 'false');
      applyStepVisualState(step);
      var summary = root.querySelector('[data-step-summary="' + step + '"]');
      if (summary) {
        var hasValue = !!summary.getAttribute('data-summary-value');
        summary.classList.toggle('tw:hidden', !shouldShowStepSummary(step, hasValue));
      }
    }

    function shouldShowStepSummary(step, hasValue) {
      return !!hasValue && (
        !!pickerState.touchedSteps[step]
        || (step === '2' && !!pickerState.colorSummaryShown)
        || (step === '3' && !!pickerState.lidSummaryShown)
        || (step === '4' && !!pickerState.pocketSummaryShown)
      );
    }

    function setStepSummary(step, text) {
      var summary = root.querySelector('[data-step-summary="' + step + '"]');
      if (!summary) return;
      var value = String(text || '').trim();
      summary.innerHTML = '';
      if (value) {
        var label = document.createElement('span');
        label.className = 'tw:font-normal tw:text-gray-600';
        label.textContent = 'Selected: ';
        var valueEl = document.createElement('span');
        valueEl.className = 'tw:font-bold tw:text-black';
        valueEl.textContent = value;
        summary.appendChild(label);
        summary.appendChild(valueEl);
        summary.setAttribute('data-summary-value', value);
        summary.setAttribute('aria-label', 'Selected: ' + value);
        if (step === '2') pickerState.colorSummaryShown = true;
        if (step === '4') pickerState.pocketSummaryShown = true;
      } else {
        summary.removeAttribute('data-summary-value');
        summary.removeAttribute('aria-label');
      }
      summary.classList.toggle('tw:hidden', !shouldShowStepSummary(step, !!value));
    }

    function setStepSummaryContent(step, value, content) {
      var summary = root.querySelector('[data-step-summary="' + step + '"]');
      if (!summary) return;
      var summaryValue = String(value || '').trim();
      summary.innerHTML = '';
      if (summaryValue && content) {
        summary.appendChild(content);
        summary.setAttribute('data-summary-value', summaryValue);
        summary.setAttribute('aria-label', 'Selected: ' + summaryValue);
        if (step === '2') pickerState.colorSummaryShown = true;
        if (step === '3') pickerState.lidSummaryShown = true;
        if (step === '4') pickerState.pocketSummaryShown = true;
      } else {
        summary.removeAttribute('data-summary-value');
        summary.removeAttribute('aria-label');
      }
      summary.classList.toggle('tw:hidden', !shouldShowStepSummary(step, !!summaryValue));
    }

    function getSummaryBackgroundSrc(color) {
      return getCaseSrc(color);
    }

    function getCaseSrc(color, side) {
      if (!color) return '';
      var caseImage = getCaseImageSrc(color, side);
      if (caseImage) return caseImage;
      if (color.swatch_image) return color.swatch_image;
      var key = getCaseColorKey(color);
      var entry = getColorData(key) || getFirstColorData(key) || getSecondColorData(key);
      return entry && entry.swatch_image || '';
    }

    function applySummaryBackground(el, color) {
      var src = getSummaryBackgroundSrc(color);
      if (!src) return;
      var safeSrc = encodeURI(String(src)).replace(/"/g, '%22');
      el.style.backgroundImage = 'url("' + safeSrc + '")';
      el.style.backgroundSize = 'cover';
      el.style.backgroundPosition = 'center';
      el.style.color = '#fff';
    }

    function createColorPreview(color, label) {
      if (isTwoSideComponentFlow()) {
        var componentFrame = createTwoSideComponentPreviewFrame({
          context: 'colorHeader',
          ariaLabel: label || 'Selected two-side case color preview'
        });
        if (componentFrame) return componentFrame;
        var emptyComponentSwatch = document.createElement('span');
        emptyComponentSwatch.className = 'tw:inline-flex tw:flex-shrink-0 tw:items-center tw:justify-center';
        emptyComponentSwatch.setAttribute('role', 'img');
        emptyComponentSwatch.setAttribute('aria-label', label || 'Selected two-side case color preview');
        return emptyComponentSwatch;
      }
      var size = getCaseSize(color && color.variant);
      var width = (size && size.color) || '64px';
      var swatch = document.createElement('span');
      swatch.className = 'tw:inline-flex tw:flex-shrink-0 tw:items-center tw:justify-center';
      swatch.setAttribute('role', 'img');
      swatch.setAttribute('aria-label', label || 'Selected color');
      var src = getCaseSrc(color);
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        img.className = 'tw:block tw:h-auto tw:object-contain';
        img.style.width = width;
        img.style.height = 'auto';
        swatch.appendChild(img);
      }
      return swatch;
    }

    function createColorItem(label, color) {
      var name = getColorDisplayName(color);
      var item = document.createElement('span');
      item.setAttribute('data-combined-summary-row', '');
      item.className = 'tw:flex tw:w-full tw:min-w-0 tw:items-start tw:sm:items-center';
      item.appendChild(createColorPreview(color, label ? label + ' color ' + name : name));
      return item;
    }

    function renderColorBodyPreview() {
      if (!colorBodyPreviewEl) return;
      colorBodyPreviewEl.innerHTML = '';

      if (!isTwoCaseFamily()) {
        colorBodyPreviewEl.classList.add('tw:hidden');
        colorBodyPreviewEl.setAttribute('aria-hidden', 'true');
        return;
      }

      var first = getFirstColorData(pickerState.firstColor);
      var second = getSecondColorData(pickerState.secondColor);
      var labels = getTwoCaseSummaryLabels();
      var label = [
        first ? labels[0] + ' color ' + getColorDisplayName(first) : '',
        second ? labels[1] + ' color ' + getColorDisplayName(second) : ''
      ].filter(Boolean).join(', ') || 'Selected case color preview';
      if (isTwoSideComponentFlow()) {
        var componentFrame = createTwoSideComponentPreviewFrame({
          context: 'colorBody',
          ariaLabel: label
        });
        if (componentFrame) {
          colorBodyPreviewEl.classList.remove('tw:hidden');
          colorBodyPreviewEl.removeAttribute('aria-hidden');
          colorBodyPreviewEl.setAttribute('role', 'img');
          colorBodyPreviewEl.setAttribute('aria-label', label);
          colorBodyPreviewEl.appendChild(componentFrame);
          return;
        }
        colorBodyPreviewEl.classList.remove('tw:hidden');
        colorBodyPreviewEl.removeAttribute('aria-hidden');
        colorBodyPreviewEl.setAttribute('role', 'img');
        colorBodyPreviewEl.setAttribute('aria-label', label);
        return;
      }
      var variant = pickerState.selectedVariant || (second && second.variant) || (first && first.variant) || null;
      var color = variant ? { variant: variant } : null;
      var src = getCaseSrc(color);
      if (!src) {
        colorBodyPreviewEl.classList.add('tw:hidden');
        colorBodyPreviewEl.setAttribute('aria-hidden', 'true');
        return;
      }

      var size = getCaseSize(variant);
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'tw:block tw:h-auto tw:max-w-full tw:object-contain tw:md:scale-125';
      img.style.width = (size && size.color) || '96px';
      img.style.height = 'auto';
      img.style.transform = 'rotate(90deg)';
      img.style.transformOrigin = 'center center';
      colorBodyPreviewEl.classList.remove('tw:hidden');
      colorBodyPreviewEl.removeAttribute('aria-hidden');
      colorBodyPreviewEl.setAttribute('role', 'img');
      colorBodyPreviewEl.setAttribute('aria-label', label);
      colorBodyPreviewEl.appendChild(img);
    }

    function createSummaryPill(text, color, ariaLabel) {
      var labelText = text && typeof text === 'object'
        ? {
          primary: String(text.primary || '').trim(),
          secondary: String(text.secondary || '').trim().toUpperCase()
        }
        : {
          primary: String(text || '').trim(),
          secondary: ''
        };
      var hasSecondaryText = !!labelText.secondary;
      var pill = document.createElement('span');
      pill.setAttribute('data-combined-summary-pill', '');
      pill.className = hasSecondaryText
        ? 'tw:inline-flex tw:min-h-8 tw:w-full tw:min-w-[45px] tw:max-w-full tw:shrink tw:flex-col tw:items-center tw:justify-center tw:overflow-hidden tw:rounded-md tw:border tw:border-gray-300 tw:bg-white tw:px-1.5 tw:py-1 tw:text-center tw:text-[11px] tw:font-semibold tw:leading-none tw:text-gray-900 tw:sm:w-auto tw:sm:max-w-28 tw:sm:shrink-0 tw:sm:px-2'
        : 'tw:inline-flex tw:min-h-6 tw:w-full tw:min-w-[45px] tw:max-w-full tw:shrink tw:items-center tw:justify-center tw:truncate tw:rounded-md tw:border tw:border-gray-300 tw:bg-white tw:px-1.5 tw:py-1 tw:text-[11px] tw:font-semibold tw:leading-none tw:text-gray-900 tw:sm:w-auto tw:sm:max-w-28 tw:sm:shrink-0 tw:sm:px-2';
      if (ariaLabel) pill.setAttribute('aria-label', ariaLabel);
      applySummaryBackground(pill, color);
      if (hasSecondaryText) {
        var primaryLine = document.createElement('span');
        var secondaryLine = document.createElement('span');
        primaryLine.className = 'tw:block tw:max-w-full tw:truncate';
        secondaryLine.className = 'tw:block tw:max-w-full tw:truncate';
        secondaryLine.style.fontSize = '6px';
        secondaryLine.style.lineHeight = '1';
        if (labelText.primary) {
          primaryLine.textContent = labelText.primary;
        } else {
          primaryLine.innerHTML = '&nbsp;';
        }
        secondaryLine.textContent = labelText.secondary;
        pill.appendChild(primaryLine);
        pill.appendChild(secondaryLine);
      } else if (labelText.primary) {
        pill.textContent = labelText.primary;
      } else {
        pill.innerHTML = '&nbsp;';
      }
      return pill;
    }

    function createSummaryPillRow(label, values, color) {
      var row = document.createElement('span');
      row.setAttribute('data-combined-summary-row', '');
      row.className = 'tw:flex tw:w-full tw:min-w-0 tw:items-start tw:gap-1.5 tw:sm:items-center';
      var pills = document.createElement('span');
      pills.setAttribute('data-combined-summary-pills', '');
      pills.className = 'tw:grid tw:w-full tw:min-w-0 tw:grid-cols-[repeat(auto-fit,minmax(2.15rem,1fr))] tw:gap-1 tw:sm:flex tw:sm:flex-wrap tw:sm:items-center';
      values.forEach(function (value) {
        pills.appendChild(createSummaryPill(value, color));
      });
      row.appendChild(pills);
      return row;
    }

    function getCaseColorKey(color) {
      if (color) {
        if (color.key) return toLookupKey(color.key);
        if (color.name) return toLookupKey(color.name);
        if (color.variant && color.variant.option2) return toLookupKey(color.variant.option2);
      }
      return toLookupKey(pickerState.firstColor);
    }

    function getLidSrc(color) {
      return getCaseSrc(color || { variant: pickerState.selectedVariant });
    }

    function getLidPreviewContextKey(context) {
      if (context === 'gallery' && isNarrowPreview()) return 'galleryMobile';
      if (context === 'thumb' && isNarrowPreview()) return 'thumbMobile';
      return context || 'header';
    }

    function getLidPreviewConfig(variant) {
      return LID_PREVIEW_CONFIG[getCaseKey(variant)] || {};
    }

    function getLidPreviewContextValue(values, context, fallback) {
      values = values || {};
      var contextKey = getLidPreviewContextKey(context);
      if (Object.prototype.hasOwnProperty.call(values, contextKey)) return values[contextKey];
      if (Object.prototype.hasOwnProperty.call(values, context)) return values[context];
      return fallback;
    }

    // Gallery v2: the preview thumbnail is a true miniature of the main preview, so the
    // case keeps the same share of the frame as in the big image (fixed px sizes overflow
    // the smaller v2 thumbnails).
    function getGalleryV2ThumbWidth(mainWidth) {
      var stageWidth = galleryStage ? galleryStage.clientWidth : 0;
      var thumbWidth = mainThumb ? mainThumb.clientWidth : 0;
      var mainPx = parseFloat(mainWidth);
      if (!stageWidth || !thumbWidth || !isFinite(mainPx)) return null;
      return Math.max(8, Math.round(mainPx / stageWidth * thumbWidth)) + 'px';
    }

    function getLidPreviewImageWidth(variant, context) {
      var size = getCaseSize(variant);
      var contextKey = getLidPreviewContextKey(context);
      if (!size) return context === 'thumb' ? '48px' : '150px';
      if (contextKey === 'galleryMobile') return size.main_mb || size.main || '150px';
      if (context === 'gallery') return size.main || '150px';
      if (context === 'thumb' && galleryV2) {
        var v2Thumb = getGalleryV2ThumbWidth(isNarrowPreview() ? (size.main_mb || size.main) : size.main);
        if (v2Thumb) return v2Thumb;
      }
      if (context === 'thumb') return size.thumb || '48px';
      if (context === 'body') return size.lidBody || size.lid || '150px';
      return size.lid || '150px';
    }

    function getLidPreviewFrameWidth(variant, config, context, imageWidth) {
      var size = getCaseSize(variant);
      if (!size || config.orientation !== 'vertical') return imageWidth;
      if (context === 'body') return size.lidBodyFrame || size.lidFrame || imageWidth;
      if (context === 'header') return size.lidFrame || imageWidth;
      return imageWidth;
    }

    function getLidPreviewFontSize(config, context) {
      return getLidPreviewContextValue(config.fontSize, context, context === 'thumb' ? 8 : 16);
    }

    function getLidPreviewScale(config, context, options) {
      if (options && Object.prototype.hasOwnProperty.call(options, 'imgScale')) return options.imgScale;
      return getLidPreviewContextValue(config.scale, context, 1);
    }

    function getLidPreviewLayoutKey() {
      if (pickerState.family === 'ampm') return 'ampm';
      if (pickerState.family === 'two_week') return 'two_week';
      return 'single';
    }

    function getLidPreviewSlots(config) {
      var layoutKey = getLidPreviewLayoutKey();
      var slots = config.slots && config.slots[layoutKey];
      if (slots && slots.length) return slots;
      if (layoutKey !== 'single') return DEFAULT_LID_PREVIEW_SLOTS[layoutKey];
      return config.orientation === 'vertical'
        ? DEFAULT_LID_PREVIEW_SLOTS.singleVertical
        : DEFAULT_LID_PREVIEW_SLOTS.single;
    }

    function getLidPreviewPercent(value) {
      if (typeof value === 'number') return value + '%';
      if (value !== undefined && value !== null && value !== '') return String(value);
      return '';
    }

    function getLidSlotValue(slot, key, context) {
      var value = slot && slot[key];
      if (value && typeof value === 'object') {
        var contextKey = getLidPreviewContextKey(context);
        if (Object.prototype.hasOwnProperty.call(value, contextKey)) return value[contextKey];
        if (Object.prototype.hasOwnProperty.call(value, context)) return value[context];
        if (Object.prototype.hasOwnProperty.call(value, 'default')) return value.default;
        return '';
      }
      return value;
    }

    function getEngravingPreviewTextColor(colorName) {
      var key = toLookupKey(colorName);
      return key === 'aluminum' || key === 'titanium' || key === 'stainless' || key === 'stainless-steel'
        ? '#a3a3a3'
        : '';
    }

    function getLidPreviewColorName(color, variant, slotIndex) {
      if (variant) {
        if (slotIndex > 0 && variant.option3) return variant.option3;
        if (variant.option2) return variant.option2;
      }
      if (color) return color.name || color.label || color.key || '';
      return '';
    }

    function getTwoSideLidPreviewColorName(preview, slotIndex) {
      var side;
      if (pickerState.family === 'two_week') {
        side = slotIndex === 0 ? preview.right : preview.left;
      } else {
        side = slotIndex === 0 ? preview.left : preview.right;
      }
      return getLidPreviewColorName(null, side && side.variant, 0)
        || getLidPreviewColorName(null, preview && preview.fallbackVariant, slotIndex);
    }

    function getLidPreviewLabelStyle(colorName, context, stroke) {
      var previewTextColor = getEngravingPreviewTextColor(colorName);
      if (context === 'thumb') {
        return { color: previewTextColor, textStroke: '' };
      }
      if (previewTextColor) {
        return { color: 'transparent', textStroke: '1px ' + previewTextColor };
      }
      if (stroke) {
        return { color: 'transparent', textStroke: '1px #d3d3d3' };
      }
      return { color: '', textStroke: '' };
    }

    function createLidPreviewLabel(text, slot, options) {
      options = options || {};
      var label = document.createElement('span');
      var style = getLidPreviewLabelStyle(options.colorName, options.context, options.stroke);
      label.setAttribute('aria-hidden', 'true');
      label.className = 'tw:absolute tw:flex tw:items-center tw:justify-center tw:truncate tw:text-center tw:leading-none tw:text-neutral-200';
      label.style.left = getLidPreviewPercent(getLidSlotValue(slot, 'x', options.context));
      label.style.top = getLidPreviewPercent(getLidSlotValue(slot, 'y', options.context));
      label.style.width = getLidPreviewPercent(getLidSlotValue(slot, 'w', options.context));
      label.style.height = getLidPreviewPercent(getLidSlotValue(slot, 'h', options.context));
      label.style.transform = 'translate(-50%, -50%)' + (options.offsetX ? ' translateX(' + options.offsetX + ')' : '');
      label.style.fontSize = (options.fontSize || 14) + 'px';
      label.style.whiteSpace = 'nowrap';
      label.style.overflow = 'hidden';
      label.style.textOverflow = 'ellipsis';
      if (style.color) label.style.color = style.color;
      if (style.textStroke) label.style.setProperty('-webkit-text-stroke', style.textStroke);
      label.textContent = text || '';
      return label;
    }

    function createLidPreviewFrame(options) {
      options = options || {};
      if (isTwoSideComponentFlow()) {
        var componentPreview = options.componentPreview || getTwoSideComponentPreview();
        if (!componentPreview) return null;
        options.componentPreview = componentPreview;
        return createTwoSideComponentPreviewFrame(options);
      }
      var context = options.context || 'header';
      var color = options.color || null;
      var variant = options.variant || (color && color.variant) || pickerState.selectedVariant || null;
      var caseKey = getCaseKey(variant);
      var config = getLidPreviewConfig(variant);
      var imageWidth = options.imageWidth || getLidPreviewImageWidth(variant, context);
      var frameWidth = getLidPreviewFrameWidth(variant, config, context, imageWidth);
      var labels = Array.isArray(options.labels) ? options.labels : [];
      var src = Object.prototype.hasOwnProperty.call(options, 'imageSrc') ? options.imageSrc : getLidSrc(color || { variant: variant });
      var frame = document.createElement('span');
      var scale = getLidPreviewScale(config, context, options);
      var imageTransforms = [];
      var galleryCaseOffsetX = '';
      if (context === 'gallery') {
        if (caseKey === 'nano' || caseKey.indexOf('nano-') === 0) galleryCaseOffsetX = '-25px';
        if (caseKey === 'mission' || caseKey.indexOf('mission-') === 0) galleryCaseOffsetX = '20px';
      }

      if (!src && (context === 'gallery' || context === 'thumb')) return null;

      frame.setAttribute('data-lid-preview-frame', '');
      frame.setAttribute('role', 'img');
      frame.setAttribute('aria-label', options.ariaLabel || 'Lid engraving preview');
      frame.className = 'tw:relative tw:inline-flex tw:flex-shrink-0 tw:items-center tw:justify-center';
      frame.style.width = frameWidth;
      frame.style.overflow = 'visible';
      if (config.orientation === 'vertical') frame.style.height = imageWidth;

      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = context === 'gallery' ? 'eager' : 'lazy';
        var imageClasses = 'tw:block tw:h-auto tw:object-contain';
        if (context === 'gallery' && !isTwoCaseFamily()) {
          var roundedClass = (caseKey === 'nano' || caseKey.indexOf('nano-') === 0) ? 'tw:rounded-[10px] tw:md:rounded-2xl' : 'tw:rounded-xl';
          imageClasses += ' tw:shadow-[5px_5px_15px_rgba(0,0,0,0.8)] ' + roundedClass;
        }
        img.className = imageClasses;
        img.style.width = imageWidth;
        img.style.height = 'auto';
        img.style.maxWidth = 'none';
        if (galleryCaseOffsetX) imageTransforms.push('translateX(' + galleryCaseOffsetX + ')');
        if (config.orientation === 'vertical') imageTransforms.push('rotate(90deg)');
        if (scale && scale !== 1) imageTransforms.push('scale(' + scale + ')');
        if (imageTransforms.length) {
          img.style.transform = imageTransforms.join(' ');
          img.style.transformOrigin = 'center center';
        }
        frame.appendChild(img);
      }

      // Gallery v2 thumbnails keep the case artwork without unreadable engraving text.
      if (options.hideLabels) return frame;

      var slots = getLidPreviewSlots(config);
      var fontSize = getLidPreviewFontSize(config, context);
      var useStroke = !!config.stroke && context !== 'thumb';
      slots.forEach(function (slot) {
        frame.appendChild(createLidPreviewLabel(labels[slot.slot], slot, {
          context: context,
          fontSize: fontSize,
          offsetX: galleryCaseOffsetX,
          stroke: useStroke,
          colorName: getLidPreviewColorName(color, variant, slot.slot)
        }));
      });

      return frame;
    }

    function renderLidPreviewMount(mount, options) {
      if (!mount) return;
      mount.innerHTML = '';
      var frame = createLidPreviewFrame(options);
      if (!frame) {
        mount.classList.add('tw:hidden');
        mount.setAttribute('aria-hidden', 'true');
        return;
      }

      mount.classList.remove('tw:hidden');
      mount.removeAttribute('aria-hidden');
      if (options && options.absolute) {
        mount.style.position = 'absolute';
        mount.style.top = '50%';
        mount.style.left = '50%';
        mount.style.right = 'auto';
        mount.style.bottom = 'auto';
        mount.style.transform = 'translate(-50%, -50%)';
        mount.style.pointerEvents = 'none';
        mount.style.zIndex = '10';
        mount.style.display = 'flex';
        mount.style.alignItems = 'center';
        mount.style.justifyContent = 'center';
      }
      mount.appendChild(frame);
    }

    function setLidPreviewRowVisible(visible) {
      if (!lidPreviewRowEl) return;
      lidPreviewRowEl.classList.toggle('tw:hidden', !visible);
      if (visible) {
        lidPreviewRowEl.removeAttribute('aria-hidden');
      } else {
        lidPreviewRowEl.setAttribute('aria-hidden', 'true');
      }
    }

    function renderLidBodyPreview() {
      if (!lidBodyPreviewEl) return;
      lidBodyPreviewEl.innerHTML = '';

      var count = getLidInputCount();
      var labels = normalizeLidLabels(
        (pickerState.lidEngraving && pickerState.lidEngraving.labels) || [],
        count,
        getLidMaxLength()
      );
      if (!pickerState.lidEngraving || pickerState.lidEngraving.mode !== 'CUSTOM') {
        labels = normalizeLidLabels([], count, getLidMaxLength());
      }

      var colors = getSelectedColorEntriesForSummary();
      if (isTwoCaseFamily()) {
        var color = { variant: pickerState.selectedVariant || (colors[1] && colors[1].variant) || (colors[0] && colors[0].variant) };
        var componentFrame = createLidPreviewFrame({
          context: 'body',
          labels: labels,
          color: color,
          ariaLabel: getLidInputLabels().join(', ') + ' lid engraving preview'
        });
        if (componentFrame) lidBodyPreviewEl.appendChild(componentFrame);
        return;
      }

      var frame = createLidPreviewFrame({
        context: 'body',
        labels: labels,
        color: colors[0] || { variant: pickerState.selectedVariant },
        ariaLabel: 'Lid engraving preview'
      });
      if (frame) lidBodyPreviewEl.appendChild(frame);
    }

    function getPocketBodyPreviewLabels() {
      var pocket = pickerState.pocketEngraving || {};
      var kind = getPocketKind();
      var mode = getPocketMode(kind);
      var value = String(pocket.value || '').trim();

      if (pocket.mode !== mode || !value) return [];
      if (mode === 'DOTW') {
        return buildDotwSummaryValues(value, getPocketSummarySlotCount(kind));
      }
      if (kind === 'mission') {
        return value.split('-').map(function (part) {
          return String(part || '').trim();
        }).filter(Boolean);
      }
      return [value];
    }

    function getPocketImageKind(kind) {
      if (kind === 'mission') return 'mission';
      if (kind === 'nano') return 'nano';
      return 'weekly';
    }

    function getPocketBodyPreviewSrc(color, kind) {
      var imageKind = getPocketImageKind(kind);
      var colorKey = getCaseColorKey(color);
      var row = colorKey ? pocketImagesByColor[colorKey] : null;
      return (row && row[imageKind]) ? row[imageKind] : pocketBodyPreviewSrc;
    }

    function getPocketBodyPreviewWidth(kind) {
      kind = kind || getPocketKind();
      return POCKET_BODY_PREVIEW_WIDTHS[kind] || POCKET_BODY_PREVIEW_WIDTHS.nano;
    }

    function getPocketBodyPreviewAreas(count, kind) {
      kind = kind || getPocketKind();
      if (kind === 'nano' || count <= 1) return [{ top: '35%', left: '50%', width: '48px' }];
      if (kind === 'mission') return [
        { top: '18%', left: '50%', width: '52px' },
        { top: '50%', left: '50%', width: '52px' },
        { top: '80%', left: '50%', width: '52px' }
      ];
      if (kind === 'weekly') {
        return [6.5, 18.5, 31, 44, 56.5, 69, 81.5].map(function (top) {
          return { top: top + '%', left: '50%', width: '34px' };
        });
      }
      if (kind === 'ampm' || kind === 'two_week') {
        var columns = [6.5, 19, 32, 44, 57, 69.5, 81.5];
        var rows = ['26%', '76%'];
        var areas = [];
        rows.forEach(function (left) {
          columns.forEach(function (top) {
            areas.push({ top: top + '%', left: left, width: kind === 'ampm' ? '48px' : '34px' });
          });
        });
        return areas;
      }

      var areas = [];
      var step = 100 / (count + 1);
      for (var i = 0; i < count; i++) {
        areas.push({ top: Math.round(step * (i + 1)) + '%', left: '50%', width: '40px' });
      }
      return areas;
    }

    function getPocketBodyPreviewLabelText(label) {
      if (label && typeof label === 'object') {
        return [
          label.primary,
          label.secondary
        ].map(function (part) {
          return String(part || '').trim();
        }).filter(Boolean).join(' ');
      }
      return String(label || '').trim();
    }

    function createPocketBodyPreviewLabel(text, area, count, kind, textColor) {
      var labelText = text && typeof text === 'object'
        ? {
          primary: String(text.primary || '').trim().toUpperCase(),
          secondary: String(text.secondary || '').trim().toUpperCase()
        }
        : {
          primary: String(text || '').trim().toUpperCase(),
          secondary: ''
        };
      var displayText = labelText.primary;
      var secondaryText = labelText.secondary;
      var hasSecondaryText = !!secondaryText;
      var verticalNanoText = !hasSecondaryText && kind === 'nano' && displayText.length > 3;
      var fontSize = verticalNanoText ? 16 : 12;
      var label = document.createElement('span');
      label.setAttribute('aria-hidden', 'true');
      label.className = hasSecondaryText
        ? 'tw:absolute tw:flex tw:flex-col tw:items-center tw:justify-center tw:text-center tw:leading-none tw:text-neutral-200'
        : 'tw:absolute tw:flex tw:items-center tw:justify-center tw:truncate tw:text-center tw:leading-none tw:text-neutral-200';
      label.style.left = (area && area.left) || '50%';
      label.style.top = (area && area.top) || '50%';
      label.style.transform = verticalNanoText ? 'translate(-50%, 10%) rotate(90deg)' : 'translate(-50%, -50%)';
      label.style.width = verticalNanoText ? '64px' : ((area && area.width) || (count > 3 ? '34px' : '48px'));
      label.style.maxWidth = label.style.width;
      label.style.whiteSpace = 'nowrap';
      label.style.fontSize = fontSize + 'px';
      if (textColor) label.style.color = textColor;

      if (hasSecondaryText) {
        var primaryLine = document.createElement('span');
        var secondaryLine = document.createElement('span');
        label.style.gap = '1px';
        label.style.overflow = 'visible';
        primaryLine.style.display = 'block';
        primaryLine.style.fontSize = fontSize + 'px';
        primaryLine.style.lineHeight = '1';
        primaryLine.textContent = displayText;
        secondaryLine.style.display = 'block';
        secondaryLine.style.fontSize = Math.max(6, Math.round(fontSize / 2)) + 'px';
        secondaryLine.style.lineHeight = '1';
        secondaryLine.textContent = secondaryText;
        label.appendChild(primaryLine);
        label.appendChild(secondaryLine);
        return label;
      }

      label.textContent = displayText;
      return label;
    }

    function createPocketBodyPreviewFrame(labels, color, kind, ariaLabel) {
      var frame = document.createElement('span');
      frame.setAttribute('data-pocket-body-preview-frame', '');
      frame.setAttribute('role', 'img');
      var ariaLabels = labels.map(getPocketBodyPreviewLabelText).filter(Boolean);
      frame.setAttribute('aria-label', ariaLabel || (ariaLabels.length ? 'Pocket engraving preview: ' + ariaLabels.join(', ') : 'Pocket engraving preview'));
      frame.className = 'tw:relative tw:inline-flex tw:flex-shrink-0 tw:items-center tw:justify-center tw:overflow-hidden tw:rounded-sm tw:bg-white';
      frame.style.width = getPocketBodyPreviewWidth(kind);
      frame.style.maxWidth = '100%';

      var src = getPocketBodyPreviewSrc(color, kind);
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        img.className = 'tw:block tw:h-auto tw:w-full tw:object-contain';
        frame.appendChild(img);
      } else {
        frame.style.aspectRatio = '1 / 1';
      }

      var areas = getPocketBodyPreviewAreas(labels.length, kind);
      var previewTextColor = getEngravingPreviewTextColor(getCaseColorKey(color));
      labels.forEach(function (label, index) {
        frame.appendChild(createPocketBodyPreviewLabel(label, areas[index], labels.length, kind, previewTextColor));
      });

      return frame;
    }

    function renderPocketBodyPreview() {
      if (!pocketBodyPreviewEl) return;
      pocketBodyPreviewEl.innerHTML = '';

      var labels = getPocketBodyPreviewLabels();
      var kind = getPocketKind();
      var colors = getSelectedColorEntriesForSummary();

      if (isTwoCaseFamily()) {
        var splitLabels = labels.length ? labels.slice(0, getPocketSummarySlotCount(kind)) : [];
        var rowLabels = getTwoCasePocketPreviewLabels();
        var pocketFrames = [
          {
            color: colors[0],
            label: rowLabels[0] || 'First case'
          },
          {
            color: colors[1] || colors[0],
            label: rowLabels[1] || 'Second case'
          }
        ];
        if (pickerState.family === 'two_week') {
          pocketFrames.reverse();
        }
        var wrap = document.createElement('span');
        wrap.className = 'tw:inline-flex tw:max-w-full tw:flex-shrink-0 tw:items-center tw:justify-center';
        pocketFrames.forEach(function (frame) {
          var frameLabels = splitLabels.map(function (label) {
            return {
              primary: label,
              secondary: frame.label
            };
          });
          wrap.appendChild(createPocketBodyPreviewFrame(
            frameLabels,
            frame.color,
            'weekly',
            frame.label + (splitLabels.length ? ' pocket engraving preview: ' + splitLabels.join(', ') : ' pocket engraving preview')
          ));
        });
        pocketBodyPreviewEl.appendChild(wrap);
        return;
      }

      pocketBodyPreviewEl.appendChild(createPocketBodyPreviewFrame(
        labels,
        colors[0] || { variant: pickerState.selectedVariant },
        kind,
        labels.length ? 'Pocket engraving preview: ' + labels.join(', ') : 'Pocket engraving preview'
      ));
    }

    function refreshRenderedPocketBodyPreview() {
      if (pocketBodyPreviewEl && pocketBodyPreviewEl.childNodes.length) renderPocketBodyPreview();
    }

    function getTwoCaseSummaryLabels() {
      if (pickerState.family === 'ampm') return ['AM', 'PM'];
      if (pickerState.family === 'two_week') {
        return isTwoSideComponentFlow() ? getTwoWeekV3CaseLabels() : ['Week 1', 'Week 2'];
      }
      return ['', ''];
    }

    function getTwoCasePocketPreviewLabels() {
      if (pickerState.family === 'ampm') return ['AM', 'PM'];
      if (pickerState.family === 'two_week') return ['Week 1', 'Week 2'];
      return ['', ''];
    }

    function getTwoCaseColorInputLabels() {
      if (pickerState.family === 'ampm') return [
        'AM / LEFT & BOTTOM SIDE COLOR',
        'PM / RIGHT & TOP SIDE COLOR'
      ];
      if (pickerState.family === 'two_week') {
        if (isTwoSideComponentFlow()) {
          return getTwoWeekV3CaseLabels().map(function (label) {
            return label + ' Color';
          });
        }
        return [
          'WEEK 1 / RIGHT & TOP SIDE COLOR',
          'WEEK 2 / LEFT & BOTTOM SIDE COLOR'
        ];
      }
      return ['First color', 'Second color'];
    }

    function getSelectedColorEntriesForSummary() {
      if (isTwoCaseFamily()) {
        var first = getFirstColorData(pickerState.firstColor);
        var second = getSecondColorData(pickerState.secondColor);
        return [
          first || second || null,
          second || first || null
        ];
      }
      var color = getColorData(pickerState.firstColor);
      return color ? [color] : [];
    }

    function renderColorStepSummary() {
      if (isTwoCaseFamily()) {
        var first = getFirstColorData(pickerState.firstColor);
        var second = getSecondColorData(pickerState.secondColor);
        if (!first || !second) {
          setStepSummary('2', '');
          return;
        }
        var labels = getTwoCaseSummaryLabels();
        var wrap = document.createElement('span');
        wrap.setAttribute('data-combined-summary-wrap', '');
        wrap.className = 'tw:flex tw:w-full tw:min-w-0 tw:items-center';
        wrap.appendChild(createColorPreview(
          { variant: pickerState.selectedVariant || second.variant },
          labels[0] + ' color ' + getColorDisplayName(first) + ', ' + labels[1] + ' color ' + getColorDisplayName(second)
        ));
        setStepSummaryContent('2', getColorSummary(), wrap);
        return;
      }

      var color = getColorData(pickerState.firstColor);
      if (!color) {
        setStepSummary('2', '');
        return;
      }
      var colorName = getColorDisplayName(color);
      var singleWrap = document.createElement('span');
      singleWrap.setAttribute('data-combined-summary-wrap', '');
      singleWrap.className = 'tw:flex tw:w-full tw:min-w-0 tw:items-center';
      singleWrap.appendChild(createColorItem('', color));
      setStepSummaryContent('2', colorName, singleWrap);
    }

    function renderLidStepSummary() {
      if (!pickerState.touchedSteps['3'] && !pickerState.lidSummaryShown) {
        setStepSummary('3', '');
        return;
      }

      var mode = pickerState.lidEngraving && pickerState.lidEngraving.mode;
      var inputCount = getLidInputCount();
      var labels = normalizeLidLabels((pickerState.lidEngraving && pickerState.lidEngraving.labels) || [], inputCount, getLidMaxLength());
      if (mode === 'NONE') {
        labels = normalizeLidLabels([], inputCount, getLidMaxLength());
      }

      var colors = getSelectedColorEntriesForSummary();
      var sideLabels = getLidInputLabels();
      var wrap = document.createElement('span');
      wrap.setAttribute('data-combined-summary-wrap', '');
      wrap.className = 'tw:flex tw:w-full tw:min-w-0 tw:flex-wrap tw:items-center tw:gap-1.5';
      if (isTwoCaseFamily()) {
        var color = { variant: pickerState.selectedVariant || (colors[1] && colors[1].variant) || (colors[0] && colors[0].variant) };
        var componentFrame = createLidPreviewFrame({
          context: 'header',
          labels: labels,
          color: color,
          ariaLabel: sideLabels.join(', ') + ' lid engraving preview'
        });
        if (componentFrame) wrap.appendChild(componentFrame);
        var splitSummaryText = labels.filter(function (label) {
          return String(label || '').trim();
        }).join('|') || 'No lid engraving';
        if (!componentFrame) wrap.textContent = splitSummaryText;
        setStepSummaryContent('3', splitSummaryText, wrap);
        return;
      }
      labels.forEach(function (label, index) {
        var side = sideLabels[index] || ('Lid ' + (index + 1));
        var frame = createLidPreviewFrame({
          context: 'header',
          labels: [label],
          color: colors[index] || colors[0],
          ariaLabel: side + ' lid engraving ' + (label || 'no text')
        });
        if (frame) wrap.appendChild(frame);
      });
      var summaryText = labels.filter(function (label) {
        return String(label || '').trim();
      }).join('|') || 'No lid engraving';
      setStepSummaryContent('3', summaryText, wrap);
    }

    function getPocketSummarySlotCount(kind) {
      if (kind === 'nano') return 1;
      if (kind === 'mission') return 3;
      return 7;
    }

    function formatDotwShort(value) {
      var normalized = String(value || '').trim().toLowerCase();
      for (var i = 0; i < DOTW_DAYS.length; i++) {
        if (DOTW_DAYS[i].toLowerCase() === normalized || DOTW_DAYS[i].slice(0, 3).toLowerCase() === normalized) {
          return DOTW_DAYS[i].slice(0, 3).toUpperCase();
        }
      }
      return String(value || '').trim().slice(0, 3).toUpperCase();
    }

    function buildDotwSummaryValues(startValue, count) {
      var start = 0;
      var normalized = String(startValue || '').trim().toLowerCase();
      for (var i = 0; i < DOTW_DAYS.length; i++) {
        if (DOTW_DAYS[i].toLowerCase() === normalized || DOTW_DAYS[i].slice(0, 3).toLowerCase() === normalized) {
          start = i;
          break;
        }
      }
      var values = [];
      for (var j = 0; j < count; j++) {
        values.push(formatDotwShort(DOTW_DAYS[(start + j) % DOTW_DAYS.length]));
      }
      return values;
    }

    function createPocketStepSummaryPreview(values) {
      var colors = getSelectedColorEntriesForSummary();
      var wrap = document.createElement('span');
      wrap.setAttribute('data-combined-summary-wrap', '');
      wrap.className = 'tw:flex tw:w-full tw:min-w-0 tw:flex-col tw:gap-1';
      if (isTwoCaseFamily()) {
        var rowLabels = getTwoCasePocketPreviewLabels();
        var hasValues = values.some(function (value) {
          return !!String(value || '').trim();
        });
        var firstValues = values.map(function (value) {
          return { primary: value, secondary: hasValues ? (rowLabels[0] || '') : '' };
        });
        var secondValues = values.map(function (value) {
          return { primary: value, secondary: hasValues ? (rowLabels[1] || '') : '' };
        });
        var summaryRows = [
          { label: rowLabels[0], values: firstValues, color: colors[0] },
          { label: rowLabels[1], values: secondValues, color: colors[1] || colors[0] }
        ];
        if (pickerState.family === 'ampm') {
          summaryRows.reverse();
        }
        summaryRows.forEach(function (row) {
          wrap.appendChild(createSummaryPillRow(row.label, row.values, row.color));
        });
      } else {
        wrap.appendChild(createSummaryPillRow('', values, colors[0]));
      }
      return wrap;
    }

    function getBlankPocketSummaryValues(kind) {
      var values = [];
      for (var i = 0; i < getPocketSummarySlotCount(kind); i++) {
        values.push('');
      }
      return values;
    }

    function renderPocketStepSummary(options) {
      options = options || {};
      var pocket = pickerState.pocketEngraving || {};
      var kind = getPocketKind();
      if (options.blankPreview) {
        setStepSummaryContent('4', 'Pocket engraving preview', createPocketStepSummaryPreview(getBlankPocketSummaryValues(kind)));
        return;
      }

      if (pocket.mode === 'NONE' || !pocket.value) {
        if (isTwoCaseFamily()) {
          setStepSummaryContent('4', 'No pocket engraving', createPocketStepSummaryPreview(getBlankPocketSummaryValues(kind)));
          return;
        }
        setStepSummary('4', 'No engraving');
        return;
      }

      if (pocket.mode !== 'DOTW') {
        setStepSummary('4', pocket.value);
        return;
      }

      var values = buildDotwSummaryValues(pocket.value, getPocketSummarySlotCount(kind));
      setStepSummaryContent('4', pocket.value + ':' + values.join('|'), createPocketStepSummaryPreview(values));
    }



    function createSizeStatusCard(message, tone) {
      var card = document.createElement('div');
      card.className = [
        tone === 'error'
          ? 'tw:flex tw:flex-col tw:gap-3 tw:rounded-lg tw:border tw:border-red-200 tw:bg-red-50 tw:p-4'
          : 'tw:flex tw:items-center tw:gap-3 tw:rounded-lg tw:border tw:border-gray-200 tw:bg-gray-50 tw:p-4 tw:text-sm tw:text-gray-600'
      ].join(' ');

      if (tone === 'error') {
        var row = document.createElement('div');
        row.className = 'tw:flex tw:items-start tw:gap-3';
        var errorIcon = document.createElement('span');
        errorIcon.className = 'tw:mt-0.5 tw:flex tw:h-4 tw:w-4 tw:flex-shrink-0 tw:text-red-700';
        errorIcon.setAttribute('aria-hidden', 'true');
        errorIcon.innerHTML = '<svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1zm0 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path></svg>';
        var errorText = document.createElement('p');
        errorText.className = 'tw:m-0 tw:text-sm tw:text-red-800';
        errorText.textContent = message || 'Could not load sizes.';
        row.appendChild(errorIcon);
        row.appendChild(errorText);
        card.appendChild(row);

        var retry = document.createElement('button');
        retry.type = 'button';
        retry.setAttribute('data-size-retry', 'true');
        retry.className = 'tw:self-start tw:rounded tw:border tw:border-red-300 tw:bg-white tw:px-3 tw:py-1.5 tw:text-xs tw:font-medium tw:text-red-800 tw:transition-colors tw:duration-200 tw:ease-standard tw:hover:bg-red-100';
        retry.textContent = 'Try again';
        card.appendChild(retry);
        return card;
      }

      if (tone === 'loading') {
        var loadingIcon = document.createElement('span');
        loadingIcon.className = 'tw:flex tw:h-4 tw:w-4 tw:animate-spin tw:text-gray-500';
        loadingIcon.setAttribute('aria-hidden', 'true');
        loadingIcon.innerHTML = '<svg viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" stroke-opacity="0.25"></circle><path d="M14 8a6 6 0 0 0-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
        card.appendChild(loadingIcon);
      }

      var text = document.createElement('span');
      text.textContent = message || '';
      card.appendChild(text);
      return card;
    }

    var SIZE_TRIGGER_CLASS = 'tw:flex tw:min-h-14 tw:w-full tw:items-center tw:justify-between tw:gap-2 tw:rounded-md tw:border tw:border-gray-200 tw:bg-white tw:py-1.5 tw:pl-2 tw:pr-4 tw:text-left tw:transition-all tw:duration-fast tw:ease-standard tw:cursor-pointer tw:hover:border-gray-400 tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-black tw:focus-visible:ring-offset-1';
    var SIZE_POPOVER_CLASS = 'tw:m-0 tw:border-0 tw:bg-transparent tw:p-0';



    function getSizePopoverTrigger(popover) {
      if (!popover || !popover.id) return null;
      return root.querySelector('[data-size-trigger][popovertarget="' + popover.id + '"]');
    }

    function placeSizePopover(popover) {
      var trigger = getSizePopoverTrigger(popover);
      if (!trigger) return;
      var rect = trigger.getBoundingClientRect();
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || rect.width;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var pad = 16;
      var width = Math.min(rect.width, Math.max(viewportWidth - pad * 2, 0));
      var left = Math.min(Math.max(rect.left, pad), Math.max(viewportWidth - width - pad, pad));
      popover.style.position = 'fixed';
      popover.style.margin = '0';
      popover.style.left = left + 'px';
      popover.style.right = 'auto';
      popover.style.bottom = 'auto';
      popover.style.width = width + 'px';
      var popupHeight = popover.offsetHeight || 0;
      var spaceBelow = viewportHeight - rect.bottom;
      if (spaceBelow < popupHeight + pad && rect.top > popupHeight + pad) {
        popover.style.top = (rect.top - popupHeight - 4) + 'px';
      } else {
        popover.style.top = (rect.bottom + 4) + 'px';
      }
    }

    function placeOpenSizePopover() {
      if (!openSizePopover) return;
      if (!openSizePopover.isConnected) {
        openSizePopover = null;
        unbindSizePopoverListeners();
        return;
      }
      placeSizePopover(openSizePopover);
    }

    function bindSizePopoverListeners() {
      if (sizePopoverListenersBound) return;
      window.addEventListener('resize', placeOpenSizePopover);
      window.addEventListener('scroll', placeOpenSizePopover, true);
      sizePopoverListenersBound = true;
    }

    function unbindSizePopoverListeners() {
      if (!sizePopoverListenersBound) return;
      window.removeEventListener('resize', placeOpenSizePopover);
      window.removeEventListener('scroll', placeOpenSizePopover, true);
      sizePopoverListenersBound = false;
    }

    function closeSizePopover(popover) {
      var target = popover || openSizePopover;
      if (!target) return;
      var trigger = getSizePopoverTrigger(target);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (typeof target.hidePopover === 'function') {
        try {
          target.hidePopover();
        } catch (e) {}
      }
      if (openSizePopover === target) {
        openSizePopover = null;
        unbindSizePopoverListeners();
      }
    }

    function getEnabledSizeOptions(popover) {
      if (!popover) return [];
      return Array.prototype.slice.call(popover.querySelectorAll('[data-size-option]')).filter(function (option) {
        return !option.disabled;
      });
    }

    function onSizePopoverToggle(event) {
      var trigger = getSizePopoverTrigger(event.target);
      if (event.newState === 'open') {
        openSizePopover = event.target;
        placeSizePopover(event.target);
        bindSizePopoverListeners();
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var selected = event.target.querySelector('[data-selector-option][data-selected="true"]:not([disabled])') || event.target.querySelector('[data-selector-option]:not([disabled])');
        if (selected && typeof selected.focus === 'function') selected.focus();
      } else if (openSizePopover === event.target) {
        openSizePopover = null;
        unbindSizePopoverListeners();
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    }

    function renderCatalogSizeDropdown() {
      var sizeStep = window.theme && window.theme.sizeStep;
      if (!sizeStep) {
        sizeListEl.appendChild(createSizeStatusCard('Could not display case sizes. Please refresh the page.', 'empty'));
        return;
      }
      var presentation = sizeStep.prepare(sizeCatalog.map(function (size) {
        return { key: size.key, name: getSizePresentationName(size), thumbnail: size.thumbnail,
          shape: sizeStep.shapeFor(size.key), counts: size.pill_counts };
      }));
      var selectedIndex = sizeCatalog.findIndex(function (size) { return size.key === pickerState.pendingSize; });
      var selectedSize = sizeCatalog[selectedIndex] || null;
      sizePopoverSeq += 1;
      var popId = root.id + '-sizepop-' + sizePopoverSeq;
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.setAttribute('data-size-trigger', 'true');
      trigger.setAttribute('popovertarget', popId);
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-controls', popId);
      trigger.setAttribute('aria-expanded', 'false');
      trigger.className = SIZE_TRIGGER_CLASS;
      sizeStep.appendTrigger(trigger, presentation.rows[selectedIndex] || null, {
        badge: selectedSize && selectedSize.best_seller && !selectedSize.sold_out ? 'Best seller' : '', tone: 'best'
      });
      var chevron = document.createElement('span');
      chevron.setAttribute('aria-hidden', 'true');
      chevron.className = 'tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:text-gray-500';
      chevron.innerHTML = '<svg class="tw:h-2 tw:w-3" viewBox="0 0 12 7" fill="none"><path d="M11 1L6 6L1 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      trigger.appendChild(chevron);
      sizeListEl.appendChild(trigger);
      var popover = document.createElement('div');
      popover.id = popId;
      popover.setAttribute('popover', '');
      popover.setAttribute('data-size-popover', '');
      popover.className = SIZE_POPOVER_CLASS;
      var body = document.createElement('div');
      body.className = 'tw:flex tw:max-h-72 tw:flex-col tw:overflow-hidden tw:rounded-lg tw:border tw:border-gray-200 tw:bg-white tw:shadow-lg';
      if (presentation.icons) body.appendChild(sizeStep.createPopoverHeader());
      var list = document.createElement('div');
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', 'Case sizes');
      list.className = 'tw:m-0 tw:flex tw:min-h-0 tw:flex-col tw:overflow-y-auto tw:overscroll-contain tw:p-0';
      sizeCatalog.forEach(function (size, index) {
        var selected = selectedSize && size.key === selectedSize.key;
        var soldOut = !!size.sold_out;
        var option = document.createElement('button');
        option.type = 'button';
        option.setAttribute('data-selector-option', 'true');
        option.setAttribute('data-size-option', 'true');
        option.setAttribute('data-size-key', size.key);
        option.setAttribute('data-size-label', size.label);
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
        option.setAttribute('data-selected', selected ? 'true' : 'false');
        option.disabled = soldOut;
        option.className = 'tw:border-0 tw:bg-transparent tw:transition-colors tw:duration-fast tw:ease-standard tw:cursor-pointer tw:hover:bg-gray-50 tw:focus:outline-none tw:focus-visible:bg-gray-50 tw:data-[selected=true]:bg-gray-50 tw:disabled:cursor-not-allowed tw:disabled:opacity-40 tw:disabled:hover:bg-transparent';
        sizeStep.appendOption(option, presentation.rows[index], {
          selected: !!selected, disabled: soldOut,
          badge: soldOut ? 'Sold out' : size.best_seller ? 'Best seller' : '', tone: soldOut ? 'status' : 'best'
        });
        list.appendChild(option);
      });
      body.appendChild(list);
      popover.appendChild(body);
      popover.addEventListener('beforetoggle', function (event) {
        if (event.newState === 'open') placeSizePopover(popover);
      });
      popover.addEventListener('toggle', onSizePopoverToggle);
      sizeListEl.appendChild(popover);
    }

    function renderSizeRows() {
      if (!sizeListEl) return;
      if (openSizePopover && sizeListEl.contains(openSizePopover)) closeSizePopover(openSizePopover);
      if (sizeCapacityBar && sizeCapacityBar.parentNode) sizeCapacityBar.parentNode.removeChild(sizeCapacityBar);
      sizeCapacityBar = null;
      sizeListEl.innerHTML = '';
      if (sizeFetchLoading) {
        sizeListEl.appendChild(createSizeStatusCard('Loading sizes...', 'loading'));
        return;
      }
      if (sizeFetchError) {
        sizeListEl.appendChild(createSizeStatusCard(sizeFetchError, 'error'));
        return;
      }
      if (!sizeCatalog.length) {
        sizeListEl.appendChild(createSizeStatusCard('No sizes are available.', 'empty'));
        return;
      }
      if (catalogMode) {
        sizeListEl.className = 'tw:w-full tw:max-w-full tw:sm:max-w-md';
        renderCatalogSizeDropdown();
        return;
      }
      var sizeStep = window.theme && window.theme.sizeStep;
      if (!sizeStep) {
        sizeListEl.appendChild(createSizeStatusCard('Could not display case sizes. Please refresh the page.', 'empty'));
        return;
      }
      var presentation = sizeStep.prepare(sizeCatalog.map(function (size) {
        return { key: size.key, name: getSizeDisplayName(size), thumbnail: size.thumbnail,
          shape: sizeStep.shapeFor(size.key), counts: size.pill_counts };
      }));
      if (presentation.icons) {
        sizeCapacityBar = sizeStep.createBar();
        sizeListEl.parentNode.insertBefore(sizeCapacityBar, sizeListEl);
      }
      sizeCatalog.forEach(function (size, index) {
        var isSelected = size.key === pickerState.pendingSize;
        var isSoldOut = !!size.sold_out;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-size-key', size.key);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        btn.disabled = isSoldOut;
        btn.className = [
          'tw:border tw:bg-white tw:transition-all tw:duration-200 tw:ease-standard',
          isSelected ? 'tw:border-gray-950 tw:bg-gray-50 tw:ring-1 tw:ring-gray-950' : 'tw:border-gray-300',
          isSoldOut ? 'tw:cursor-not-allowed tw:border-gray-200 tw:bg-gray-50' : 'tw:cursor-pointer tw:hover:border-gray-400 tw:hover:shadow-sm'
        ].join(' ');
        sizeStep.appendRow(btn, presentation.rows[index], {
          selected: isSelected, disabled: isSoldOut,
          badge: isSoldOut ? 'Sold out' : size.best_seller ? 'Best seller' : '', tone: isSoldOut ? 'status-dark' : 'best'
        });
        sizeListEl.appendChild(btn);
      });
    }

    function setPendingSize(key, options) {
      options = options || {};
      var size = getSizeData(key);
      if (!size) return;
      var priorConfirmedSize = pickerState.size;
      var priorFirstColor = pickerState.firstColor;
      var priorSecondColor = pickerState.secondColor;
      pickerState.pendingSize = size.key;
      if (catalogMode) applyCatalogSizeContext(size);
      if (!options.initial) setValidationMessage(sizeValidationEl, '');

      if (!options.initial && pickerState.urlPreselect && pickerState.urlPreselect.sizeKey !== size.key && !priorConfirmedSize) {
        pickerState.firstColor = null;
        pickerState.secondColor = null;
      }

      if (!options.initial && priorConfirmedSize && priorConfirmedSize !== size.key) {
        colorCandidateForSizeChange = priorFirstColor;
        secondColorCandidateForSizeChange = priorSecondColor;
        ignoreUrlColorPreselectOnce = true;
        pickerState.size = null;
        setStepTouched('1', false);
        setStepSummary('1', '');
        resetStepsAfter('1');
      }

      renderSizeRows();
      renderShellState();
      dispatchStateEvent();
      prefetchColorsForSize(size.key);
    }

    function applyInitialSizeSelection() {
      if (!sizeCatalog.length) return;
      var preselect = pickerState.urlPreselect;
      var preselectedSize = preselect && preselect.sizeKey ? resolvePreselectedSize(preselect) : null;
      var currentPendingSize = pickerState.pendingSize ? getSizeData(pickerState.pendingSize) : null;

      if (preselectedSize) {
        applyResolvedUrlPreselectSize(preselect, preselectedSize);
        pickerState.pendingSize = preselectedSize.key;
        if (preselectedSize.sold_out) {
          root.setAttribute('data-url-preselect-size-status', 'sold_out');
        } else {
          root.setAttribute('data-url-preselect-size-status', 'valid');
        }
      } else if (preselect && preselect.sizeKey) {
        root.setAttribute('data-url-preselect-size-status', 'unknown');
        pickerState.pendingSize = null;
        pickerState.firstColor = null;
        pickerState.secondColor = null;
      } else if (currentPendingSize && !currentPendingSize.sold_out) {
        pickerState.pendingSize = currentPendingSize.key;
      } else {
        pickerState.pendingSize = null;
      }
      if (catalogMode && pickerState.pendingSize) {
        applyCatalogSizeContext(getSizeData(pickerState.pendingSize));
      }
    }

    function handleSizesPayload(payload) {
      payload = requireMatchingListingContext(payload, 'sizes');
      if (!payload || payload.error || !Array.isArray(payload.sizes)) {
        sizeFetchError = payload && payload.reason
          ? 'Could not load sizes: ' + payload.reason + '.'
          : 'Could not load sizes.';
        sizePayload = null;
        sizeCatalog = [];
        pickerState.pendingSize = null;
        pickerState.size = null;
        setStepTouched('1', false);
        setStepSummary('1', '');
        resetStepsAfter('1');
        renderSizeRows();
        renderShellState();
        return null;
      }

      if (catalogMode) {
        payload.sizes = payload.sizes.map(function (size) {
          if (!size || getCatalogSizeFamily(size) === 'single') return size;
          if (getCatalogCarrierVariant(size)) return size;
          return Object.assign({}, size, {
            sold_out: true,
            blurb: size.blurb || 'This case size is not configured yet.'
          });
        });
      }

      sizeFetchError = '';
      if (pickerState.size) {
        var refreshedSize = payload.sizes.find(function (size) {
          return size && size.key === pickerState.size;
        });
        if (!refreshedSize || refreshedSize.sold_out) {
          pickerState.pendingSize = null;
          pickerState.size = null;
          setStepTouched('1', false);
          setStepSummary('1', '');
          resetStepsAfter('1');
        }
      }
      sizePayload = payload;
      sizeCatalog = catalogMode ? orderCatalogSizes(payload.sizes) : payload.sizes.slice();
      applyInitialSizeSelection();
      renderSizeRows();
      renderShellState();
      prefetchColorsForSize(pickerState.pendingSize);
      return payload;
    }

    function fetchSizes(options) {
      options = options || {};
      if (configurationError) {
        sizeFetchError = configurationError;
        renderSizeRows();
        renderShellState();
        return Promise.resolve(null);
      }
      if (sizePayload && !options.force) {
        renderSizeRows();
        renderShellState();
        return Promise.resolve(sizePayload);
      }
      if (sizeFetchPromise && !options.force) return sizeFetchPromise;

      if (!window.theme || !theme.productDataFetcher || typeof theme.productDataFetcher.fetch !== 'function') {
        sizeFetchError = 'Product data helper is not available.';
        renderSizeRows();
        renderShellState();
        return Promise.resolve(null);
      }

      var sizeFetchArgs = buildSizeFetchArgs();

      if (options.force && typeof theme.productDataFetcher.invalidate === 'function') {
        theme.productDataFetcher.invalidate.apply(theme.productDataFetcher, sizeFetchArgs);
      }

      sizeFetchLoading = true;
      syncNotifySubmit();
      sizeFetchError = '';
      renderSizeRows();
      renderShellState();

      sizeFetchPromise = theme.productDataFetcher.fetch
        .apply(theme.productDataFetcher, sizeFetchArgs)
        .then(function (payload) {
          sizeFetchLoading = false;
          syncNotifySubmit();
          sizeFetchPromise = null;
          return handleSizesPayload(payload);
        })
        .catch(function () {
          sizeFetchLoading = false;
          syncNotifySubmit();
          sizeFetchPromise = null;
          sizeFetchError = 'Could not load sizes.';
          sizePayload = null;
          sizeCatalog = [];
          pickerState.pendingSize = null;
          pickerState.size = null;
          setStepTouched('1', false);
          setStepSummary('1', '');
          resetStepsAfter('1');
          renderSizeRows();
          renderShellState();
          return null;
        });

      return sizeFetchPromise;
    }

    function appendColorStatus(parent, message, tone, retryAttr) {
      var wrap = document.createElement('div');
      wrap.className = tone === 'error'
        ? 'tw:flex tw:flex-col tw:gap-3 tw:rounded tw:border tw:border-red-200 tw:bg-red-50 tw:p-3 tw:text-sm tw:text-red-800'
        : 'tw:rounded tw:border tw:border-gray-200 tw:bg-white tw:p-3 tw:text-sm tw:text-gray-600';
      if (tone === 'error') {
        var errorText = document.createElement('p');
        errorText.className = 'tw:m-0';
        errorText.textContent = message || 'Could not load colors.';
        wrap.appendChild(errorText);
        if (retryAttr) {
          var retry = document.createElement('button');
          retry.type = 'button';
          retry.setAttribute(retryAttr, 'true');
          retry.className = 'tw:self-start tw:rounded tw:border tw:border-red-300 tw:bg-white tw:px-3 tw:py-2 tw:text-xs tw:font-semibold tw:text-red-800';
          retry.textContent = 'Retry';
          wrap.appendChild(retry);
        }
      } else {
        wrap.textContent = message || '';
      }
      parent.appendChild(wrap);
    }

    function closeColorPopover(popover) {
      var target = popover || openColorPopover;
      if (!target) return;
      var trigger = getColorPopoverTrigger(target);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (typeof target.hidePopover === 'function') {
        try {
          target.hidePopover();
        } catch (e) {}
      }
      if (openColorPopover === target) {
        openColorPopover = null;
        unbindColorPopoverListeners();
      }
    }

    function focusElementSoon(el) {
      if (!el || typeof el.focus !== 'function') return;
      var focus = function () {
        try {
          el.focus({ preventScroll: false });
        } catch (e) {
          el.focus();
        }
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(focus);
      } else {
        window.setTimeout(focus, 0);
      }
    }

    function focusStepHeader(step) {
      var header = getStepHeader(step);
      if (header && !header.disabled) focusElementSoon(header);
    }

    function getColorPopoverTrigger(popover) {
      if (!popover) return null;
      var action = popover.getAttribute('data-color-action');
      if (!action) return null;
      return root.querySelector('[data-color-popover-trigger][data-color-action="' + action + '"]');
    }

    function getEnabledColorOptions(popover) {
      if (!popover) return [];
      return Array.prototype.slice.call(popover.querySelectorAll('[data-color-option-key]')).filter(function (option) {
        return option.getAttribute('aria-disabled') !== 'true';
      });
    }

    function focusColorOption(option) {
      if (!option) return;
      var popover = option.closest('[data-color-popover]');
      var options = popover ? popover.querySelectorAll('[data-color-option-key]') : [];
      for (var i = 0; i < options.length; i++) {
        options[i].setAttribute('tabindex', options[i] === option ? '0' : '-1');
      }
      focusElementSoon(option);
      if (typeof option.scrollIntoView === 'function') {
        option.scrollIntoView({ block: 'nearest' });
      }
    }

    function focusInitialColorOption(popover, focusLast) {
      var options = getEnabledColorOptions(popover);
      if (!options.length) return;
      var selected = options.find(function (option) {
        return option.getAttribute('aria-selected') === 'true';
      });
      focusColorOption(focusLast ? options[options.length - 1] : (selected || options[0]));
    }

    function openColorPopoverFromTrigger(trigger, focusLast) {
      if (!trigger) return;
      var targetId = trigger.getAttribute('popovertarget');
      var popover = targetId ? document.getElementById(targetId) : null;
      if (!popover) return;
      if (focusLast) {
        popover.setAttribute('data-focus-last-option', 'true');
      } else {
        popover.removeAttribute('data-focus-last-option');
      }
      placeColorPopover(popover);
      if (typeof popover.showPopover === 'function') {
        try {
          popover.showPopover();
          return;
        } catch (e) {}
      }
      focusInitialColorOption(popover, !!focusLast);
    }

    function placeColorPopover(popover) {
      var trigger = getColorPopoverTrigger(popover);
      if (!trigger) return;
      var rect = trigger.getBoundingClientRect();
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || rect.width;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var sidePadding = 16;
      var width = Math.min(rect.width, Math.max(viewportWidth - sidePadding * 2, 0));
      var left = Math.min(Math.max(rect.left, sidePadding), Math.max(viewportWidth - width - sidePadding, sidePadding));

      popover.style.position = 'fixed';
      popover.style.margin = '0';
      popover.style.left = left + 'px';
      popover.style.right = 'auto';
      popover.style.bottom = 'auto';
      popover.style.width = width + 'px';

      var popupHeight = popover.offsetHeight || 0;
      var spaceBelow = viewportHeight - rect.bottom;
      if (spaceBelow < popupHeight + 16 && rect.top > popupHeight + 16) {
        popover.style.top = (rect.top - popupHeight - 4) + 'px';
      } else {
        popover.style.top = (rect.bottom + 4) + 'px';
      }
    }

    function placeOpenColorPopover() {
      if (openColorPopover) placeColorPopover(openColorPopover);
    }

    function bindColorPopoverListeners() {
      if (colorPopoverListenersBound) return;
      window.addEventListener('resize', placeOpenColorPopover);
      window.addEventListener('scroll', placeOpenColorPopover, true);
      colorPopoverListenersBound = true;
    }

    function unbindColorPopoverListeners() {
      if (!colorPopoverListenersBound) return;
      window.removeEventListener('resize', placeOpenColorPopover);
      window.removeEventListener('scroll', placeOpenColorPopover, true);
      colorPopoverListenersBound = false;
    }

    function onColorPopoverBeforeToggle(event) {
      if (event.newState === 'open') {
        placeColorPopover(event.target);
      }
    }

    function onColorPopoverToggle(event) {
      if (event.newState === 'open') {
        openColorPopover = event.target;
        placeColorPopover(event.target);
        bindColorPopoverListeners();
        var trigger = getColorPopoverTrigger(event.target);
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var focusLast = event.target.getAttribute('data-focus-last-option') === 'true';
        event.target.removeAttribute('data-focus-last-option');
        focusInitialColorOption(event.target, focusLast);
      } else if (openColorPopover === event.target) {
        openColorPopover = null;
        unbindColorPopoverListeners();
        var closedTrigger = getColorPopoverTrigger(event.target);
        if (closedTrigger) closedTrigger.setAttribute('aria-expanded', 'false');
      }
    }

    function getCatalogColorByKey(catalog, key) {
      if (!key) return null;
      for (var i = 0; i < catalog.length; i++) {
        if (catalog[i].key === key) return catalog[i];
      }
      return null;
    }

    function colorIsSoldOut(color) {
      return !!(color && (color.sold_out || !color.variant));
    }

    function createColorSwatch(color, sizeClass) {
      var swatch = document.createElement('span');
      swatch.className = [
        'tw:relative tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:overflow-hidden tw:rounded-full tw:border tw:border-gray-200 tw:bg-gray-100',
        sizeClass || 'tw:h-9 tw:w-9'
      ].join(' ');
      if (color && color.swatch_image) {
        var img = document.createElement('img');
        img.src = color.swatch_image;
        img.alt = '';
        img.loading = 'lazy';
        img.className = 'tw:h-full tw:w-full tw:object-cover';
        swatch.appendChild(img);
      }
      if (colorIsSoldOut(color)) {
        var slash = document.createElement('span');
        slash.setAttribute('aria-hidden', 'true');
        slash.className = 'tw:pointer-events-none tw:absolute tw:left-1/2 tw:top-1/2 tw:h-0.5 tw:w-[140%] tw:-translate-x-1/2 tw:-translate-y-1/2 tw:-rotate-45 tw:bg-red-600';
        swatch.appendChild(slash);
      }
      return swatch;
    }

    function appendColorBadges(parent, color, options) {
      options = options || {};
      if (!color || !Array.isArray(color.badges)) return;
      color.badges.forEach(function (badge) {
        if (!badge || !badge.name) return;
        var badgeEl = document.createElement('span');
        badgeEl.className = options.compact
          ? 'tw:rounded-full tw:bg-gray-100 tw:px-1.5 tw:py-0.5 tw:text-[10px] tw:font-medium tw:leading-tight tw:text-gray-700'
          : 'tw:rounded-full tw:bg-gray-100 tw:px-2 tw:py-0.5 tw:text-xs tw:font-semibold tw:text-gray-700';
        badgeEl.textContent = badge.name;
        if (badge.color) {
          badgeEl.style.backgroundColor = badge.color;
          badgeEl.style.color = '#fff';
        }
        parent.appendChild(badgeEl);
      });
    }

    function createColorOptionItem(color, selectedKey, action) {
      var isSelected = color.key === selectedKey;
      var isSoldOut = colorIsSoldOut(color);
      var canNotify = isSoldOut && color.bis !== false && !!notifyModalEl;
      var colorLabel = getColorDisplayName(color);
      var ariaParts = [colorLabel];
      if (isSoldOut) ariaParts.push('sold out');
      if (canNotify) ariaParts.push('notify me when available');
      if (isSelected) ariaParts.push('selected');
      var item = document.createElement('li');
      item.setAttribute('data-color-option-key', color.key);
      item.setAttribute('data-color-action', action);
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      item.setAttribute('aria-disabled', isSoldOut && !canNotify ? 'true' : 'false');
      if (canNotify) item.setAttribute('aria-haspopup', 'dialog');
      item.setAttribute('aria-label', ariaParts.join(', '));
      item.setAttribute('tabindex', '-1');
      item.className = [
        'tw:flex tw:items-center tw:gap-2',
        'tw:min-h-10 tw:max-h-12',
        'tw:px-3 tw:py-1.5',
        'tw:cursor-pointer',
        'tw:transition-colors tw:duration-fast tw:ease-standard',
        'tw:hover:bg-gray-50',
        FOCUS_RING_INSET,
        'tw:aria-disabled:opacity-40 tw:aria-disabled:cursor-not-allowed tw:aria-disabled:hover:bg-transparent',
        canNotify ? 'tw:opacity-40' : '',
        isSelected ? 'tw:bg-gray-50' : ''
      ].join(' ');

      item.appendChild(createColorSwatch(color, 'tw:h-8 tw:w-8'));

      var labelWrap = document.createElement('span');
      labelWrap.className = 'tw:flex tw:min-w-0 tw:flex-1 tw:flex-wrap tw:items-center tw:gap-1.5';
      var name = document.createElement('span');
      name.className = 'tw:min-w-0 tw:truncate tw:text-sm tw:font-medium tw:text-gray-900';
      name.textContent = getColorDisplayName(color);
      labelWrap.appendChild(name);
      appendColorBadges(labelWrap, color, { compact: true });
      if (isSoldOut) {
        var soldOut = document.createElement('span');
        soldOut.className = 'tw:rounded-full tw:bg-gray-100 tw:px-1.5 tw:py-0.5 tw:text-[10px] tw:font-semibold tw:leading-tight tw:text-gray-600';
        soldOut.textContent = 'Sold out';
        labelWrap.appendChild(soldOut);
      }
      item.appendChild(labelWrap);

      var check = document.createElement('span');
      check.setAttribute('data-color-option-check', '');
      check.className = [
        'tw:flex tw:h-4 tw:w-4 tw:flex-shrink-0 tw:items-center tw:justify-center tw:text-black',
        isSelected ? '' : 'tw:hidden'
      ].join(' ');
      check.innerHTML = '<svg class="tw:h-4 tw:w-4" viewBox="0 0 16 16" fill="currentColor"><path d="M6.5 11.4 2.6 7.5 4 6.1l2.5 2.5L12 3.1l1.4 1.4z"></path></svg>';
      item.appendChild(check);

      return item;
    }

    function appendColorPopoverControl(parent, options) {
      var catalog = getSortedColorList(options.catalog);
      var selectedColor = getCatalogColorByKey(catalog, options.selectedKey);
      var action = options.action;
      var popupId = root.id + '-color-popover-' + action;
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.setAttribute('data-color-popover-trigger', '');
      trigger.setAttribute('data-color-action', action);
      trigger.setAttribute('popovertarget', popupId);
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', popupId);
      trigger.setAttribute('aria-label', options.title + ': ' + (selectedColor ? getColorDisplayName(selectedColor) : 'Select color'));
      trigger.className = [
        'tw:flex tw:w-full tw:items-center tw:justify-between tw:gap-2',
        'tw:min-h-10 tw:rounded-md tw:border tw:border-gray-200 tw:bg-white tw:py-1.5 tw:pl-3 tw:pr-4 tw:text-left',
        'tw:cursor-pointer tw:transition-all tw:duration-fast tw:ease-standard tw:hover:border-gray-400',
        FOCUS_RING_BLACK
      ].join(' ');

      var triggerContent = document.createElement('span');
      triggerContent.className = 'tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:gap-3';
      triggerContent.appendChild(createColorSwatch(selectedColor, 'tw:h-9 tw:w-9'));
      var triggerText = document.createElement('span');
      triggerText.className = 'tw:flex tw:min-w-0 tw:flex-1 tw:flex-wrap tw:items-center tw:gap-1.5';
      var triggerName = document.createElement('span');
      triggerName.className = 'tw:min-w-0 tw:truncate tw:text-sm tw:font-semibold tw:text-gray-950';
      triggerName.textContent = selectedColor ? getColorDisplayName(selectedColor) : 'Select color';
      triggerText.appendChild(triggerName);
      appendColorBadges(triggerText, selectedColor, { compact: true });
      triggerContent.appendChild(triggerText);
      trigger.appendChild(triggerContent);

      var chevron = document.createElement('span');
      chevron.setAttribute('aria-hidden', 'true');
      chevron.className = 'tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:text-gray-500';
      chevron.innerHTML = '<svg class="tw:h-2 tw:w-3" viewBox="0 0 12 7" fill="none"><path d="M11 1L6 6L1 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      trigger.appendChild(chevron);
      parent.appendChild(trigger);

      var popup = document.createElement('div');
      popup.id = popupId;
      popup.setAttribute('popover', 'auto');
      popup.setAttribute('data-color-popover', '');
      popup.setAttribute('data-color-action', action);
      popup.setAttribute('role', 'listbox');
      popup.setAttribute('aria-label', options.title);
      popup.className = 'tw:m-0 tw:border-0 tw:bg-transparent tw:p-0';

      var list = document.createElement('ul');
      list.setAttribute('data-color-options', '');
      list.className = 'tw:list-none tw:m-0 tw:max-h-72 tw:overflow-hidden tw:overflow-y-auto tw:rounded-lg tw:border tw:border-gray-200 tw:bg-white tw:p-0 tw:shadow-lg';
      catalog.forEach(function (color) {
        list.appendChild(createColorOptionItem(color, options.selectedKey, action));
      });
      popup.appendChild(list);
      popup.addEventListener('beforetoggle', onColorPopoverBeforeToggle);
      popup.addEventListener('toggle', onColorPopoverToggle);
      parent.appendChild(popup);
    }

    function selectColorOptionElement(colorOption, options) {
      options = options || {};
      if (!colorOption) return;
      var colorAction = colorOption.getAttribute('data-color-action');
      var colorKey = colorOption.getAttribute('data-color-option-key');
      var color = colorAction === 'single' ? getColorData(colorKey)
        : (colorAction === 'first' ? getFirstColorData(colorKey)
          : (colorAction === 'second' ? getSecondColorData(colorKey) : null));
      if (!color) return;
      var popover = colorOption.closest('[data-color-popover]');
      if (colorIsSoldOut(color)) {
        if (!notifyModalEl || color.bis === false) return;
        var returnFocus = getColorPopoverTrigger(popover);
        closeColorPopover(popover);
        openNotifyModal({
          caseSize: pickerState.size,
          firstColor: colorAction === 'second' ? pickerState.firstColor : colorKey,
          secondColor: colorAction === 'second' ? colorKey : pickerState.secondColor,
          requestedColors: true,
          returnFocus: returnFocus
        });
        return;
      }
      if (colorOption.getAttribute('aria-disabled') === 'true') return;
      closeColorPopover(popover);
      if (colorAction === 'single') {
        setSingleColor(colorKey);
      } else if (colorAction === 'first') {
        setTwoCaseFirstColor(colorKey);
      } else if (colorAction === 'second') {
        setTwoCaseSecondColor(colorKey);
      }
      if (options.focusTrigger) {
        focusElementSoon(root.querySelector('[data-color-popover-trigger][data-color-action="' + colorAction + '"]'));
      }
    }

    function renderColorOptionsSection(options) {
      var section = document.createElement('div');
      section.className = 'tw:flex tw:w-full tw:flex-col tw:gap-2 tw:sm:max-w-md';
      if (options.label) {
        var label = document.createElement('span');
        label.className = 'tw:text-xs tw:font-bold tw:leading-tight tw:text-black';
        label.textContent = options.label;
        section.appendChild(label);
      }
      if (options.loading) {
        appendColorStatus(section, options.loadingText || 'Loading colors...');
      } else if (options.error) {
        appendColorStatus(section, options.error, 'error', options.retryAttr);
      } else if (options.blockedText) {
        appendColorStatus(section, options.blockedText);
      } else if (!options.catalog.length) {
        appendColorStatus(section, options.emptyText || 'No colors are available for this selection.');
      } else {
        appendColorPopoverControl(section, options);
      }

      colorListEl.appendChild(section);
    }

    function renderTwoCaseColorRows() {
      if (!pickerState.size) {
        appendColorStatus(colorListEl, 'Choose a size before selecting colors.');
        return;
      }

      var colorLabels = getTwoCaseColorInputLabels();
      renderColorOptionsSection({
        title: colorLabels[0] || 'First color',
        label: colorLabels[0] || 'First color',
        catalog: firstColorCatalog,
        selectedKey: pickerState.firstColor,
        action: 'first',
        loading: firstColorFetchLoading,
        loadingText: 'Loading first colors...',
        error: firstColorFetchError,
        retryAttr: 'data-first-color-retry',
        emptyText: 'No colors are available for this selection.'
      });

      renderColorOptionsSection({
        title: colorLabels[1] || 'Second color',
        label: colorLabels[1] || 'Second color',
        catalog: secondColorCatalog,
        selectedKey: pickerState.secondColor,
        action: 'second',
        loading: secondColorFetchLoading,
        loadingText: 'Loading second colors...',
        error: secondColorFetchError,
        retryAttr: 'data-second-color-retry',
        blockedText: pickerState.firstColor ? '' : 'Choose a first color to see matching second colors.',
        emptyText: 'No colors are available for this selection.'
      });
    }

    function renderColorRows() {
      if (!colorListEl) {
        renderColorBodyPreview();
        return;
      }
      closeColorPopover();
      colorListEl.innerHTML = '';
      renderColorBodyPreview();

      if (isTwoCaseFamily()) {
        renderTwoCaseColorRows();
        return;
      }

      if (colorFetchLoading) {
        appendColorStatus(colorListEl, 'Loading colors...');
        return;
      }

      if (colorFetchError) {
        appendColorStatus(colorListEl, colorFetchError, 'error', 'data-color-retry');
        return;
      }

      if (!colorCatalog.length) {
        appendColorStatus(colorListEl, 'No colors are available for this selection.');
        return;
      }

      renderColorOptionsSection({
        title: 'Color',
        catalog: colorCatalog,
        selectedKey: pickerState.firstColor,
        action: 'single'
      });
    }

    function setSingleColor(key, options) {
      options = options || {};
      var color = getColorData(key);
      if (!color || color.sold_out || !color.variant) return;
      var previousColor = pickerState.firstColor;
      pickerState.firstColor = color.key;
      pickerState.secondColor = null;
      pickerState.selectedVariant = color.variant;
      clearTwoSideComponentSelection();
      applySingleCaseVariantDisplay(color.variant);
      if (!options.initial) setValidationMessage(colorValidationEl, '');

      if (!options.initial && previousColor && previousColor !== color.key && (pickerState.touchedSteps['2'] || pickerState.colorSummaryShown)) {
        setStepTouched('2', false);
        resetStepsAfter('2');
        renderColorStepSummary();
      }

      renderColorRows();
      refreshRenderedPocketBodyPreview();
      renderShellState();
      dispatchStateEvent();
    }

    function applyInitialSingleColorSelection() {
      if (!colorCatalog.length) {
        pickerState.firstColor = null;
        pickerState.secondColor = null;
        pickerState.selectedVariant = null;
        root.removeAttribute('data-selected-variant-id');
        ignoreUrlColorPreselectOnce = false;
        return;
      }
      var preselect = pickerState.urlPreselect;
      var useUrlPreselect = !ignoreUrlColorPreselectOnce;
      var preselectedColor = preselect && preselect.firstColorKey ? getColorData(preselect.firstColorKey) : null;
      var currentColor = pickerState.firstColor ? getColorData(pickerState.firstColor) : null;
      var fallbackColor = getFirstSelectableColor();

      if (currentColor && !currentColor.sold_out && currentColor.variant) {
        if (preselect && preselect.firstColorKey === currentColor.key) {
          root.setAttribute('data-url-preselect-first-color-status', 'valid');
        }
        setSingleColor(currentColor.key, { initial: true });
      } else if (useUrlPreselect && preselectedColor && !preselectedColor.sold_out && preselectedColor.variant) {
        root.setAttribute('data-url-preselect-first-color-status', 'valid');
        setSingleColor(preselectedColor.key, { initial: true });
      } else if (useUrlPreselect && preselectedColor) {
        root.setAttribute('data-url-preselect-first-color-status', 'sold_out');
        if (fallbackColor) setSingleColor(fallbackColor.key, { initial: true });
      } else if (useUrlPreselect && preselect && preselect.firstColorKey) {
        root.setAttribute('data-url-preselect-first-color-status', 'unknown');
        if (fallbackColor) setSingleColor(fallbackColor.key, { initial: true });
      } else if (fallbackColor) {
        setSingleColor(fallbackColor.key, { initial: true });
      } else {
        pickerState.firstColor = null;
        pickerState.secondColor = null;
        pickerState.selectedVariant = null;
        root.removeAttribute('data-selected-variant-id');
      }
      ignoreUrlColorPreselectOnce = false;
    }

    function handleSingleColorsPayload(payload) {
      payload = requireMatchingListingContext(payload, 'colors');
      if (!payload || payload.error || !Array.isArray(payload.colors)) {
        colorFetchError = payload && payload.reason
          ? 'Could not load colors: ' + payload.reason + '.'
          : 'Could not load colors.';
        colorPayload = null;
        colorCatalog = [];
        clearConfirmedColorSelectionForCatalogRefresh(true);
        renderColorRows();
        renderShellState();
        return null;
      }

      colorFetchError = '';
      if (pickerState.firstColor && !catalogContainsColorKey(payload.colors, pickerState.firstColor)) {
        clearConfirmedColorSelectionForCatalogRefresh(true);
      }
      colorPayload = payload;
      colorCatalog = payload.colors.slice();
      applyInitialSingleColorSelection();
      renderColorRows();
      renderShellState();
      return payload;
    }

    function fetchSingleColors(options) {
      options = options || {};
      if (pickerState.family !== 'single' || !pickerState.size) {
        renderColorRows();
        renderShellState();
        return Promise.resolve(null);
      }
      if (colorPayload && colorFetchSize === pickerState.size && !options.force) {
        renderColorRows();
        renderShellState();
        return Promise.resolve(colorPayload);
      }
      if (colorPrefetchPayload && colorPrefetchSize === pickerState.size && !options.force) {
        return Promise.resolve(handleSingleColorsPayload(colorPrefetchPayload));
      }
      if (colorFetchPromise && colorFetchSize === pickerState.size && !options.force) return colorFetchPromise;

      if (!window.theme || !theme.productDataFetcher || typeof theme.productDataFetcher.fetch !== 'function') {
        colorFetchError = 'Product data helper is not available.';
        renderColorRows();
        renderShellState();
        return Promise.resolve(null);
      }

      var colorFetchArgs = buildColorFetchArgs('colors', pickerState.size);
      if (options.force && typeof theme.productDataFetcher.invalidate === 'function') {
        theme.productDataFetcher.invalidate.apply(theme.productDataFetcher, colorFetchArgs);
        colorPrefetchPayload = null;
        colorPrefetchPromise = null;
        colorPrefetchSize = null;
      }

      colorFetchSize = pickerState.size;
      colorFetchLoading = true;
      colorFetchError = '';
      renderColorRows();
      renderShellState();

      colorFetchPromise = theme.productDataFetcher.fetch
        .apply(theme.productDataFetcher, colorFetchArgs)
        .then(function (payload) {
          colorFetchLoading = false;
          colorFetchPromise = null;
          return handleSingleColorsPayload(payload);
        })
        .catch(function () {
          colorFetchLoading = false;
          colorFetchPromise = null;
          colorFetchError = 'Could not load colors.';
          pickerState.selectedVariant = null;
          root.removeAttribute('data-selected-variant-id');
          renderColorRows();
          renderShellState();
          return null;
        });

      return colorFetchPromise;
    }

    function clearTwoCaseSecondColors() {
      secondColorPayload = null;
      secondColorCatalog = [];
      secondColorFetchPromise = null;
      secondColorFetchLoading = false;
      secondColorFetchError = '';
      secondColorFetchSize = null;
      secondColorFetchFirstColor = null;
    }

    function clearSelectedVariant() {
      pickerState.selectedVariant = null;
      clearTwoSideComponentSelection();
      root.removeAttribute('data-selected-variant-id');
    }

    function catalogContainsColorKey(catalog, key) {
      if (!key || !Array.isArray(catalog)) return false;
      return catalog.some(function (color) { return color && color.key === key; });
    }

    function clearConfirmedColorSelectionForCatalogRefresh(clearFirstColor) {
      if (clearFirstColor) pickerState.firstColor = null;
      pickerState.secondColor = null;
      pickerState.colorSummaryShown = false;
      clearSelectedVariant();
      if (clearFirstColor) clearTwoCaseSecondColors();
      setStepTouched('2', false);
      setStepSummary('2', '');
      resetStepsAfter('2');
    }

    function setTwoCaseSecondColor(key, options) {
      options = options || {};
      var color = getSecondColorData(key);
      if (!color || color.sold_out || !color.variant) return;
      pickerState.secondColor = color.key;
      pickerState.selectedVariant = color.variant;
      resolveTwoSideComponentVariants();
      applyTwoCaseCompositeVariantDisplay(color.variant);
      if (!options.initial) setValidationMessage(colorValidationEl, '');

      if ((pickerState.touchedSteps['2'] || pickerState.colorSummaryShown) && pickerState.secondColor) {
        renderColorStepSummary();
      }

      renderColorRows();
      refreshRenderedPocketBodyPreview();
      renderShellState();
      dispatchStateEvent();
    }

    function applyInitialTwoCaseSecondColorSelection() {
      if (!secondColorCatalog.length) {
        pickerState.secondColor = null;
        clearSelectedVariant();
        ignoreUrlColorPreselectOnce = false;
        return;
      }

      var preselect = pickerState.urlPreselect;
      var useUrlPreselect = !ignoreUrlColorPreselectOnce;
      var preselectedColor = preselect && preselect.secondColorKey ? getSecondColorData(preselect.secondColorKey) : null;
      var currentColor = pickerState.secondColor ? getSecondColorData(pickerState.secondColor) : null;
      var fallbackColor = getFirstSelectableFromCatalog(secondColorCatalog);

      if (currentColor && !currentColor.sold_out && currentColor.variant) {
        if (preselect && preselect.secondColorKey === currentColor.key) {
          root.setAttribute('data-url-preselect-second-color-status', 'valid');
        }
        setTwoCaseSecondColor(currentColor.key, { initial: true });
      } else if (useUrlPreselect && preselectedColor && !preselectedColor.sold_out && preselectedColor.variant) {
        root.setAttribute('data-url-preselect-second-color-status', 'valid');
        setTwoCaseSecondColor(preselectedColor.key, { initial: true });
      } else if (useUrlPreselect && preselectedColor) {
        root.setAttribute('data-url-preselect-second-color-status', 'sold_out');
        if (fallbackColor) setTwoCaseSecondColor(fallbackColor.key, { initial: true });
      } else if (useUrlPreselect && preselect && preselect.secondColorKey) {
        root.setAttribute('data-url-preselect-second-color-status', 'unknown');
        if (fallbackColor) setTwoCaseSecondColor(fallbackColor.key, { initial: true });
      } else if (fallbackColor) {
        setTwoCaseSecondColor(fallbackColor.key, { initial: true });
      } else {
        pickerState.secondColor = null;
        clearSelectedVariant();
      }

      ignoreUrlColorPreselectOnce = false;
    }

    function handleSecondColorsPayload(payload) {
      payload = requireMatchingListingContext(payload, 'second colors');
      if (payload && !payload.error) {
        if (!pickerState.firstColor) return null;
        var firstColorMatches = hasIndependentSecondColors() || payload.first_color_key === pickerState.firstColor;
        if (payload.size_key !== pickerState.size || !firstColorMatches) {
          return null;
        }
      }
      if (!payload || payload.error || !Array.isArray(payload.colors)) {
        secondColorFetchError = payload && payload.reason
          ? 'Could not load second colors: ' + payload.reason + '.'
          : 'Could not load second colors.';
        secondColorPayload = null;
        secondColorCatalog = [];
        clearConfirmedColorSelectionForCatalogRefresh(false);
        renderColorRows();
        renderShellState();
        return null;
      }

      secondColorFetchError = '';
      if (pickerState.secondColor && !catalogContainsColorKey(payload.colors, pickerState.secondColor)) {
        clearConfirmedColorSelectionForCatalogRefresh(false);
      }
      secondColorPayload = payload;
      secondColorCatalog = payload.colors.slice();
      applyInitialTwoCaseSecondColorSelection();
      renderColorRows();
      renderShellState();
      return payload;
    }

    function fetchSecondColors(options) {
      options = options || {};
      if (!isTwoCaseFamily() || !pickerState.size || !pickerState.firstColor || !pickerState.tier) {
        renderColorRows();
        renderShellState();
        return Promise.resolve(null);
      }
      var secondColorCacheKey = getSecondColorCacheKey(pickerState.firstColor);
      if (
        secondColorPayload &&
        secondColorFetchSize === pickerState.size &&
        secondColorFetchFirstColor === secondColorCacheKey &&
        !options.force
      ) {
        renderColorRows();
        renderShellState();
        return Promise.resolve(secondColorPayload);
      }
      if (
        secondColorPrefetchPayload &&
        secondColorPrefetchSize === pickerState.size &&
        secondColorPrefetchFirstColor === secondColorCacheKey &&
        !options.force
      ) {
        return Promise.resolve(handleSecondColorsPayload(secondColorPrefetchPayload));
      }
      if (
        secondColorFetchPromise &&
        secondColorFetchSize === pickerState.size &&
        secondColorFetchFirstColor === secondColorCacheKey &&
        !options.force
      ) {
        return secondColorFetchPromise;
      }

      if (!window.theme || !theme.productDataFetcher || typeof theme.productDataFetcher.fetch !== 'function') {
        secondColorFetchError = 'Product data helper is not available.';
        renderColorRows();
        renderShellState();
        return Promise.resolve(null);
      }

      var secondColorFetchArgs = buildColorFetchArgs('secondcolors', pickerState.size, pickerState.firstColor);
      if (options.force && typeof theme.productDataFetcher.invalidate === 'function') {
        theme.productDataFetcher.invalidate.apply(theme.productDataFetcher, secondColorFetchArgs);
        secondColorPrefetchPayload = null;
        secondColorPrefetchPromise = null;
        secondColorPrefetchSize = null;
        secondColorPrefetchFirstColor = null;
      }

      secondColorFetchSize = pickerState.size;
      secondColorFetchFirstColor = secondColorCacheKey;
      secondColorFetchLoading = true;
      secondColorFetchError = '';
      renderColorRows();
      renderShellState();

      secondColorFetchPromise = theme.productDataFetcher.fetch
        .apply(theme.productDataFetcher, secondColorFetchArgs)
        .then(function (payload) {
          secondColorFetchLoading = false;
          secondColorFetchPromise = null;
          return handleSecondColorsPayload(payload);
        })
        .catch(function () {
          secondColorFetchLoading = false;
          secondColorFetchPromise = null;
          secondColorFetchError = 'Could not load second colors.';
          pickerState.secondColor = null;
          clearSelectedVariant();
          renderColorRows();
          renderShellState();
          return null;
        });

      return secondColorFetchPromise;
    }

    function setTwoCaseFirstColor(key, options) {
      options = options || {};
      var color = getFirstColorData(key);
      if (!color || color.sold_out || !color.variant) return Promise.resolve(null);
      var previousColor = pickerState.firstColor;
      pickerState.firstColor = color.key;
      if (!options.initial) setValidationMessage(colorValidationEl, '');

      if (!options.initial && previousColor !== color.key) {
        if (hasIndependentSecondColors()) {
          clearTwoSideComponentSelection();
          var currentSecondColor = getSecondColorData(pickerState.secondColor);
          if (currentSecondColor && !currentSecondColor.sold_out && currentSecondColor.variant) {
            pickerState.selectedVariant = currentSecondColor.variant;
            resolveTwoSideComponentVariants();
            applyTwoCaseCompositeVariantDisplay(currentSecondColor.variant);
          } else {
            clearSelectedVariant();
          }
        } else {
          pickerState.secondColor = null;
          clearSelectedVariant();
          clearTwoCaseSecondColors();
        }
        if (pickerState.touchedSteps['2'] || pickerState.colorSummaryShown) {
          setStepTouched('2', false);
          resetStepsAfter('2');
        }
      }

      renderColorRows();
      refreshRenderedPocketBodyPreview();
      renderShellState();
      dispatchStateEvent();
      return fetchSecondColors({ force: options.forceSecond });
    }

    function applyInitialTwoCaseFirstColorSelection() {
      if (!firstColorCatalog.length) {
        pickerState.firstColor = null;
        pickerState.secondColor = null;
        clearTwoCaseSecondColors();
        clearSelectedVariant();
        ignoreUrlColorPreselectOnce = false;
        return;
      }

      var preselect = pickerState.urlPreselect;
      var useUrlPreselect = !ignoreUrlColorPreselectOnce;
      var preselectedColor = preselect && preselect.firstColorKey ? getFirstColorData(preselect.firstColorKey) : null;
      var currentColor = pickerState.firstColor ? getFirstColorData(pickerState.firstColor) : null;
      var fallbackColor = getFirstSelectableFromCatalog(firstColorCatalog);

      if (currentColor && !currentColor.sold_out && currentColor.variant) {
        if (preselect && preselect.firstColorKey === currentColor.key) {
          root.setAttribute('data-url-preselect-first-color-status', 'valid');
        }
        setTwoCaseFirstColor(currentColor.key, { initial: true });
      } else if (useUrlPreselect && preselectedColor && !preselectedColor.sold_out && preselectedColor.variant) {
        root.setAttribute('data-url-preselect-first-color-status', 'valid');
        setTwoCaseFirstColor(preselectedColor.key, { initial: true });
      } else if (useUrlPreselect && preselectedColor) {
        root.setAttribute('data-url-preselect-first-color-status', 'sold_out');
        if (fallbackColor) setTwoCaseFirstColor(fallbackColor.key, { initial: true });
      } else if (useUrlPreselect && preselect && preselect.firstColorKey) {
        root.setAttribute('data-url-preselect-first-color-status', 'unknown');
        if (fallbackColor) setTwoCaseFirstColor(fallbackColor.key, { initial: true });
      } else if (fallbackColor) {
        setTwoCaseFirstColor(fallbackColor.key, { initial: true });
      } else {
        pickerState.firstColor = null;
        pickerState.secondColor = null;
        clearTwoCaseSecondColors();
        clearSelectedVariant();
        ignoreUrlColorPreselectOnce = false;
      }
    }

    function handleFirstColorsPayload(payload) {
      payload = requireMatchingListingContext(payload, 'first colors');
      if (payload && !payload.error && payload.size_key !== pickerState.size) {
        return null;
      }
      if (!payload || payload.error || !Array.isArray(payload.colors)) {
        firstColorFetchError = payload && payload.reason
          ? 'Could not load first colors: ' + payload.reason + '.'
          : 'Could not load first colors.';
        firstColorPayload = null;
        firstColorCatalog = [];
        clearConfirmedColorSelectionForCatalogRefresh(true);
        renderColorRows();
        renderShellState();
        return null;
      }

      firstColorFetchError = '';
      if (pickerState.firstColor && !catalogContainsColorKey(payload.colors, pickerState.firstColor)) {
        clearConfirmedColorSelectionForCatalogRefresh(true);
      }
      firstColorPayload = payload;
      firstColorCatalog = payload.colors.slice();
      applyInitialTwoCaseFirstColorSelection();
      renderColorRows();
      renderShellState();
      return payload;
    }

    function fetchFirstColors(options) {
      options = options || {};
      if (!isTwoCaseFamily() || !pickerState.size || !pickerState.tier) {
        renderColorRows();
        renderShellState();
        return Promise.resolve(null);
      }
      if (firstColorPayload && firstColorFetchSize === pickerState.size && !options.force) {
        renderColorRows();
        renderShellState();
        return Promise.resolve(firstColorPayload);
      }
      if (firstColorPrefetchPayload && firstColorPrefetchSize === pickerState.size && !options.force) {
        return Promise.resolve(handleFirstColorsPayload(firstColorPrefetchPayload));
      }
      if (firstColorFetchPromise && firstColorFetchSize === pickerState.size && !options.force) return firstColorFetchPromise;

      if (!window.theme || !theme.productDataFetcher || typeof theme.productDataFetcher.fetch !== 'function') {
        firstColorFetchError = 'Product data helper is not available.';
        renderColorRows();
        renderShellState();
        return Promise.resolve(null);
      }

      var firstColorFetchArgs = buildColorFetchArgs('firstcolors', pickerState.size);
      if (options.force && typeof theme.productDataFetcher.invalidate === 'function') {
        theme.productDataFetcher.invalidate.apply(theme.productDataFetcher, firstColorFetchArgs);
        firstColorPrefetchPayload = null;
        firstColorPrefetchPromise = null;
        firstColorPrefetchSize = null;
      }

      firstColorFetchSize = pickerState.size;
      firstColorFetchLoading = true;
      firstColorFetchError = '';
      clearTwoCaseSecondColors();
      renderColorRows();
      renderShellState();

      firstColorFetchPromise = theme.productDataFetcher.fetch
        .apply(theme.productDataFetcher, firstColorFetchArgs)
        .then(function (payload) {
          firstColorFetchLoading = false;
          firstColorFetchPromise = null;
          return handleFirstColorsPayload(payload);
        })
        .catch(function () {
          firstColorFetchLoading = false;
          firstColorFetchPromise = null;
          firstColorFetchError = 'Could not load first colors.';
          pickerState.firstColor = null;
          pickerState.secondColor = null;
          clearTwoCaseSecondColors();
          clearSelectedVariant();
          renderColorRows();
          renderShellState();
          return null;
        });

      return firstColorFetchPromise;
    }

    function setValidationMessage(el, message) {
      if (!el) return;
      var value = String(message || '').trim();
      el.textContent = value;
      el.classList.toggle('tw:hidden', !value);
    }

    function appendAddOnStatus(parent, message) {
      var status = document.createElement('div');
      status.className = 'tw:rounded tw:border tw:border-gray-200 tw:bg-white tw:p-3 tw:text-sm tw:text-gray-600';
      status.textContent = message;
      parent.appendChild(status);
    }

    function createEngravingModeButton(attrName, mode, label, priceText, selected) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute(attrName, mode);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.className = [
        'tw:w-full tw:sm:w-auto tw:flex-grow tw:min-h-10 tw:flex tw:items-center tw:justify-center tw:gap-1 tw:rounded-md tw:border tw:px-3 tw:py-2 tw:text-xs tw:font-medium tw:text-center tw:leading-snug tw:transition-colors tw:duration-200 tw:ease-standard',
        FOCUS_RING,
        selected
          ? 'tw:border-gray-950 tw:bg-gray-950 tw:text-white'
          : 'tw:border-gray-300 tw:bg-white tw:text-gray-900 tw:cursor-pointer tw:hover:bg-gray-50'
      ].join(' ');

      var labelEl = document.createElement('span');
      labelEl.textContent = label;
      button.appendChild(labelEl);

      if (priceText) {
        var priceEl = document.createElement('span');
        priceEl.className = 'tw:text-xs tw:font-semibold tw:text-current';
        priceEl.textContent = priceText;
        button.appendChild(priceEl);
      }

      return button;
    }

    function appendLidEngravingModeButtons(parent, selectedMode) {
      var group = document.createElement('div');
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', 'Lid engraving mode');
      group.className = 'tw:flex tw:w-full tw:flex-wrap tw:gap-1.5';
      group.appendChild(createEngravingModeButton(
        'data-lid-engraving-mode',
        'CUSTOM',
        'Add Custom Lid Engraving Text',
        formatAddonButtonPrice(lidVariant),
        selectedMode === 'CUSTOM'
      ));
      group.appendChild(createEngravingModeButton(
        'data-lid-engraving-mode',
        'NONE',
        'Skip! No Engravings On the Lids',
        '',
        selectedMode === 'NONE'
      ));
      parent.appendChild(group);
    }

    function getPocketEngravingAddLabel(mode) {
      return mode === 'DOTW'
        ? 'Add Days of the Week Inside the Pockets'
        : 'Add Custom Pocket Engraving Text';
    }

    function appendPocketEngravingModeButtons(parent, mode, selectedMode) {
      var group = document.createElement('div');
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', 'Pocket engraving mode');
      group.className = 'tw:flex tw:w-full tw:flex-wrap tw:gap-1.5';
      group.appendChild(createEngravingModeButton(
        'data-pocket-engraving-mode',
        mode,
        getPocketEngravingAddLabel(mode),
        formatAddonButtonPrice(pocketVariant),
        selectedMode === mode
      ));
      group.appendChild(createEngravingModeButton(
        'data-pocket-engraving-mode',
        'NONE',
        'Skip! No Pocket Engravings',
        '',
        selectedMode === 'NONE'
      ));
      parent.appendChild(group);
    }

    function getLidMaxLength() {
      var normalized = normalizeAddonText(getSelectedSizeLabel());
      if (isTwoCaseFamily() || normalized.indexOf('weekly') !== -1 || normalized.indexOf('2 week') !== -1) return 12;
      return 3;
    }

    function getLidInputLabels() {
      var title = String(lidTitle || 'Lid engraving').trim();
      if (pickerState.family === 'ampm') return [
        'AM | MORNING = LEFT & BOTTOM SIDE',
        'PM | EVENING = RIGHT & TOP SIDE'
      ];
      if (pickerState.family === 'two_week') {
        return isTwoSideComponentFlow()
          ? getTwoWeekV3CaseLabels()
          : [
            'WEEK 1 = RIGHT & TOP SIDE',
            'Week 2 = LEFT & BOTTOM SIDE'
          ];
      }
      return [title];
    }

    function getLidInputCount() {
      return isTwoCaseFamily() ? 2 : 1;
    }

    function normalizeLidLabels(labels, count, maxLen) {
      var out = [];
      labels = Array.isArray(labels) ? labels : [];
      for (var i = 0; i < count; i++) {
        out.push(String(labels[i] || '').slice(0, maxLen));
      }
      return out;
    }

    function countNonEmpty(values) {
      var count = 0;
      values = Array.isArray(values) ? values : [];
      values.forEach(function (value) {
        if (String(value || '').trim()) count += 1;
      });
      return count;
    }

    function getLidValidationLabel(index) {
      var labels = getLidInputLabels();
      return String(labels[index] || ('Lid engraving ' + (index + 1))).replace(/\s+/g, ' ').trim();
    }

    function getLidValueValidationMessage(value, index, maxLen) {
      var text = String(value || '');
      var label = getLidValidationLabel(index);
      if (maxLen && text.length > maxLen) {
        return label + ' must be ' + maxLen + ' characters or fewer.';
      }
      if (!LID_ALLOWED_PATTERN.test(text)) {
        return label + ' contains unsupported characters. ' + LID_ALLOWED_DESCRIPTION;
      }
      return '';
    }

    function getLidInputValidationMessage() {
      var inputs = lidFieldsEl ? lidFieldsEl.querySelectorAll('[data-lid-input]') : [];
      var maxLen = getLidMaxLength();
      for (var i = 0; i < inputs.length; i++) {
        var message = getLidValueValidationMessage(inputs[i].value, i, maxLen);
        if (message) return message;
      }
      return '';
    }

    function updateLidCounter(input) {
      var counter = input && input.parentNode && input.parentNode.querySelector('[data-lid-counter]');
      var maxLen = parseInt(input && input.getAttribute('maxlength'), 10) || getLidMaxLength();
      var value = String(input && input.value || '');
      var invalid = !!getLidValueValidationMessage(value, parseInt(input && input.getAttribute('data-lid-index'), 10) || 0, maxLen);
      var atLimit = maxLen > 0 && value.length >= maxLen;
      if (counter) {
        counter.textContent = String(value.length) + '/' + maxLen;
        counter.classList.toggle('tw:text-red-700', invalid);
        counter.classList.toggle('tw:text-gray-900', !invalid && atLimit);
        counter.classList.toggle('tw:text-gray-500', !invalid && !atLimit);
      }
      if (input) {
        input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
        input.classList.toggle('tw:border-red-400', invalid);
        input.classList.toggle('tw:focus-visible:ring-red-500', invalid);
        input.classList.toggle('tw:border-gray-300', !invalid);
        input.classList.toggle('tw:focus-visible:ring-black', !invalid);
      }
    }

    function buildPocketDropdown(options, selectedValue) {
      var wrap = document.createElement('span');
      wrap.className = 'tw:relative tw:block tw:w-full';

      var select = document.createElement('select');
      select.setAttribute('data-pocket-value', '');
      select.className = [
        'tw:appearance-none', 'tw:m-0', 'tw:min-h-[38px]', 'tw:w-full',
        'tw:rounded-md', 'tw:border', 'tw:border-gray-300', 'tw:bg-white',
        'tw:pl-3', 'tw:pr-8', 'tw:text-xs', 'tw:cursor-pointer',
        'tw:transition-colors', 'tw:duration-fast', 'tw:ease-standard',
        'tw:hover:border-gray-400', 'tw:focus:outline-none'
      ].join(' ');
      select.style.backgroundImage = 'none';
      select.style.webkitAppearance = 'none';
      select.style.MozAppearance = 'none';
      select.style.appearance = 'none';

      options.forEach(function (option) {
        var opt = document.createElement('option');
        opt.value = option;
        opt.textContent = option;
        if (option === selectedValue) opt.selected = true;
        select.appendChild(opt);
      });
      wrap.appendChild(select);

      var chevron = document.createElement('span');
      chevron.setAttribute('aria-hidden', 'true');
      chevron.className = 'tw:pointer-events-none tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 tw:text-gray-500';
      chevron.innerHTML = '<svg class="tw:h-2 tw:w-3" viewBox="0 0 12 7" fill="none"><path d="M11 1L6 6L1 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      wrap.appendChild(chevron);

      return wrap;
    }

    function buildLidInput(index, labelText, value, placeholder, maxLen) {
      var row = document.createElement('label');
      row.className = 'tw:flex tw:min-w-0 tw:flex-col tw:mb-0';

      var content = document.createElement('span');
      content.className = 'tw:flex tw:min-w-0 tw:flex-col tw:gap-1';

      var label = document.createElement('span');
      label.className = 'tw:text-xs tw:font-bold tw:leading-tight tw:text-black';
      label.textContent = labelText;
      content.appendChild(label);

      var wrap = document.createElement('span');
      wrap.className = 'tw:relative tw:block';

      var input = document.createElement('input');
      input.type = 'text';
      input.setAttribute('data-lid-input', '');
      input.setAttribute('data-lid-index', String(index));
      input.maxLength = maxLen;
      input.placeholder = placeholder || '';
      input.value = value || '';
      input.className = 'tw:m-0 tw:min-h-[38px] tw:w-full tw:rounded-md tw:border tw:border-gray-300 tw:bg-white tw:pl-3 tw:pr-12 tw:text-xs tw:transition-colors tw:duration-fast tw:ease-standard tw:hover:border-gray-400';
      var counterId = 'combined-v2-lid-counter-' + cfg.sectionId + '-' + index;
      input.setAttribute('aria-describedby', counterId + ' combined-v2-lid-validation-' + cfg.sectionId);
      wrap.appendChild(input);

      var counter = document.createElement('span');
      counter.id = counterId;
      counter.setAttribute('data-lid-counter', '');
      counter.className = 'tw:pointer-events-none tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 tw:text-xs tw:tabular-nums tw:text-gray-500';
      wrap.appendChild(counter);

      content.appendChild(wrap);
      row.appendChild(content);
      updateLidCounter(input);
      return row;
    }

    function renderLidFields() {
      if (!lidFieldsEl) return;
      resolveAddOnVariants();
      var modeFieldsEl = lidModeFieldsEl || lidFieldsEl;
      if (lidModeFieldsEl) lidModeFieldsEl.innerHTML = '';
      lidFieldsEl.innerHTML = '';
      setValidationMessage(lidValidationEl, '');

      var count = getLidInputCount();
      var maxLen = getLidMaxLength();
      pickerState.lidEngraving = pickerState.lidEngraving || { mode: null, labels: [], variantId: null };
      pickerState.lidEngraving.labels = normalizeLidLabels(pickerState.lidEngraving.labels, count, maxLen);
      var lidMode = pickerState.lidEngraving.mode;

      if (!lidProduct) {
        pickerState.lidEngraving = { mode: 'NONE', labels: [], variantId: null };
        setLidPreviewRowVisible(false);
        renderLidBodyPreview();
        appendAddOnStatus(modeFieldsEl, 'Lid engraving is not configured.');
        return;
      }
      if (!lidVariant) {
        pickerState.lidEngraving = { mode: 'NONE', labels: [], variantId: null };
        setLidPreviewRowVisible(false);
        renderLidBodyPreview();
        appendAddOnStatus(modeFieldsEl, 'Lid engraving is not available for this size.');
        return;
      }

      appendLidEngravingModeButtons(modeFieldsEl, lidMode);
      if (lidMode !== 'CUSTOM') {
        if (lidMode === 'NONE') {
          pickerState.lidEngraving = { mode: 'NONE', labels: [], variantId: null };
        }
        setLidPreviewRowVisible(false);
        renderLidBodyPreview();
        return;
      }

      setLidPreviewRowVisible(true);
      var labels = getLidInputLabels();
      for (var i = 0; i < count; i++) {
        lidFieldsEl.appendChild(buildLidInput(
          i,
          labels[i] || 'Lid engraving',
          pickerState.lidEngraving.labels[i],
          i === 1 ? lidPlaceholderPm : lidPlaceholderAm,
          maxLen
        ));
      }
      renderLidBodyPreview();
    }

    function readLidInputs() {
      var inputs = lidFieldsEl ? lidFieldsEl.querySelectorAll('[data-lid-input]') : [];
      var values = [];
      for (var i = 0; i < inputs.length; i++) {
        values.push(String(inputs[i].value || '').trim());
      }
      return values;
    }

    function commitLidEngraving() {
      if (!pickerState.lidEngraving || !pickerState.lidEngraving.mode) {
        return { ok: false, message: 'Choose Add Custom Lid Engraving Text or Skip before confirming.' };
      }

      if (pickerState.lidEngraving.mode === 'NONE') {
        pickerState.lidEngraving = { mode: 'NONE', labels: normalizeLidLabels([], getLidInputCount(), getLidMaxLength()), variantId: null };
        return { ok: true, summary: 'No engraving' };
      }

      var labels = readLidInputs();
      var maxLen = getLidMaxLength();
      var fieldMessage = getLidInputValidationMessage();
      if (fieldMessage) return { ok: false, message: fieldMessage };

      var selectedCount = countNonEmpty(labels);
      if (!selectedCount) {
        return { ok: false, message: 'Enter lid engraving text, or choose Skip if you do not want lid engraving.' };
      }
      if (!lidVariant) {
        return { ok: false, message: 'Lid engraving is not available for this size.' };
      }

      pickerState.lidEngraving = {
        mode: 'CUSTOM',
        labels: normalizeLidLabels(labels, getLidInputCount(), maxLen),
        variantId: String(lidVariant.id || '')
      };
      return {
        ok: true,
        summary: selectedCount === 1 ? '1 lid engraving' : selectedCount + ' lid engravings'
      };
    }

    function getPocketKind() {
      if (pickerState.family === 'ampm') return 'ampm';
      if (pickerState.family === 'two_week') return 'two_week';
      var normalized = normalizeAddonText(getSelectedSizeLabel());
      if (normalized.indexOf('weekly') !== -1) return 'weekly';
      if (normalized.indexOf('mission') !== -1) return 'mission';
      return 'nano';
    }

    function getPocketOptions(kind) {
      if (kind === 'mission') return MISSION_POCKET_OPTIONS;
      if (kind === 'weekly' || kind === 'ampm' || kind === 'two_week') return DOTW_DAYS;
      return NANO_POCKET_OPTIONS;
    }

    function getPocketMode(kind) {
      return (kind === 'weekly' || kind === 'ampm' || kind === 'two_week') ? 'DOTW' : 'CUSTOM';
    }

    function getLidHelpText() {
      if (lidHelpCopy) return lidHelpCopy;

      var kind = getPocketKind();
      return (kind === 'weekly' || kind === 'ampm' || kind === 'two_week') ? LID_HELP_COPY.long : LID_HELP_COPY.short;
    }

    function getPocketHelpText() {
      if (pocketHelpCopy) return pocketHelpCopy;

      var kind = getPocketKind();
      if (kind === 'mission') return POCKET_HELP_COPY.mission;
      if (kind === 'nano') return POCKET_HELP_COPY.nano;
      return POCKET_HELP_COPY.dotw;
    }

    function renderEngravingHelpText() {
      if (lidHelpTextEl) lidHelpTextEl.textContent = getLidHelpText();
      if (pocketHelpTextEl) pocketHelpTextEl.textContent = getPocketHelpText();
    }

    function renderPocketFields() {
      if (!pocketFieldsEl) return;
      resolveAddOnVariants();
      pocketFieldsEl.innerHTML = '';
      setValidationMessage(pocketValidationEl, '');

      if (!pocketProduct) {
        pickerState.pocketEngraving = { mode: 'NONE', value: '', variantId: null };
        renderPocketBodyPreview();
        appendAddOnStatus(pocketFieldsEl, 'Pocket engraving is not configured.');
        return;
      }
      if (!pocketVariant) {
        pickerState.pocketEngraving = { mode: 'NONE', value: '', variantId: null };
        renderPocketBodyPreview();
        appendAddOnStatus(pocketFieldsEl, 'Pocket engraving is not available for this size.');
        return;
      }

      var kind = getPocketKind();
      var options = getPocketOptions(kind);
      var mode = getPocketMode(kind);
      pickerState.pocketEngraving = pickerState.pocketEngraving || { mode: null, value: '', variantId: null };
      var selectedMode = pickerState.pocketEngraving.mode;
      var selectedValue = pickerState.pocketEngraving.value;
      if (selectedMode === mode) {
        if (options.indexOf(selectedValue) === -1) selectedValue = options[0] || '';
      } else {
        selectedValue = '';
      }

      appendPocketEngravingModeButtons(pocketFieldsEl, mode, selectedMode);
      if (selectedMode !== mode) {
        if (selectedMode === 'NONE') {
          pickerState.pocketEngraving = { mode: 'NONE', value: '', variantId: null };
        }
        renderPocketBodyPreview();
        return;
      }

      var selectLabel = document.createElement('label');
      selectLabel.className = 'tw:flex tw:w-full tw:max-w-full tw:flex-col tw:gap-1 tw:sm:w-64 tw:mb-0';
      var labelText = document.createElement('span');
      labelText.className = 'tw:text-xs tw:font-bold tw:text-black';
      labelText.textContent = mode === 'DOTW' ? 'Select start day:' : 'Select from options:';
      selectLabel.appendChild(labelText);
      selectLabel.appendChild(buildPocketDropdown(options, selectedValue));
      pocketFieldsEl.appendChild(selectLabel);

      pickerState.pocketEngraving = {
        mode: mode,
        value: selectedValue,
        variantId: selectedValue && pocketVariant ? String(pocketVariant.id || '') : null
      };
      renderPocketBodyPreview();
    }

    function commitPocketEngraving() {
      var select = pocketFieldsEl && pocketFieldsEl.querySelector('[data-pocket-value]');
      if (!pickerState.pocketEngraving || !pickerState.pocketEngraving.mode) {
        return { ok: false, message: 'Choose ' + getPocketEngravingAddLabel(getPocketMode(getPocketKind())) + ' or Skip before confirming.' };
      }

      if (pickerState.pocketEngraving.mode === 'NONE') {
        pickerState.pocketEngraving = { mode: 'NONE', value: '', variantId: null };
        return { ok: true, summary: 'No engraving' };
      }
      if (!pocketVariant) {
        return { ok: false, message: 'Pocket engraving is not available for this size.' };
      }

      var kind = getPocketKind();
      var mode = getPocketMode(kind);
      var options = getPocketOptions(kind);
      var value = select ? select.value : '';
      if (options.indexOf(value) === -1) {
        return { ok: false, message: 'Choose a valid pocket engraving option.' };
      }

      pickerState.pocketEngraving = {
        mode: mode,
        value: value,
        variantId: String(pocketVariant.id || '')
      };
      return { ok: true, summary: value };
    }

    function isStepSkipped(step) {
      var el = getStepEl(step);
      return !!(el && el.getAttribute('data-skipped') === 'true');
    }

    function setStepSkipped(step, skipped) {
      var el = getStepEl(step);
      if (!el) return;
      el.setAttribute('data-skipped', skipped ? 'true' : 'false');
      el.classList.toggle('tw:hidden', !!skipped);
      if (skipped) {
        setStepBodyVisible(step, false);
        el.setAttribute('data-active', 'false');
        if (pickerState.expandedStep === step) pickerState.expandedStep = null;
        pickerState.touchedSteps[step] = true;
        el.setAttribute('data-touched', 'true');
      }
      applyStepVisualState(step);
    }

    function getUltemPreviewKey() {
      if (!catalogMode) return '';
      var size = getSizeData(pickerState.size || pickerState.pendingSize);
      var family = getCatalogSizeFamily(size);
      if (family === 'ampm' || family === 'two_week') return 'two_case';

      var singleFamily = getAddonFamilyKey([
        size && size.family_key,
        size && size.label,
        size && size.target_handle
      ].filter(Boolean).join(' '));
      return singleFamily === 'nano' || singleFamily === 'mission' || singleFamily === 'weekly'
        ? singleFamily
        : '';
    }

    function applyUltemPreview() {
      if (!catalogMode || !ultemPreviewEl) return;
      var src = ultemPreviewImages[getUltemPreviewKey()] || ultemPreviewImages.default || '';
      if (src && ultemPreviewEl.getAttribute('src') !== src) {
        ultemPreviewEl.removeAttribute('srcset');
        ultemPreviewEl.setAttribute('src', src);
      } else if (!src) {
        ultemPreviewEl.removeAttribute('src');
        ultemPreviewEl.removeAttribute('srcset');
      }
      ultemPreviewEl.classList.toggle('tw:hidden', !src);
    }

    function getSwapUnavailableNote(reason) {
      var plural = isTwoCaseFamily();
      var colorName = String(swapState.detail || '').trim();
      if (reason === 'checking') return 'Checking Ultem stock...';
      if (reason === 'color') {
        return colorName
          ? 'Ultem isn\'t available in ' + colorName + ' for this size.'
          : 'Ultem isn\'t available in this color for this size.';
      }
      if (reason === 'soldout') {
        return colorName
          ? 'The Ultem case in ' + colorName + ' is sold out. It comes back as soon as stock arrives.'
          : 'This Ultem case is sold out. It comes back as soon as stock arrives.';
      }
      if (reason === 'engraving') {
        return 'Ultem lid engraving isn\'t available for this size, so the swap can\'t include your engraving.';
      }
      if (reason === 'error') return 'Ultem stock could not be checked. Please try again.';
      if (reason === 'incomplete') return plural ? 'Choose both colors to see the Ultem swap.' : 'Choose a color to see the Ultem swap.';
      return '';
    }

    function applyUltemVisual() {
      var mode = getUltemMode();
      var plural = isTwoCaseFamily();
      var copyMode = plural ? 'plural' : 'singular';
      applyUltemPreview();
      var stepLabel = root.querySelector('[data-step-label="ultem"]');
      if (stepLabel) stepLabel.textContent = plural ? 'Add Ultem Lids' : 'Add Ultem Lid';
      root.querySelectorAll('[data-ultem-copy]').forEach(function (copy) {
        copy.classList.toggle('tw:hidden', copy.getAttribute('data-ultem-copy') !== copyMode);
      });

      var swapSupported = isSwapSupportedForSize();
      var swapReason = swapSupported ? getSwapBlockReason() : 'unsupported';
      var swapSelectable = swapReason === '';
      var deltaCents = swapSelectable ? getSwapDeltaCents() : null;

      if (ultemSwapLabelEl) {
        ultemSwapLabelEl.textContent = swapReason === 'soldout'
          ? (plural ? 'Ultem Lids - Sold out' : 'Ultem Lid - Sold out')
          : (plural ? 'Swap to Ultem Lids' : 'Swap to Ultem Lid');
      }
      if (ultemSwapPriceEl) {
        ultemSwapPriceEl.textContent = deltaCents === null || deltaCents === 0
          ? ''
          : (deltaCents > 0 ? '(+' + formatMoneySafe(deltaCents) + ')' : '(-' + formatMoneySafe(Math.abs(deltaCents)) + ')');
      }
      if (ultemAddLabelEl) {
        ultemAddLabelEl.textContent = plural ? 'Add Extra Ultem Lids - Set of 2' : 'Add Extra Ultem Lid';
      }
      if (ultemPriceEl) {
        ultemPriceEl.textContent = formatAddonButtonPrice(ultemVariant);
      }
      if (ultemNoteEl) {
        // Swap stays visible when it is sold out or missing a color, so the
        // shopper can see why, and it opens up by itself once stock arrives.
        var note = swapSupported && mode !== 'SWAP' ? getSwapUnavailableNote(swapReason) : '';
        ultemNoteEl.textContent = note;
        ultemNoteEl.classList.toggle('tw:hidden', !note);
      }

      root.querySelectorAll('[data-ultem-option]').forEach(function (button) {
        var option = button.getAttribute('data-ultem-option');
        var isActive = (option === 'yes' && mode === 'ADD')
          || (option === 'swap' && mode === 'SWAP')
          || (option === 'no' && mode === 'NONE');
        var disabled = option === 'yes' ? !ultemVariant : (option === 'swap' ? !swapSelectable : false);
        var hidden = option === 'swap'
          ? !swapSupported
          : (option === 'yes' ? !ultemVariant && swapSupported : false);

        button.disabled = disabled;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.classList.toggle('tw:hidden', hidden);
        button.classList.toggle('tw:flex', !hidden);
        button.classList.toggle('tw:border-gray-950', isActive);
        button.classList.toggle('tw:bg-gray-950', isActive);
        button.classList.toggle('tw:text-white', isActive);
        button.classList.toggle('tw:border-gray-300', !isActive);
        button.classList.toggle('tw:bg-white', !isActive);
        button.classList.toggle('tw:text-gray-900', !isActive);
        button.classList.toggle('tw:cursor-not-allowed', disabled);
        button.classList.toggle('tw:cursor-pointer', !disabled);
        button.classList.toggle('tw:opacity-40', disabled);
        button.classList.toggle('tw:hover:bg-gray-50', !disabled && !isActive);
      });
    }

    function getUltemSummaryText() {
      var mode = getUltemMode();
      if (mode === 'SWAP') return isTwoCaseFamily() ? 'Swapped to Ultem Lids' : 'Swapped to Ultem Lid';
      if (mode === 'ADD') return isTwoCaseFamily() ? 'Yes, Add Ultem Lids' : 'Yes, Add Ultem Lid';
      return 'No, Thanks';
    }

    function renderUltemStep() {
      resolveAddOnVariants();
      var skipped = shouldSkipUltemStep();
      setStepSkipped('5', skipped);

      if (skipped) {
        setUltemMode('NONE');
        applyUltemVisual();
        setStepSummary('5', '');
        syncGiftStep();
        return;
      }

      setUltemMode(getUltemMode());
      applyUltemVisual();
      syncGiftStep();

      // Resolving Ultem stock is a fetch, so render again when it lands. A
      // stale response is dropped inside ensureSwapResolution, by key.
      ensureSwapResolution().then(function () {
        if (getUltemMode() === 'SWAP' && !isSwapSelectable()) {
          setUltemMode('NONE');
          setStepTouched('5', false);
          setStepSummary('5', '');
          refreshPriceDisplay();
        }
        applyUltemVisual();
        renderShellState();
      });
    }

    function collapseAll() {
      stepOrder.forEach(function (step) {
        var el = getStepEl(step);
        if (!el) return;
        el.setAttribute('data-active', 'false');
        setStepBodyVisible(step, false);
        applyStepVisualState(step);
      });
      pickerState.expandedStep = null;
    }

    function expandStep(step, options) {
      options = options || {};
      var el = getStepEl(step);
      if (!el || el.getAttribute('data-locked') === 'true') return;
      collapseAll();
      el.setAttribute('data-active', 'true');
      setStepBodyVisible(step, true);
      pickerState.expandedStep = step;
      applyStepVisualState(step);
      if (step === '1') fetchSizes();
      if (step === '2' && pickerState.family === 'single') fetchSingleColors();
      if (step === '2' && isTwoCaseFamily()) fetchFirstColors();
      if (step === '3') renderLidFields();
      if (step === '4') {
        renderPocketFields();
        if (!pickerState.touchedSteps['4'] && !pickerState.pocketSummaryShown && isTwoCaseFamily()) {
          renderPocketStepSummary({ blankPreview: true });
        }
      }
      if (step === '5') renderUltemStep();
      renderShellState();
      if (options.focusHeader) focusStepHeader(step);
    }

    function resetStepsAfter(step) {
      var start = parseInt(step, 10) + 1;
      if (start <= 2) {
        pickerState.firstColor = null;
        pickerState.secondColor = null;
        pickerState.selectedVariant = null;
        pickerState.colorSummaryShown = false;
        clearTwoSideComponentSelection();
        resetGallerySelectionPreview();
        colorPayload = null;
        colorCatalog = [];
        colorFetchPromise = null;
        colorFetchLoading = false;
        colorFetchError = '';
        colorFetchSize = null;
        firstColorPayload = null;
        firstColorCatalog = [];
        firstColorFetchPromise = null;
        firstColorFetchLoading = false;
        firstColorFetchError = '';
        firstColorFetchSize = null;
        clearTwoCaseSecondColors();
        setValidationMessage(colorValidationEl, '');
        root.removeAttribute('data-selected-variant-id');
        renderColorRows();
      }
      if (start <= 3) {
        pickerState.lidEngraving = { mode: null, labels: [], variantId: null };
        pickerState.lidSummaryShown = false;
        updateGalleryLidPreview();
        if (lidModeFieldsEl) lidModeFieldsEl.innerHTML = '';
        if (lidFieldsEl) lidFieldsEl.innerHTML = '';
        if (lidBodyPreviewEl) lidBodyPreviewEl.innerHTML = '';
        setLidPreviewRowVisible(false);
        setValidationMessage(lidValidationEl, '');
      }
      if (start <= 4) {
        pickerState.pocketEngraving = { mode: null, value: '', variantId: null };
        pickerState.pocketSummaryShown = false;
        if (pocketFieldsEl) pocketFieldsEl.innerHTML = '';
        if (pocketBodyPreviewEl) pocketBodyPreviewEl.innerHTML = '';
        setValidationMessage(pocketValidationEl, '');
      }
      if (start <= 5) {
        setUltemMode('NONE');
        if (start <= 3) resetSwapResolution();
        resolveAddOnVariants();
        applyUltemVisual();
        setStepSkipped('5', shouldSkipUltemStep());
      }
      stepOrder.forEach(function (candidate) {
        if (parseInt(candidate, 10) < start) return;
        setStepTouched(candidate, false);
        setStepSummary(candidate, '');
        setStepLocked(candidate, true);
      });
      refreshAddToCart();
    }

    function allStepsTouched() {
      return stepOrder.every(function (step) {
        return step === '6' || isStepSkipped(step) || !!pickerState.touchedSteps[step];
      });
    }

    function syncGiftStep() {
      if (!giftConfig) return;
      var giftStep = getStepEl('6');
      if (!giftStep) return;
      var unlocked = !!pickerState.touchedSteps['4']
        && (isStepSkipped('5') || !!pickerState.touchedSteps['5']);
      if ((giftStep.getAttribute('data-locked') === 'true') === unlocked) {
        setStepLocked('6', !unlocked);
      }
      var number = giftStep.querySelector('[data-badge-number]');
      if (number) number.textContent = isStepSkipped('5') ? '5.' : '6.';
    }

    function advanceAfterUltem() {
      if (!giftConfig) {
        collapseAll();
        return;
      }
      setStepLocked('6', false);
      expandStep('6', { focusHeader: true });
    }

    function selectedGift() {
      if (!giftConfig) return { skipped: true };
      if (!giftSelect) return null;
      var id = String(giftSelect.value || '');
      if (id === 'none' && giftConfig.optional) return { skipped: true };
      return (giftConfig.variantIds || []).some(function (allowed) { return String(allowed) === id; })
        ? { id: id }
        : null;
    }

    function isCaseReady() {
      var hasSelectedVariant = !!(pickerState.selectedVariant && pickerState.selectedVariant.id && pickerState.selectedVariant.available);
      if (!allStepsTouched() || !hasSelectedVariant) return false;
      // A Swap must still be resolvable; the aluminum variant above is only
      // what the gallery and the color step are showing.
      if (getUltemMode() === 'SWAP' && !isSwapSelectable()) return false;
      if (isTwoSideComponentFlow()) {
        var components = pickerState.twoSideComponents || resolveTwoSideComponentVariants();
        return !!(components && components.ready);
      }
      return true;
    }

    function isAtcReady() {
      return !creatorCartUncertain && isCaseReady()
        && (!giftConfig || (!!pickerState.touchedSteps['6'] && !!selectedGift()));
    }

    function refreshAddToCart() {
      if (configurationError) {
        if (addToCartSpinner) addToCartSpinner.classList.add('tw:hidden');
        if (addToCartButton) addToCartButton.disabled = true;
        if (addToCartLabel) addToCartLabel.textContent = 'Product unavailable';
        setAddToCartMessage(configurationError, 'error');
        return;
      }
      var ready = isAtcReady();
      if (addToCartSpinner) addToCartSpinner.classList.add('tw:hidden');
      if (addToCartButton) addToCartButton.disabled = !ready;
      if (addToCartLabel) addToCartLabel.textContent = creatorCartUncertain
        ? 'View Cart'
        : ready ? 'Add to Cart' : isCaseReady() && giftConfig
          ? selectedGift() ? 'Confirm Your Free Item' : 'Choose Your Free Item'
          : 'Configure Your Case First';
      if (creatorCartUncertain) return;
      if (addToCartError) {
        addToCartError.classList.add('tw:hidden');
        addToCartError.setAttribute('aria-hidden', 'true');
      }
      if (addToCartMessage) addToCartMessage.textContent = '';
    }

    function getColorSummary() {
      if (isTwoCaseFamily()) {
        var firstColor = getFirstColorData(pickerState.firstColor);
        var secondColor = getSecondColorData(pickerState.secondColor);
        var firstLabel = firstColor ? getColorDisplayName(firstColor) : formatKey(pickerState.firstColor);
        var secondLabel = secondColor ? getColorDisplayName(secondColor) : formatKey(pickerState.secondColor);
        if (pickerState.firstColor && pickerState.secondColor) {
          return firstLabel + ' / ' + secondLabel;
        }
        if (pickerState.firstColor) return firstLabel;
      }
      if (pickerState.firstColor) {
        var selectedColor = getColorData(pickerState.firstColor);
        return selectedColor ? getColorDisplayName(selectedColor) : formatKey(pickerState.firstColor);
      }
      return 'Ready';
    }

    function renderShellState() {
      var preselect = pickerState.urlPreselect;

      if (preselect && preselect.raw) {
        root.setAttribute('data-url-preselect', preselect.raw);
      }
      renderCaseSpecs();
      renderEngravingHelpText();
      refreshPriceDisplay();
      refreshStockDisplay();
      syncGiftStep();
      updateConfirmButtons();
      refreshAddToCart();
    }

    function updateConfirmButtons() {
      var sizeConfirm = root.querySelector('[data-step-confirm="1"]');
      var pendingSize = getSizeData(pickerState.pendingSize);
      if (sizeConfirm) sizeConfirm.disabled = !!sizeFetchLoading || !!sizeFetchError || !pendingSize || !!pendingSize.sold_out;
      var colorConfirm = root.querySelector('[data-step-confirm="2"]');
      if (colorConfirm) {
        if (pickerState.family === 'single') {
          var selectedColor = getColorData(pickerState.firstColor);
          colorConfirm.disabled = !!colorFetchLoading || !!colorFetchError || !selectedColor || !!selectedColor.sold_out || !selectedColor.variant;
        } else if (isTwoCaseFamily()) {
          var selectedFirstColor = getFirstColorData(pickerState.firstColor);
          var selectedSecondColor = getSecondColorData(pickerState.secondColor);
          colorConfirm.disabled = !!firstColorFetchLoading || !!secondColorFetchLoading || !!firstColorFetchError || !!secondColorFetchError || !selectedFirstColor || !!selectedFirstColor.sold_out || !selectedSecondColor || !!selectedSecondColor.sold_out || !selectedSecondColor.variant;
        } else {
          colorConfirm.disabled = false;
        }
      }
      var lidConfirm = root.querySelector('[data-step-confirm="3"]');
      if (lidConfirm) {
        lidConfirm.disabled = !pickerState.size || !pickerState.selectedVariant;
      }
      var pocketConfirm = root.querySelector('[data-step-confirm="4"]');
      if (pocketConfirm) {
        pocketConfirm.disabled = !pickerState.size || !pickerState.selectedVariant;
      }
      var ultemConfirm = root.querySelector('[data-step-confirm="5"]');
      if (ultemConfirm) {
        ultemConfirm.disabled = isStepSkipped('5') || !pickerState.size || !pickerState.selectedVariant;
      }
      var giftConfirm = root.querySelector('[data-step-confirm="6"]');
      if (giftConfirm) giftConfirm.disabled = !selectedGift();
    }

    function getSelectedFirstColorName() {
      if (isTwoCaseFamily()) {
        var first = getFirstColorData(pickerState.firstColor);
        return first ? getColorDisplayName(first) : formatKey(pickerState.firstColor);
      }
      var color = getColorData(pickerState.firstColor);
      return color ? getColorDisplayName(color) : formatKey(pickerState.firstColor);
    }

    function getSelectedSecondColorName() {
      var second = getSecondColorData(pickerState.secondColor);
      return second ? getColorDisplayName(second) : formatKey(pickerState.secondColor);
    }

    function setNotifyMessage(text, tone) {
      if (!notifyMessageEl) return;
      notifyMessageEl.textContent = text || '';
      notifyMessageEl.classList.toggle('tw:hidden', !text);
      notifyMessageEl.classList.remove('tw:text-red-700', 'tw:text-green-700', 'tw:text-gray-600');
      if (!text) return;
      notifyMessageEl.classList.add(tone === 'success' ? 'tw:text-green-700' : (tone === 'error' ? 'tw:text-red-700' : 'tw:text-gray-600'));
    }

    function setNotifySubmitting(isSubmitting) {
      notifySubmitting = !!isSubmitting;
      syncNotifySubmit();
    }

    function findNotifyColor(colors, key) {
      return colors.find(function (color) { return color.value === key; }) || null;
    }

    function isNotifySelectionEligible() {
      var size = notifySizeSelect && notifySizeSelect.value;
      if (!size || size !== notifyLookupSize) return false;
      var firstKey = notifyFirstColorSelect && notifyFirstColorSelect.value;
      var first = findNotifyColor(isTwoCaseFamily() ? notifyFirstColors : notifySingleColors, firstKey);
      if (!first) return false;
      if (!isTwoCaseFamily()) return first.status === 'signable';
      var second = findNotifyColor(notifySecondColors, notifySecondColorSelect && notifySecondColorSelect.value);
      if (!second || notifySecondFirstColor !== firstKey) return false;
      return (first.status === 'available' || first.status === 'signable')
        && (second.status === 'available' || second.status === 'signable')
        && (first.status === 'signable' || second.status === 'signable');
    }

    function syncNotifySubmit() {
      if (!notifySubmitBtn) return;
      notifySubmitBtn.disabled = notifySubmitting || sizeFetchLoading || notifyFirstLoading || notifySecondLoading || !isNotifySelectionEligible();
      notifySubmitBtn.textContent = notifySubmitting ? 'Sending...' : 'Notify me';
    }

    function syncNotifySelectTone(select) {
      if (!select) return;
      var isPromptSelected = !select.value;
      select.classList.toggle('tw:text-gray-400', isPromptSelected);
      select.classList.toggle('tw:text-gray-900', !isPromptSelected);
    }

    function setNotifyOptions(select, options, placeholder, selectedValue) {
      if (!select) return;
      select.innerHTML = '';
      if (placeholder) {
        var placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = placeholder;
        placeholderOption.className = 'tw:text-gray-400';
        select.appendChild(placeholderOption);
      }
      (options || []).forEach(function (option) {
        if (!option || !option.value) return;
        var opt = document.createElement('option');
        opt.value = option.value;
        opt.textContent = option.label + (option.soldOut ? ' (Sold out)' : '');
        opt.setAttribute('data-label', option.label);
        if (option.soldOut) opt.setAttribute('data-sold-out', 'true');
        opt.className = 'tw:text-gray-900';
        if (selectedValue && option.value === selectedValue) opt.selected = true;
        select.appendChild(opt);
      });
      select.disabled = !options || !options.length;
      syncNotifySelectTone(select);
    }

    function setNotifyPlaceholder(select, placeholder) {
      setNotifyOptions(select, [], placeholder || 'No options loaded', '');
    }

    function getNotifySelectedLabel(select) {
      if (!select || !select.value || select.selectedIndex < 0) return '';
      var option = select.options[select.selectedIndex];
      return (option && option.getAttribute('data-label')) || (option ? String(option.textContent || '').replace(/\s+\(Sold out\)$/, '') : '');
    }

    function pickNotifyValue(choices, preferredValue) {
      var preferred = String(preferredValue || '');
      if (preferred && choices.some(function (choice) { return choice.value === preferred; })) return preferred;
      for (var i = 0; i < choices.length; i++) {
        if (choices[i] && choices[i].soldOut) return choices[i].value;
      }
      return choices.length ? choices[0].value : '';
    }

    function pickNotifyColorValue(choices, preferredValue, label, lookup) {
      if (!notifyRequestedColorsOnly) return pickNotifyValue(choices, preferredValue);
      var preferred = String(preferredValue || '');
      if (!preferred) return '';
      if (choices.some(function (choice) { return choice.value === preferred; })) return preferred;
      var requested = findNotifyColor(lookup, preferred);
      if (requested && requested.status === 'available') {
        setNotifyMessage(requested.label + ' is in stock. You can order it now.', 'neutral');
      } else if (requested && requested.status === 'blocked') {
        setNotifyMessage('Restock alerts aren\'t available for ' + requested.label + '.', 'neutral');
      } else {
        setNotifyMessage('The requested ' + label.toLowerCase() + ' is no longer listed for this selection. Please choose another color.', 'error');
      }
      return '';
    }

    function getNotifySizes() {
      return sizeCatalog.map(function (size) {
        return {
          value: size.key,
          label: getSizePresentationName(size),
          soldOut: !!size.sold_out
        };
      });
    }

    function getNotifySizeLabel(sizeKey) {
      var size = getSizeData(sizeKey);
      return size ? getSizePresentationName(size) : formatKey(sizeKey);
    }

    function getNotifyProductName() {
      var sizeKey = notifySizeSelect ? notifySizeSelect.value : '';
      if (!sizeKey) return '';
      var size = getSizeData(sizeKey);
      // Display labels may be abbreviated. The raw catalog label and key
      // describe the requested case, independently of the purchase selection.
      var sizeLabel = String((size && size.label) || formatKey(sizeKey)).trim();
      var sizeText = sizeLabel + ' ' + sizeKey;
      var familyKey = getAddonFamilyKey(sizeText)
        || (isTwoCaseFamily() ? pickerState.family : getAddonFamilyKey(productTitle));
      var familyLabel = {
        weekly: 'Weekly',
        mission: 'Mission',
        ampm: 'Weekly AM-PM',
        two_week: '2-Week',
        nano: 'Nano'
      }[familyKey] || '';
      var caseType = {
        pill: 'Pill Case',
        vitamin: 'Vitamin Case',
        'vitamin-xl': 'Vitamin XL Case'
      }[getAddonSizeKey(sizeText)];
      if (caseType) return [familyLabel, caseType].filter(Boolean).join(' ');
      // Preserve explicit names for other case sizes, including their family
      // when already present, rather than guessing a standard case type.
      return getAddonFamilyKey(sizeLabel) || !familyLabel
        ? sizeLabel
        : familyLabel + ' ' + sizeLabel;
    }

    function getNotifyColors(payload) {
      if (!payload || payload.error || !Array.isArray(payload.colors)) return [];
      var seen = Object.create(null);
      var rows = payload.colors.concat((payload.notify_colors || []).map(function (color) {
        return { key: color.key, name: color.name, sold_out: true, bis: true };
      }));
      return rows.filter(function (color) {
        if (!color || !color.key || seen[color.key]) return false;
        seen[color.key] = true;
        return true;
      }).map(function (color) {
        return {
          value: color.key,
          label: getColorDisplayName(color),
          soldOut: !!color.sold_out,
          status: !color.sold_out ? 'available' : (color.bis === false ? 'blocked' : 'signable')
        };
      }).sort(function (a, b) {
        if (a.soldOut !== b.soldOut) return a.soldOut ? -1 : 1;
        var aLabel = String(a.label || '').toLowerCase();
        var bLabel = String(b.label || '').toLowerCase();
        if (aLabel < bLabel) return -1;
        if (aLabel > bLabel) return 1;
        return 0;
      });
    }

    function fetchNotifyColors(action, sizeKey, firstColorKey) {
      if (!window.theme || !theme.productDataFetcher || typeof theme.productDataFetcher.fetch !== 'function') {
        return Promise.resolve(null);
      }
      var args = null;
      if (action === 'colors') {
        args = buildColorFetchArgs('colors', sizeKey);
      }
      if (action === 'firstcolors') {
        args = buildColorFetchArgs('firstcolors', sizeKey);
      }
      if (action === 'secondcolors') {
        args = buildColorFetchArgs('secondcolors', sizeKey, firstColorKey);
      }
      if (!args) return Promise.resolve(null);
      return theme.productDataFetcher.fetch.apply(theme.productDataFetcher, args)
        .then(function (payload) {
          return requireMatchingListingContext(payload, 'notify colors');
        });
    }

    function getNotifyFirstLabel() {
      if (pickerState.family === 'ampm') return 'AM color';
      if (pickerState.family === 'two_week') return 'Week 1 color';
      return 'Color';
    }

    function getNotifySecondLabel() {
      if (pickerState.family === 'ampm') return 'PM color';
      if (pickerState.family === 'two_week') return 'Week 2 color';
      return 'Second color';
    }

    function getNotifyPrompt(label) {
      return label === 'Color' ? 'Select a color' : 'Select ' + label;
    }

    function syncNotifyLabels() {
      var twoCase = isTwoCaseFamily();
      if (notifyFirstColorLabelEl) notifyFirstColorLabelEl.textContent = getNotifyFirstLabel();
      if (notifySecondColorLabelEl) notifySecondColorLabelEl.textContent = getNotifySecondLabel();
      if (notifySecondColorField) {
        notifySecondColorField.classList.toggle('tw:hidden', !twoCase);
        notifySecondColorField.classList.toggle('tw:flex', twoCase);
      }
      if (notifySecondColorSelect) notifySecondColorSelect.required = twoCase;
    }

    function buildNotifyLabel() {
      var productName = getNotifyProductName();
      if (!productName) return '';
      var parts = [productName];
      var firstColor = getNotifySelectedLabel(notifyFirstColorSelect) || (notifyRequestedColorsOnly ? '' : getSelectedFirstColorName());
      var secondColor = getNotifySelectedLabel(notifySecondColorSelect) || (notifyRequestedColorsOnly ? '' : getSelectedSecondColorName());
      if (firstColor) parts.push(isTwoCaseFamily() ? getTwoCaseSummaryLabels()[0] + ': ' + firstColor : firstColor);
      if (isTwoCaseFamily() && secondColor) parts.push(getTwoCaseSummaryLabels()[1] + ': ' + secondColor);
      return parts.filter(Boolean).join(' / ');
    }

    function syncNotifyFields() {
      syncNotifySelectTone(notifySizeSelect);
      syncNotifySelectTone(notifyFirstColorSelect);
      syncNotifySelectTone(notifySecondColorSelect);
      var design = buildNotifyLabel();
      var size = getNotifySelectedLabel(notifySizeSelect);
      var firstColor = getNotifySelectedLabel(notifyFirstColorSelect);
      var secondColor = getNotifySelectedLabel(notifySecondColorSelect);
      if (notifyProductInput) notifyProductInput.value = getNotifyProductName();
      if (notifyVariantLabelInput) notifyVariantLabelInput.value = design;
      if (notifyCaseSizeInput) notifyCaseSizeInput.value = size || '';
      if (notifyFirstColorInput) notifyFirstColorInput.value = firstColor || '';
      if (notifySecondColorInput) notifySecondColorInput.value = secondColor || '';
      if (notifyDesignInput) notifyDesignInput.value = design;
      if (notifyDateInput) notifyDateInput.value = new Date().toISOString().split('T')[0];
      if (notifyContextEl) {
        notifyContextEl.textContent = size && firstColor && (!isTwoCaseFamily() || secondColor)
          ? 'We will email you when ' + design + ' is available.'
          : 'Select the size and color you want us to track.';
      }
      syncNotifySubmit();
    }

    function loadNotifySecondColors(selectedSecondColor) {
      var token = ++notifySecondColorFetchToken;
      notifySecondLoading = false;
      notifySecondColors = [];
      notifySecondFirstColor = '';
      if (!isTwoCaseFamily() || !notifySecondColorSelect) {
        if (notifySecondColorSelect) setNotifyPlaceholder(notifySecondColorSelect, 'No second color needed');
        syncNotifyFields();
        return Promise.resolve(null);
      }

      var sizeKey = notifySizeSelect ? notifySizeSelect.value : '';
      var firstColorKey = notifyFirstColorSelect ? notifyFirstColorSelect.value : '';
      var first = findNotifyColor(notifyFirstColors, firstColorKey);
      if (!sizeKey || !first || first.status === 'blocked') {
        setNotifyPlaceholder(notifySecondColorSelect, 'Select the first color first');
        syncNotifyFields();
        return Promise.resolve(null);
      }

      notifySecondLoading = true;
      setNotifyPlaceholder(notifySecondColorSelect, 'Loading colors...');
      syncNotifyFields();
      return fetchNotifyColors('secondcolors', sizeKey, firstColorKey).then(function (payload) {
        if (token !== notifySecondColorFetchToken) return null;
        if (!payload || payload.error || !Array.isArray(payload.colors)) throw new Error('Could not load color options.');
        notifySecondColors = getNotifyColors(payload);
        notifySecondFirstColor = firstColorKey;
        notifySecondLoading = false;
        var choices = notifySecondColors.filter(function (color) {
          return color.status === 'signable' || (first.status === 'signable' && color.status === 'available');
        });
        var preferredValue = selectedSecondColor || (notifyRequestedColorsOnly ? '' : pickerState.secondColor);
        var selectedValue = pickNotifyColorValue(choices, preferredValue, getNotifySecondLabel(), notifySecondColors);
        setNotifyOptions(
          notifySecondColorSelect,
          choices,
          choices.length ? getNotifyPrompt(getNotifySecondLabel()) : 'No restock-alert colors pair with ' + first.label + '.',
          selectedValue
        );
        syncNotifyFields();
        return payload;
      }).catch(function (error) {
        if (token !== notifySecondColorFetchToken) return null;
        console.error('[combined-v2] notify second color fetch failed:', error);
        notifySecondLoading = false;
        notifySecondColors = [];
        notifySecondFirstColor = '';
        setNotifyPlaceholder(notifySecondColorSelect, 'Could not load colors');
        setNotifyMessage('Could not load color options. Please try again.', 'error');
        syncNotifyFields();
        return null;
      });
    }

    function loadNotifyColors(selectedFirstColor, selectedSecondColor) {
      var token = ++notifyColorFetchToken;
      notifySecondColorFetchToken += 1;
      notifyFirstLoading = false;
      notifySecondLoading = false;
      notifySingleColors = [];
      notifyFirstColors = [];
      notifySecondColors = [];
      notifyLookupSize = '';
      notifySecondFirstColor = '';
      if (!notifyFirstColorSelect) {
        syncNotifyFields();
        return Promise.resolve(null);
      }

      syncNotifyLabels();
      var sizeKey = notifySizeSelect ? notifySizeSelect.value : '';
      if (!sizeKey) {
        setNotifyPlaceholder(notifyFirstColorSelect, 'Select a size first');
        setNotifyPlaceholder(notifySecondColorSelect, 'Select the first color first');
        syncNotifyFields();
        return Promise.resolve(null);
      }

      var action = isTwoCaseFamily() ? 'firstcolors' : 'colors';
      notifyFirstLoading = true;
      setNotifyPlaceholder(notifyFirstColorSelect, isTwoCaseFamily() ? 'Loading first colors...' : 'Loading colors...');
      setNotifyPlaceholder(notifySecondColorSelect, isTwoCaseFamily() ? 'Select the first color first' : 'No second color needed');
      syncNotifyFields();

      return fetchNotifyColors(action, sizeKey).then(function (payload) {
        if (token !== notifyColorFetchToken) return null;
        if (!payload || payload.error || !Array.isArray(payload.colors)) throw new Error('Could not load color options.');
        var lookup = getNotifyColors(payload);
        notifyLookupSize = sizeKey;
        notifyFirstLoading = false;
        if (isTwoCaseFamily()) notifyFirstColors = lookup;
        else notifySingleColors = lookup;
        var choices = lookup.filter(function (color) {
          return color.status === 'signable' || (isTwoCaseFamily() && color.status === 'available');
        });
        var preferredValue = selectedFirstColor || (notifyRequestedColorsOnly ? '' : pickerState.firstColor);
        var selectedValue = pickNotifyColorValue(choices, preferredValue, getNotifyFirstLabel(), lookup);
        setNotifyOptions(
          notifyFirstColorSelect,
          choices,
          choices.length ? getNotifyPrompt(getNotifyFirstLabel()) : 'No colors in this size are open for restock alerts.',
          selectedValue
        );
        if (isTwoCaseFamily()) {
          return loadNotifySecondColors(selectedSecondColor);
        }
        syncNotifyFields();
        return payload;
      }).catch(function (error) {
        if (token !== notifyColorFetchToken) return null;
        console.error('[combined-v2] notify color fetch failed:', error);
        notifyFirstLoading = false;
        notifyLookupSize = '';
        notifySingleColors = [];
        notifyFirstColors = [];
        setNotifyPlaceholder(notifyFirstColorSelect, 'Could not load colors');
        setNotifyMessage('Could not load color options. Please try again.', 'error');
        syncNotifyFields();
        return null;
      });
    }

    function fillNotifyForm(options) {
      if (!notifyFormEl || !notifySizeSelect || !notifyFirstColorSelect) return;
      options = options || {};
      syncNotifyLabels();
      setNotifyMessage('', 'neutral');

      if (!sizePayload && !sizeCatalog.length && !sizeFetchError) {
        setNotifyPlaceholder(notifySizeSelect, 'Loading sizes...');
        setNotifyPlaceholder(notifyFirstColorSelect, 'Select a size first');
        setNotifyPlaceholder(notifySecondColorSelect, 'Select the first color first');
        syncNotifyFields();
        var sessionToken = notifySessionToken;
        var pendingSizes = sizeFetchPromise || fetchSizes();
        pendingSizes.then(function () {
          if (sessionToken !== notifySessionToken) return;
          fillNotifyForm(options);
        });
        return;
      }

      var sizeChoices = getNotifySizes();
      var selectedSize = options.caseSize || pickerState.size || pickerState.pendingSize || defaultSizeKey;
      if (selectedSize && !sizeChoices.some(function (choice) { return choice.value === selectedSize; })) {
        sizeChoices.push({ value: selectedSize, label: getNotifySizeLabel(selectedSize), soldOut: false });
      }
      var selectedSizeValue = pickNotifyValue(sizeChoices, selectedSize);
      setNotifyOptions(
        notifySizeSelect,
        sizeChoices,
        sizeChoices.length ? 'Select a case size' : 'No case sizes loaded',
        selectedSizeValue
      );
      if (!sizeChoices.length) {
        setNotifyMessage(sizeFetchError || 'Could not load case sizes. Please try again.', 'error');
      }
      loadNotifyColors(
        options.firstColor !== undefined ? options.firstColor : pickerState.firstColor,
        options.secondColor !== undefined ? options.secondColor : pickerState.secondColor
      );
    }

    function invalidateNotifyRequests() {
      notifySessionToken += 1;
      notifyColorFetchToken += 1;
      notifySecondColorFetchToken += 1;
      notifyFirstLoading = false;
      notifySecondLoading = false;
      notifySingleColors = [];
      notifyFirstColors = [];
      notifySecondColors = [];
      notifyLookupSize = '';
      notifySecondFirstColor = '';
      syncNotifySubmit();
    }

    function focusNotifyModal() {
      var fields = [notifySizeSelect, notifyFirstColorSelect, notifySecondColorSelect];
      var target = fields.find(function (field) {
        return field && !field.disabled && !field.value && field.getClientRects().length;
      });
      if (!target) target = notifyEmailInput || notifyModalEl.querySelector('[data-notify-close]');
      if (target) target.focus();
    }

    function trapNotifyFocus(event) {
      var focusable = Array.prototype.slice.call(notifyModalEl.querySelectorAll(
        'button:not([disabled]), select:not([disabled]), input:not([type="hidden"]):not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) { return element.getClientRects().length; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !notifyModalEl.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !notifyModalEl.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }

    function openNotifyModal(options) {
      if (!notifyModalEl) return;
      options = options || {};
      invalidateNotifyRequests();
      var sessionToken = notifySessionToken;
      notifyReturnFocusEl = options.returnFocus || document.activeElement;
      notifyRequestedColorsOnly = !!options.requestedColors;
      setNotifySubmitting(false);
      notifyModalEl.classList.remove('tw:hidden');
      notifyModalEl.setAttribute('data-open', 'true');
      fillNotifyForm(options);
      window.setTimeout(function () {
        if (sessionToken === notifySessionToken) focusNotifyModal();
      }, 0);
    }

    function openNotifyFromUrl() {
      var request = parseUrlPreselect('notify');
      if (!request || !notifyModalEl) return;
      fetchSizes().then(function () {
        var size = resolvePreselectedSize(request);
        openNotifyModal({
          caseSize: size ? size.key : '',
          firstColor: request.firstColorKey,
          secondColor: request.secondColorKey,
          requestedColors: true,
          returnFocus: root.querySelector('[data-notify-open]')
        });
      });
    }

    function closeNotifyModal() {
      if (!notifyModalEl) return;
      invalidateNotifyRequests();
      var sessionToken = notifySessionToken;
      notifyModalEl.classList.add('tw:hidden');
      notifyModalEl.removeAttribute('data-open');
      setNotifySubmitting(false);
      var returnFocus = notifyReturnFocusEl;
      notifyReturnFocusEl = null;
      window.setTimeout(function () {
        if (sessionToken === notifySessionToken && returnFocus && returnFocus.isConnected && typeof returnFocus.focus === 'function') {
          returnFocus.focus();
        }
      }, 0);
    }

    function validateNotifyResponse(response) {
      if (!response || response.result !== 'success') {
        throw new Error(response && response.error ? response.error : 'Back-in-stock request failed');
      }
      return response;
    }

    function submitNotifyData(data) {
      if (window.jQuery) {
        return new Promise(function (resolve, reject) {
          window.jQuery.ajax({
            url: NOTIFY_ENDPOINT,
            method: 'GET',
            dataType: 'json',
            data: data
          }).done(function (response) {
            try {
              resolve(validateNotifyResponse(response));
            } catch (error) {
              reject(error);
            }
          }).fail(reject);
        });
      }
      var params = new URLSearchParams(data);
      return fetch(NOTIFY_ENDPOINT + '?' + params.toString(), { method: 'GET' })
        .then(function (response) {
          if (!response.ok) throw new Error('Notify request failed: ' + response.status);
          return response.json();
        })
        .then(validateNotifyResponse);
    }

    function onNotifySubmit(event) {
      if (!notifyFormEl) return;
      event.preventDefault();
      if (notifySubmitting) return;
      syncNotifyFields();
      var design = notifyDesignInput ? String(notifyDesignInput.value || '').trim() : '';
      var size = notifySizeSelect ? String(notifySizeSelect.value || '').trim() : '';
      var firstColor = notifyFirstColorSelect ? String(notifyFirstColorSelect.value || '').trim() : '';
      var secondColor = notifySecondColorSelect ? String(notifySecondColorSelect.value || '').trim() : '';
      var email = notifyEmailInput ? String(notifyEmailInput.value || '').trim() : '';
      if (!size || !firstColor || (isTwoCaseFamily() && !secondColor) || !email) {
        setNotifyMessage(isTwoCaseFamily()
          ? 'Select the size, both colors, and enter your email address.'
          : 'Select the size and color, then enter your email address.', 'error');
        return;
      }
      if (sizeFetchLoading || notifyFirstLoading || notifySecondLoading || !isNotifySelectionEligible()) {
        setNotifyMessage('Choose a sold-out color that is open for restock alerts.', 'error');
        syncNotifySubmit();
        return;
      }
      var data = {
        Product: notifyProductInput ? notifyProductInput.value : getNotifyProductName(),
        ProductVariantLabel: notifyVariantLabelInput ? notifyVariantLabelInput.value : design,
        DesignDetails: design,
        CaseSize: notifyCaseSizeInput ? notifyCaseSizeInput.value : '',
        ColorVariant_1: notifyFirstColorInput ? notifyFirstColorInput.value : '',
        ColorVariant_2: notifySecondColorInput ? notifySecondColorInput.value : '',
        Date: notifyDateInput ? notifyDateInput.value : new Date().toISOString().split('T')[0],
        Email: email
      };
      setNotifySubmitting(true);
      setNotifyMessage('', 'neutral');
      var sessionToken = notifySessionToken;
      submitNotifyData(data).then(function () {
        if (sessionToken !== notifySessionToken) return;
        setNotifyMessage('Thank you. We will notify you when this design is back in stock.', 'success');
        if (notifyEmailInput) notifyEmailInput.value = '';
      }).catch(function (error) {
        if (sessionToken !== notifySessionToken) return;
        console.error('[combined-v2] notify submit failed:', error);
        setNotifyMessage('There was an error submitting your request. Please try again.', 'error');
      }).then(function () {
        if (sessionToken === notifySessionToken) setNotifySubmitting(false);
      }, function () {
        if (sessionToken === notifySessionToken) setNotifySubmitting(false);
      });
    }

    function getCombinedMode() {
      if (pickerState.family === 'ampm') return 'ap';
      if (pickerState.family === 'two_week') return '2w';
      return getPocketKind() === 'weekly' ? 'w' : '';
    }

    function getConfirmedLidLabels() {
      var maxLen = getLidMaxLength();
      return normalizeLidLabels((pickerState.lidEngraving && pickerState.lidEngraving.labels) || [], getLidInputCount(), maxLen);
    }

    function getCartAddonState() {
      resolveAddOnVariants();
      var lidLabels = getConfirmedLidLabels();
      var lidCount = countNonEmpty(lidLabels);
      var hasLid = lidCount > 0 && !!lidVariant;
      var hasPocket = !!(
        pocketVariant
        && pickerState.pocketEngraving
        && pickerState.pocketEngraving.mode !== 'NONE'
        && String(pickerState.pocketEngraving.value || '').trim()
      );
      var hasUltem = !!(ultemVariant && getUltemMode() === 'ADD');
      return {
        lidLabels: lidLabels,
        pocketValue: hasPocket ? String(pickerState.pocketEngraving.value || '').trim() : '',
        hasLid: hasLid,
        hasPocket: hasPocket,
        hasUltem: hasUltem,
        hasAny: hasLid || hasPocket || hasUltem
      };
    }

    function buildBundleMarker(bundleId, role) {
      var marker = BUNDLE_MARKER_PREFIX + ':' + String(bundleId);
      return role ? marker + ':' + role : marker;
    }

    function buildTwoSideBundleMarker(bundleId, role, parentVariantId) {
      var marker = TWO_SIDE_BUNDLE_MARKER_PREFIX + ':' + String(bundleId);
      if (parentVariantId) marker += ':' + String(parentVariantId);
      return role ? marker + ':' + role : marker;
    }

    function copyCartProperties(target, source) {
      Object.keys(source || {}).forEach(function (key) {
        var value = source[key];
        if (value != null && String(value).trim() !== '') {
          target[key] = value;
        }
      });
      return target;
    }

    function addMagneticSetProperty(properties, setNumber) {
      var result = Object.assign({}, properties || {});
      result['Magnetic Set #'] = String(setNumber);
      return result;
    }

    function buildVisibleProperties(addons) {
      var properties = {};
      var mode = getCombinedMode();
      var firstColor = getSelectedFirstColorName();
      var secondColor = getSelectedSecondColorName();
      var lidOne = addons.lidLabels[0] || '';
      var lidTwo = addons.lidLabels[1] || '';

      if (mode === 'ap') {
        if (firstColor) properties['AM - Left Side'] = firstColor;
        if (secondColor) properties['PM - Right Side'] = secondColor;
        if (lidOne) properties['AM - Left Side Lid Engraving'] = lidOne;
        if (lidTwo) properties['PM - Right Side Lid Engraving'] = lidTwo;
      } else if (mode === '2w') {
        if (firstColor) properties['Week 1 - Top & Right Case #1'] = firstColor;
        if (secondColor) properties['Week 2 - Bottom & Left Case #2'] = secondColor;
        if (lidOne) properties['Week 1 - Top & Right Case #1 Lid Engraving'] = lidOne;
        if (lidTwo) properties['Week 2 - Bottom & Left Case #2 Lid Engraving'] = lidTwo;
      } else if (lidOne) {
        properties['Lid Engraving'] = lidOne;
      }

      if (addons.pocketValue) {
        properties[mode === 'w' ? 'DOTW' : 'Pocket Engraving'] = addons.pocketValue;
      }

      return properties;
    }

    function buildTwoSideAddonVisibleProperties(addons, role) {
      var properties = {};
      var mode = getCombinedMode();
      var lidOne = addons.lidLabels[0] || '';
      var lidTwo = addons.lidLabels[1] || '';
      var twoWeekCaseLabels = getTwoWeekV3CaseLabels();

      if (role === 'lid') {
        if (mode === 'ap') {
          if (lidOne) properties['AM - Left Side Lid Engraving'] = lidOne;
          if (lidTwo) properties['PM - Right Side Lid Engraving'] = lidTwo;
        } else if (mode === '2w') {
          if (lidOne) properties[twoWeekCaseLabels[0] + ' Lid Engraving'] = lidOne;
          if (lidTwo) properties[twoWeekCaseLabels[1] + ' Lid Engraving'] = lidTwo;
        } else if (lidOne) {
          properties['Lid Engraving'] = lidOne;
        }
      } else if (role === 'pocket' && addons.pocketValue) {
        properties[mode === 'w' ? 'DOTW' : 'Pocket Engraving'] = addons.pocketValue;
      }

      return properties;
    }

    function buildTwoSideCaseVisibleProperties(addons, role) {
      var properties = {};
      if (!addons) return properties;

      var mode = getCombinedMode();
      var lidLabels = addons.lidLabels || [];
      var lidOne = lidLabels[0] || '';
      var lidTwo = lidLabels[1] || '';
      var twoWeekCaseLabels = getTwoWeekV3CaseLabels();

      if (addons.hasLid) {
        if (mode === 'ap') {
          if (role === 'am_case' && lidOne) properties['AM - Left Side Lid Engraving'] = lidOne;
          if (role === 'pm_case' && lidTwo) properties['PM - Right Side Lid Engraving'] = lidTwo;
        } else if (mode === '2w') {
          // Week 1 is the physical right/top SKU; Week 2 is the physical left/bottom SKU.
          if (role === 'week1_case' && lidOne) properties[twoWeekCaseLabels[0] + ' Lid Engraving'] = lidOne;
          if (role === 'week2_case' && lidTwo) properties[twoWeekCaseLabels[1] + ' Lid Engraving'] = lidTwo;
        }
      }

      if (addons.hasPocket && addons.pocketValue) {
        // Preserve the property names used by the legacy two-case products.
        properties[mode === 'ap' ? 'DOTW' : 'Pocket Engraving'] = addons.pocketValue;
      }

      return properties;
    }

    function buildAddonCartItem(variant, quantity, bundleId, role, markerBuilder, extraProperties) {
      if (!variant || !variant.id || !quantity) return null;
      var buildMarker = markerBuilder || buildBundleMarker;
      var properties = {
        _ikg_bundle: buildMarker(bundleId, role)
      };
      copyCartProperties(properties, extraProperties);
      return {
        id: parseInt(variant.id, 10) || variant.id,
        quantity: quantity,
        properties: properties
      };
    }

    function buildTwoSideCaseCartItem(variant, bundleId, role, parentVariantId, parentTitle, extraProperties) {
      if (!variant || !variant.id) return null;
      var properties = {
        _ikg_bundle: buildTwoSideBundleMarker(bundleId, role, parentVariantId)
      };
      if (parentTitle) properties._ikg_parent_title = parentTitle;
      copyCartProperties(properties, extraProperties);
      return {
        id: parseInt(variant.id, 10) || variant.id,
        quantity: 1,
        properties: properties
      };
    }

    function buildTwoSideCartItems(magneticSetNumber) {
      var components = pickerState.twoSideComponents || resolveTwoSideComponentVariants();
      if (!components || !components.ready) return null;
      if (!twoSideCart || twoSideCart.parseSetNumber(magneticSetNumber) == null) return null;

      var addons = getCartAddonState();
      var bundleId = twoSideCart.createBundleId();
      var parentVariantId = components.carrierVariant && components.carrierVariant.id ? components.carrierVariant.id : '';
      var buildTwoSideMarker = function (itemBundleId, role) {
        return buildTwoSideBundleMarker(itemBundleId, role, parentVariantId);
      };

      var items = [];
      // Swapped puts the Ultem Left / Right pieces in the same physical slots.
      // The roles, the carrier and the 2-Week mapping below are untouched.
      var swapByRole = getSwapVariantsByRole();
      var leftVariant = swapByRole ? swapByRole.left : components.amVariant;
      var rightVariant = swapByRole ? swapByRole.right : components.pmVariant;
      if (swapByRole && (!leftVariant || !rightVariant)) return null;

      var firstVariant = leftVariant;
      var firstRole = 'am_case';
      var secondVariant = rightVariant;
      var secondRole = 'pm_case';
      if (pickerState.family === 'two_week') {
        // Week 1 is physical right; Week 2 is physical left.
        firstVariant = rightVariant;
        firstRole = 'week1_case';
        secondVariant = leftVariant;
        secondRole = 'week2_case';
      }

      var firstCaseItem = buildTwoSideCaseCartItem(
        firstVariant,
        bundleId,
        firstRole,
        parentVariantId,
        components.parentTitle,
        addMagneticSetProperty(buildTwoSideCaseVisibleProperties(addons, firstRole), magneticSetNumber)
      );
      if (firstCaseItem) items.push(firstCaseItem);

      var secondCaseItem = buildTwoSideCaseCartItem(
        secondVariant,
        bundleId,
        secondRole,
        parentVariantId,
        '',
        addMagneticSetProperty(buildTwoSideCaseVisibleProperties(addons, secondRole), magneticSetNumber)
      );
      if (secondCaseItem) items.push(secondCaseItem);

      if (addons.hasLid) {
        var lidCount = countNonEmpty(addons.lidLabels);
        var lidItem = buildAddonCartItem(
          getLidEngravingVariantForCart(),
          lidCount,
          bundleId,
          'lid',
          buildTwoSideMarker,
          addMagneticSetProperty(buildTwoSideAddonVisibleProperties(addons, 'lid'), magneticSetNumber)
        );
        if (lidItem) items.push(lidItem);
      }

      if (addons.hasPocket) {
        var pocketItem = buildAddonCartItem(
          pocketVariant,
          1,
          bundleId,
          'pocket',
          buildTwoSideMarker,
          addMagneticSetProperty(buildTwoSideAddonVisibleProperties(addons, 'pocket'), magneticSetNumber)
        );
        if (pocketItem) items.push(pocketItem);
      }

      if (addons.hasUltem) {
        var ultemItem = buildAddonCartItem(
          ultemVariant,
          1,
          bundleId,
          'ultem',
          buildTwoSideMarker,
          addMagneticSetProperty({}, magneticSetNumber)
        );
        if (ultemItem) items.push(ultemItem);
      }

      return items;
    }

    function buildCartItems(magneticSetNumber) {
      if (!isAtcReady()) return null;
      if (isTwoSideComponentFlow()) return buildTwoSideCartItems(magneticSetNumber);
      var variant = pickerState.selectedVariant;
      // Swapped sells the Ultem case in place of the aluminum one, so it
      // becomes the bundle parent and the price `_ikg_case` records.
      var swapByRole = getSwapVariantsByRole();
      if (swapByRole) {
        if (!swapByRole.single) return null;
        variant = swapByRole.single;
      }
      var addons = getCartAddonState();
      var bundleId = Date.now();
      var properties = buildVisibleProperties(addons);
      var caseMeta = buildCaseMeta(variant);

      properties._ikg_bundle = buildBundleMarker(bundleId);
      if (caseMeta) properties._ikg_case = caseMeta;

      var items = [{
        id: parseInt(variant.id, 10) || variant.id,
        quantity: 1,
        properties: properties
      }];

      if (addons.hasLid) {
        var lidCount = countNonEmpty(addons.lidLabels);
        var lidItem = buildAddonCartItem(getLidEngravingVariantForCart(), lidCount, bundleId, 'lid');
        if (lidItem) items.push(lidItem);
      }

      if (addons.hasPocket) {
        var pocketItem = buildAddonCartItem(pocketVariant, 1, bundleId, 'pocket');
        if (pocketItem) items.push(pocketItem);
      }

      if (addons.hasUltem) {
        var ultemItem = buildAddonCartItem(ultemVariant, 1, bundleId, 'ultem');
        if (ultemItem) items.push(ultemItem);
      }

      return items;
    }

    function setAddToCartMessage(message, tone) {
      if (!addToCartMessage) return;
      var value = String(message || '').trim();
      addToCartMessage.textContent = value;
      if (tone === 'case-added' || tone === 'review-cart') {
        var cartLink = document.createElement('a');
        cartLink.href = cartRoute('cart');
        cartLink.textContent = 'View Cart';
        cartLink.className = 'tw:underline tw:font-semibold';
        addToCartMessage.appendChild(document.createTextNode(' '));
        addToCartMessage.appendChild(cartLink);
      }
      if (addToCartError) {
        addToCartError.classList.toggle('tw:hidden', !value);
        addToCartError.setAttribute('aria-hidden', value ? 'false' : 'true');
      }
    }

    function logCartItemPayload(items) {
      if (!window.console || !Array.isArray(items)) return;
      var parsedItems = items.map(function (item) {
        return Object.assign({}, item, {
          properties: Object.assign({}, item.properties)
        });
      });
      console.log('[bundle-builder] cart payload', parsedItems);
    }

    function getCartAddItems(items) {
      // Shopify presents multi-add lines in reverse insertion order in checkout.
      // Keep every Combined V2 builder logical, but reverse the transport array
      // so the final component order is case(s), lid, pocket, then Ultem.
      return items.slice().reverse();
    }

    function cartRoute(path) {
      if (twoSideCart) return twoSideCart.cartRoute(path);
      return '/' + String(path || '').replace(/^\/+/, '');
    }

    function parseCartResponse(response, fallbackMessage) {
      if (response.ok) return response.json();
      return response.json().catch(function () { return {}; }).then(function (payload) {
        throw new Error(payload.description || payload.message || fallbackMessage);
      });
    }

    function loadCartForRecovery() {
      return fetch(cartRoute('cart.js'), { headers: { 'Accept': 'application/json' } })
        .then(function (response) { return parseCartResponse(response, 'Could not read the cart for recovery.'); });
    }

    function removeCartLines(lines) {
      return lines.reduce(function (chain, line) {
        return chain.then(function () {
          if (!line.key) throw new Error('Could not identify a cart line for recovery.');
          return fetch(cartRoute('cart/change.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          }).then(function (response) { return parseCartResponse(response, 'Could not remove a cart line.'); });
        });
      }, Promise.resolve());
    }

    function recoverCartLines(matches) {
      var removals = 0;
      function removeNext() {
        return loadCartForRecovery().then(function (cart) {
          var line = (cart.items || []).find(matches);
          if (!line) return;
          if (++removals > 25) throw new Error('Cart cleanup exceeded the expected line count.');
          return removeCartLines([line]).then(removeNext);
        });
      }
      return removeNext().then(function () {
        return loadCartForRecovery();
      }).then(function (cart) {
        if ((cart.items || []).some(matches)) throw new Error('Cart cleanup could not be confirmed.');
      });
    }

    function ensureGiftStillFree(gift) {
      if (!gift || gift.skipped) return Promise.resolve();
      return fetch('/products/' + encodeURIComponent(giftConfig.handle) + '.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function (response) { return parseCartResponse(response, 'Could not check the free item.'); })
        .then(function (product) {
          var variant = (product.variants || []).find(function (entry) { return String(entry.id) === gift.id; });
          if (variant && variant.available && variant.price != null && Number(variant.price) === 0) return;
          var option = Array.prototype.find.call(giftSelect.options, function (entry) { return entry.value === gift.id; });
          if (option) option.remove();
          giftSelect.value = '';
          setStepTouched('6', false);
          setStepSummary('6', '');
          expandStep('6', { focusHeader: true });
          throw new Error('That free item is no longer available at $0. Please choose another ' + (giftConfig.optional ? 'item or No thanks.' : 'item.'));
        });
    }

    function getAttemptMarker(items) {
      var marker = items && items[0] && items[0].properties && items[0].properties._ikg_bundle;
      var match = String(marker || '').match(/^(com2|com3):([^:]+)/);
      return match ? match[1] + ':' + match[2] : '';
    }

    function matchesAttempt(marker, line) {
      var value = String(line && line.properties && line.properties._ikg_bundle || '');
      return !!marker && (value === marker || value.indexOf(marker + ':') === 0);
    }

    function cartLineVariantId(line) {
      return String(line && (line.variant_id || line.id) || '');
    }

    function matchesSubmittedItem(line, item) {
      return cartLineVariantId(line) === String(item.id)
        && Number(line.quantity) >= Number(item.quantity)
        && line.properties && item.properties
        && line.properties._ikg_bundle === item.properties._ikg_bundle;
    }

    function inspectCaseAdd(payload, items) {
      var returned = payload && Array.isArray(payload.items) ? payload.items : [];
      var marker = getAttemptMarker(items);
      if (!marker || !returned.length) return false;
      if (returned.length === items.length && items.every(function (item) {
        return returned.some(function (line) { return matchesSubmittedItem(line, item); });
      })) return true;

      // A Cart Transform can merge the submitted case and add-ons into one
      // line before Shopify builds the Ajax response. The merge writes the
      // attempt marker on its parent, so the submitted-line count no longer
      // matches the response count.
      if (returned.length !== 1 || items.length < 2) return false;
      var merged = returned[0];
      if (!merged.properties || merged.properties._ikg_bundle !== marker || Number(merged.quantity) < 1) return false;
      var expectedParentId = '';
      if (marker.indexOf('com2:') === 0) {
        var parentItem = items.find(function (item) {
          return item.properties && item.properties._ikg_bundle === marker;
        });
        expectedParentId = parentItem && String(parentItem.id) || '';
      } else if (marker.indexOf('com3:') === 0) {
        var firstMarker = String(items[0].properties && items[0].properties._ikg_bundle || '');
        expectedParentId = firstMarker.split(':')[2] || '';
      }
      if (!expectedParentId || cartLineVariantId(merged) !== expectedParentId) return false;

      // Some Ajax responses include bundle components. Verify them when
      // present; other responses expose only the merged parent line.
      var components = Array.isArray(merged.item_components) ? merged.item_components : [];
      if (components.some(function (component) {
        return component && component.properties && component.properties._ikg_bundle;
      })) {
        return items.every(function (item) {
          if (marker.indexOf('com2:') === 0 && item.properties._ikg_bundle === marker) return true;
          return components.some(function (component) { return matchesSubmittedItem(component, item); });
        });
      }
      return true;
    }

    function confirmCaseAdd(payload, items) {
      if (inspectCaseAdd(payload, items)) return Promise.resolve();
      var marker = getAttemptMarker(items);
      return loadCartForRecovery().then(function (cart) {
        var attemptLines = (cart.items || []).filter(function (line) { return matchesAttempt(marker, line); });
        if (!inspectCaseAdd({ items: attemptLines }, items)) {
          throw new Error('The case add could not be confirmed.');
        }
      });
    }

    function buildCreatorGiftItem(gift, items) {
      if (!gift || gift.skipped) return null;
      var marker = getAttemptMarker(items);
      var firstMarker = String(items[0].properties._ikg_bundle || '');
      var giftMarker = marker.indexOf('com2:') === 0
        ? marker + ':gift'
        : 'com3:' + marker.split(':')[1] + ':' + firstMarker.split(':')[2] + ':gift';
      return {
        id: Number(gift.id),
        quantity: 1,
        properties: { _ikg_bundle: giftMarker }
      };
    }

    function confirmCreatorGiftInCart(marker, gift) {
      if (!gift || gift.skipped) return Promise.resolve();
      return loadCartForRecovery().then(function (cart) {
        var attemptLines = (cart.items || []).filter(function (line) { return matchesAttempt(marker, line); });
        var parent = attemptLines.find(function (line) {
          return line.properties && line.properties._ikg_bundle === marker
            && String(line.properties._ikg_creator_gift || '') === gift.id;
        });
        if (!parent || attemptLines.length !== 1) {
          throw new Error('The free item was not merged with your case.');
        }
      });
    }

    function reopenUltemStepAfterSwapLoss() {
      setUltemMode('NONE');
      setStepTouched('5', false);
      setStepSummary('5', '');
      setStepLocked('5', false);
      applyUltemVisual();
      refreshPriceDisplay();
      expandStep('5', { focusHeader: true });
      renderShellState();
    }

    function ensureSwapStillSellable() {
      // Stock can move between choosing Swap and adding to cart, so re-read it
      // instead of trusting the page-load cache. Shopify still has the final
      // say at /cart/add.js.
      if (getUltemMode() !== 'SWAP') return Promise.resolve();
      return ensureSwapResolution({ force: true }).then(function () {
        if (isSwapSelectable()) return;
        var message = getSwapUnavailableNote(getSwapBlockReason())
          || 'The Ultem case is no longer available. Please review the Ultem step.';
        reopenUltemStepAfterSwapLoss();
        throw new Error(message);
      });
    }

    function prepareCartItems() {
      if (!isTwoSideComponentFlow()) {
        return ensureSwapStillSellable().then(function () {
          return buildCartItems();
        });
      }
      if (!twoSideCart) {
        return Promise.reject(new Error('Could not prepare this magnetic set. Please refresh and try again.'));
      }

      return ensureSwapStillSellable()
        .then(function () {
          return fetch(cartRoute('cart.js'), {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
          });
        })
        .then(function (response) {
          return parseCartResponse(response, 'Could not read the cart.');
        })
        .then(function (cart) {
          var setNumber = twoSideCart.getNextMagneticSetNumber(cart.items);
          return buildCartItems(setNumber);
        });
    }

    function handleAddToCart() {
      if (!addToCartButton || addToCartButton.disabled) return;
      if (!isAtcReady()) {
        setAddToCartMessage('Complete each step to continue.', 'error');
        return;
      }

      addToCartButton.disabled = true;
      if (addToCartLabel) addToCartLabel.textContent = 'Adding...';
      if (addToCartSpinner) addToCartSpinner.classList.remove('tw:hidden');
      setAddToCartMessage('', '');

      var gift = selectedGift();
      var attemptMarker = '';
      ensureGiftStillFree(gift).then(function () { return prepareCartItems(); })
        .then(function (items) {
          if (!items || !items.length) {
            throw new Error('Complete each step to continue.');
          }
          var giftItem = giftConfig ? buildCreatorGiftItem(gift, items) : null;
          if (giftItem) items.push(giftItem);
          var cartAddItems = getCartAddItems(items);
          attemptMarker = getAttemptMarker(items);
          logCartItemPayload(cartAddItems);

          return fetch(cartRoute('cart/add.js'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: cartAddItems })
          }).then(function (response) {
            return parseCartResponse(response, 'Could not add this item to cart.');
          }).then(function (payload) {
            if (giftConfig) return confirmCaseAdd(payload, cartAddItems)
              .then(function () { return confirmCreatorGiftInCart(attemptMarker, gift); });
          });
        })
        .catch(function (error) {
          if (!attemptMarker) throw error;
          return recoverCartLines(function (line) { return matchesAttempt(attemptMarker, line); })
            .then(function () { throw error; }, function () {
              var recoveryError = new Error((error && error.message || 'Could not add the case.') + ' Cart cleanup could not be confirmed. Review your cart before checkout.');
              recoveryError.reviewCart = true;
              throw recoveryError;
            });
        })
        .then(function () {
          window.location.href = cartRoute('cart');
        })
        .catch(function (error) {
          if (addToCartSpinner) addToCartSpinner.classList.add('tw:hidden');
          if (error && error.reviewCart) creatorCartUncertain = true;
          refreshAddToCart();
          setAddToCartMessage(error && error.message ? error.message : 'Could not add this item to cart.', creatorCartUncertain ? 'review-cart' : 'error');
        });
    }

    function dispatchStateEvent() {
      root.dispatchEvent(new CustomEvent('bundle-builder:statechange', {
        bubbles: true,
        detail: { state: pickerState }
      }));
    }

    function confirmStep(step) {
      if (step === '1') {
        var selectedSize = getSizeData(pickerState.pendingSize);
        if (!selectedSize) {
          setValidationMessage(sizeValidationEl, 'Choose an available size before confirming.');
          return;
        }
        if (selectedSize.sold_out) {
          setValidationMessage(sizeValidationEl, 'This size is sold out. Choose another size.');
          return;
        }
        setValidationMessage(sizeValidationEl, '');
        var previousSize = pickerState.size;
        pickerState.size = selectedSize.key;
        if (catalogMode) {
          applyCatalogSizeContext(selectedSize);
        } else if (sizePayload && sizePayload.family) {
          pickerState.family = sizePayload.family;
          root.setAttribute('data-family', pickerState.family);
        }
        if (previousSize && previousSize !== pickerState.size) {
          resetStepsAfter('1');
        }
        if (!updateTwoSidePrice()) updatePriceForSize(selectedSize);
        setStepTouched('1', true);
        setStepSummary('1', getSizePresentationName(selectedSize));
        setStepLocked('2', false);
        if (pickerState.family === 'single' && colorCandidateForSizeChange) {
          pickerState.firstColor = colorCandidateForSizeChange;
          pickerState.secondColor = null;
          pickerState.selectedVariant = null;
          clearTwoSideComponentSelection();
        } else if (isTwoCaseFamily()) {
          if (colorCandidateForSizeChange) pickerState.firstColor = colorCandidateForSizeChange;
          if (secondColorCandidateForSizeChange) pickerState.secondColor = secondColorCandidateForSizeChange;
          pickerState.selectedVariant = null;
          clearTwoSideComponentSelection();
        }
        colorCandidateForSizeChange = null;
        secondColorCandidateForSizeChange = null;
        resolveAddOnVariants();
        renderUltemStep();
        // Warm the Ultem size state while the shopper picks a color, so step 5
        // rarely has to show "Checking Ultem stock...".
        if (isSwapSupportedForSize()) prefetchSwapSizeState();
        expandStep('2', { focusHeader: true });
      } else if (step === '2') {
        if (pickerState.family === 'single') {
          var confirmedColor = getColorData(pickerState.firstColor);
          if (!confirmedColor) {
            setValidationMessage(colorValidationEl, 'Choose a color before confirming.');
            return;
          }
          if (confirmedColor.sold_out || !confirmedColor.variant) {
            setValidationMessage(colorValidationEl, 'This color is unavailable. Choose another color.');
            return;
          }
          setValidationMessage(colorValidationEl, '');
          pickerState.selectedVariant = confirmedColor.variant;
          applySingleCaseVariantDisplay(confirmedColor.variant);
          setStepTouched('2', true);
          renderColorStepSummary();
          resetStepsAfter('2');
          setStepLocked('3', false);
          expandStep('3', { focusHeader: true });
        } else {
          if (isTwoCaseFamily()) {
            var confirmedFirstColor = getFirstColorData(pickerState.firstColor);
            var confirmedSecondColor = getSecondColorData(pickerState.secondColor);
            if (!confirmedFirstColor) {
              setValidationMessage(colorValidationEl, 'Choose a first color before confirming.');
              return;
            }
            if (confirmedFirstColor.sold_out) {
              setValidationMessage(colorValidationEl, 'The first color is unavailable. Choose another color.');
              return;
            }
            if (!confirmedSecondColor) {
              setValidationMessage(colorValidationEl, 'Choose a second color before confirming.');
              return;
            }
            if (confirmedSecondColor.sold_out || !confirmedSecondColor.variant) {
              setValidationMessage(colorValidationEl, 'This color pair is unavailable. Choose another second color.');
              return;
            }
            setValidationMessage(colorValidationEl, '');
            pickerState.selectedVariant = confirmedSecondColor.variant;
            resolveTwoSideComponentVariants();
            applyTwoCaseCompositeVariantDisplay(confirmedSecondColor.variant);
          }
          setStepTouched('2', true);
          renderColorStepSummary();
          resetStepsAfter('2');
          setStepLocked('3', false);
          expandStep('3', { focusHeader: true });
        }
      } else if (step === '3') {
        resolveAddOnVariants();
        var lidResult = commitLidEngraving();
        if (!lidResult.ok) {
          setValidationMessage(lidValidationEl, lidResult.message);
          return;
        }
        setValidationMessage(lidValidationEl, '');
        setStepTouched('3', true);
        renderLidStepSummary();
        updateGalleryLidPreview();
        resetStepsAfter('3');
        setStepLocked('4', false);
        expandStep('4', { focusHeader: true });
      } else if (step === '4') {
        resolveAddOnVariants();
        var pocketResult = commitPocketEngraving();
        if (!pocketResult.ok) {
          setValidationMessage(pocketValidationEl, pocketResult.message);
          return;
        }
        setValidationMessage(pocketValidationEl, '');
        setStepTouched('4', true);
        renderPocketStepSummary();
        resetStepsAfter('4');
        renderUltemStep();
        if (isStepSkipped('5')) {
          setStepSummary('5', '');
          advanceAfterUltem();
        } else {
          setStepLocked('5', false);
          expandStep('5', { focusHeader: true });
        }
      } else if (step === '5') {
        renderUltemStep();
        if (isStepSkipped('5')) {
          setStepTouched('5', true);
          advanceAfterUltem();
          renderShellState();
          dispatchStateEvent();
          return;
        }
        if (getUltemMode() === 'SWAP' && !isSwapSelectable()) {
          setUltemMode('NONE');
          applyUltemVisual();
          return;
        }
        setUltemMode(getUltemMode());
        applyUltemVisual();
        setStepTouched('5', true);
        setStepSummary('5', getUltemSummaryText());
        advanceAfterUltem();
      } else if (step === '6') {
        var gift = selectedGift();
        if (!gift) {
          setValidationMessage(giftValidationEl, giftConfig.optional
            ? 'Choose a free item or No thanks before confirming.'
            : 'Choose a free item before confirming.');
          return;
        }
        setValidationMessage(giftValidationEl, '');
        setStepTouched('6', true);
        var option = giftSelect.options[giftSelect.selectedIndex];
        setStepSummary('6', option ? option.textContent.trim() : '');
        collapseAll();
      }
      renderShellState();
      dispatchStateEvent();
    }

    function getUrlPreselectStatus(name) {
      return root.getAttribute('data-url-preselect-' + name + '-status');
    }

    function fetchUrlPreselectColors() {
      if (pickerState.family === 'single') return fetchSingleColors();
      if (isTwoCaseFamily()) {
        return fetchFirstColors().then(function () {
          return fetchSecondColors();
        });
      }
      return Promise.resolve(null);
    }

    function canAutoConfirmUrlPreselectColors(preselect) {
      if (!preselect || !preselect.firstColorKey) return false;

      if (pickerState.family === 'single') {
        var color = getColorData(pickerState.firstColor);
        return getUrlPreselectStatus('first-color') === 'valid' &&
          !!(color && color.key === preselect.firstColorKey && !color.sold_out && color.variant);
      }

      if (isTwoCaseFamily()) {
        if (!preselect.secondColorKey) return false;
        var firstColor = getFirstColorData(pickerState.firstColor);
        var secondColor = getSecondColorData(pickerState.secondColor);
        return getUrlPreselectStatus('first-color') === 'valid' &&
          getUrlPreselectStatus('second-color') === 'valid' &&
          !!(firstColor && firstColor.key === preselect.firstColorKey && !firstColor.sold_out && firstColor.variant) &&
          !!(secondColor && secondColor.key === preselect.secondColorKey && !secondColor.sold_out && secondColor.variant);
      }

      return false;
    }

    function applyUrlPreselectFlow() {
      var preselect = pickerState.urlPreselect;
      if (!preselect || !preselect.sizeKey || urlPreselectApplying || urlPreselectApplied) return;

      urlPreselectApplying = true;
      fetchSizes()
        .then(function () {
          var preselectedSize = resolvePreselectedSize(preselect);
          if (!preselectedSize) return null;

          applyResolvedUrlPreselectSize(preselect, preselectedSize);
          pickerState.pendingSize = preselectedSize.key;
          renderSizeRows();
          renderShellState();

          if (preselectedSize.sold_out) return null;

          if (pickerState.size !== preselectedSize.key) {
            confirmStep('1');
          }
          if (pickerState.size !== preselectedSize.key || !preselect.firstColorKey) return null;

          return fetchUrlPreselectColors().then(function () {
            if (canAutoConfirmUrlPreselectColors(preselect)) {
              confirmStep('2');
            } else {
              renderShellState();
              dispatchStateEvent();
            }
            return null;
          });
        })
        .catch(function (error) {
          if (window.console && typeof console.warn === 'function') {
            console.warn('[combined-v2] Failed to apply URL preselect:', error);
          }
        })
        .then(function () {
          urlPreselectApplying = false;
          urlPreselectApplied = true;
        });
    }

    function initializeStateFromUrl() {
      var preselect = parseUrlPreselect('size');
      pickerState.urlPreselect = preselect;
      pickerState.pendingSize = preselect && preselect.sizeKey
        ? preselect.sizeKey
        : null;
      pickerState.size = null;
      pickerState.firstColor = preselect && preselect.firstColorKey
        ? preselect.firstColorKey
        : null;
      pickerState.secondColor = preselect && preselect.secondColorKey
        ? preselect.secondColorKey
        : null;
    }

    root.addEventListener('keydown', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var sizeOption = event.target.closest('[data-size-option]');
      if (sizeOption && root.contains(sizeOption)) {
        var sizeKey = event.key;
        if (sizeKey !== 'ArrowDown' && sizeKey !== 'ArrowUp' && sizeKey !== 'Home' && sizeKey !== 'End') return;
        var sizePopover = sizeOption.closest('[data-size-popover]');
        var sizeOptions = getEnabledSizeOptions(sizePopover);
        if (!sizeOptions.length) return;
        event.preventDefault();
        var sizeIndex = sizeOptions.indexOf(sizeOption);
        if (sizeIndex < 0) sizeIndex = 0;
        var nextSizeOption;
        if (sizeKey === 'Home') nextSizeOption = sizeOptions[0];
        else if (sizeKey === 'End') nextSizeOption = sizeOptions[sizeOptions.length - 1];
        else if (sizeKey === 'ArrowDown') nextSizeOption = sizeOptions[Math.min(sizeOptions.length - 1, sizeIndex + 1)];
        else nextSizeOption = sizeOptions[Math.max(0, sizeIndex - 1)];
        if (nextSizeOption) nextSizeOption.focus();
        return;
      }

      var colorOption = event.target.closest('[data-color-option-key]');
      if (colorOption && root.contains(colorOption)) {
        var popover = colorOption.closest('[data-color-popover]');
        var options = getEnabledColorOptions(popover);
        var currentIndex = options.indexOf(colorOption);
        if (currentIndex < 0) currentIndex = 0;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          if (options.length) focusColorOption(options[(currentIndex + 1 + options.length) % options.length]);
          return;
        }
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          if (options.length) focusColorOption(options[(currentIndex - 1 + options.length) % options.length]);
          return;
        }
        if (event.key === 'Home') {
          event.preventDefault();
          if (options.length) focusColorOption(options[0]);
          return;
        }
        if (event.key === 'End') {
          event.preventDefault();
          if (options.length) focusColorOption(options[options.length - 1]);
          return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectColorOptionElement(colorOption, { focusTrigger: true });
          return;
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          closeColorPopover(popover);
          focusElementSoon(getColorPopoverTrigger(popover));
        }
        return;
      }

      var colorPopoverTrigger = event.target.closest('[data-color-popover-trigger]');
      if (colorPopoverTrigger && root.contains(colorPopoverTrigger) && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        event.preventDefault();
        openColorPopoverFromTrigger(colorPopoverTrigger, event.key === 'ArrowUp');
      }
    });

    root.addEventListener('click', function (event) {
      var galleryThumb = event.target.closest('[data-gallery-thumb]');
      if (galleryThumb && root.contains(galleryThumb)) {
        event.preventDefault();
        setActiveGallerySlide(galleryThumb.getAttribute('data-slide-target'));
        return;
      }

      var galleryPrev = event.target.closest('[data-gallery-prev]');
      if (galleryPrev && root.contains(galleryPrev)) {
        event.preventDefault();
        if (!galleryPrev.disabled) moveGallery(-1);
        return;
      }

      var galleryNext = event.target.closest('[data-gallery-next]');
      if (galleryNext && root.contains(galleryNext)) {
        event.preventDefault();
        if (!galleryNext.disabled) moveGallery(1);
        return;
      }

      var retry = event.target.closest('[data-size-retry]');
      if (retry && root.contains(retry)) {
        fetchSizes({ force: true });
        return;
      }

      var colorRetry = event.target.closest('[data-color-retry]');
      if (colorRetry && root.contains(colorRetry)) {
        fetchSingleColors({ force: true });
        return;
      }

      var firstColorRetry = event.target.closest('[data-first-color-retry]');
      if (firstColorRetry && root.contains(firstColorRetry)) {
        fetchFirstColors({ force: true });
        return;
      }

      var secondColorRetry = event.target.closest('[data-second-color-retry]');
      if (secondColorRetry && root.contains(secondColorRetry)) {
        fetchSecondColors({ force: true });
        return;
      }

      var sizeButton = event.target.closest('[data-size-key]');
      if (sizeButton && root.contains(sizeButton)) {
        if (sizeButton.disabled) return;
        var selectedFromPopover = sizeButton.closest('[data-size-popover]');
        if (selectedFromPopover) {
          event.preventDefault();
          closeSizePopover(selectedFromPopover);
        }
        setPendingSize(sizeButton.getAttribute('data-size-key'));
        return;
      }

      var colorPopoverTrigger = event.target.closest('[data-color-popover-trigger]');
      if (colorPopoverTrigger && root.contains(colorPopoverTrigger)) {
        var targetId = colorPopoverTrigger.getAttribute('popovertarget');
        var targetPopover = targetId ? document.getElementById(targetId) : null;
        if (targetPopover) placeColorPopover(targetPopover);
        return;
      }

      var colorOption = event.target.closest('[data-color-option-key]');
      if (colorOption && root.contains(colorOption)) {
        event.preventDefault();
        selectColorOptionElement(colorOption);
        return;
      }

      var compareTrigger = event.target.closest('[data-compare-tooltip]');
      if (compareTrigger && root.contains(compareTrigger)) {
        event.preventDefault();
        event.stopPropagation();
        toggleCompareTooltip(compareTrigger);
        return;
      }

      var lidModeButton = event.target.closest('[data-lid-engraving-mode]');
      if (lidModeButton && root.contains(lidModeButton)) {
        event.preventDefault();
        var lidMode = lidModeButton.getAttribute('data-lid-engraving-mode');
        var maxLen = getLidMaxLength();
        var refreshLidSummary = !!(pickerState.touchedSteps['3'] || pickerState.lidSummaryShown);
        if (lidMode === 'NONE') {
          pickerState.lidEngraving = { mode: 'NONE', labels: [], variantId: null };
        } else {
          pickerState.lidEngraving = {
            mode: 'CUSTOM',
            labels: normalizeLidLabels(pickerState.lidEngraving && pickerState.lidEngraving.labels, getLidInputCount(), maxLen),
            variantId: lidVariant ? String(lidVariant.id || '') : null
          };
        }
        if (pickerState.touchedSteps['3']) {
          setStepTouched('3', false);
          resetStepsAfter('3');
        }
        if (refreshLidSummary) renderLidStepSummary();
        updateGalleryLidPreview();
        renderLidFields();
        renderShellState();
        returnToGalleryPreview();
        return;
      }

      var pocketModeButton = event.target.closest('[data-pocket-engraving-mode]');
      if (pocketModeButton && root.contains(pocketModeButton)) {
        event.preventDefault();
        var pocketMode = pocketModeButton.getAttribute('data-pocket-engraving-mode');
        var refreshPocketSummary = !!(pickerState.touchedSteps['4'] || pickerState.pocketSummaryShown);
        if (pocketMode === 'NONE') {
          pickerState.pocketEngraving = { mode: 'NONE', value: '', variantId: null };
        } else {
          var kind = getPocketKind();
          var options = getPocketOptions(kind);
          var currentValue = pickerState.pocketEngraving && pickerState.pocketEngraving.value;
          var currentMode = pickerState.pocketEngraving && pickerState.pocketEngraving.mode;
          var value = currentMode && currentMode !== 'NONE' && options.indexOf(currentValue) !== -1 ? currentValue : (options[0] || '');
          pickerState.pocketEngraving = {
            mode: getPocketMode(kind),
            value: value,
            variantId: value && pocketVariant ? String(pocketVariant.id || '') : null
          };
        }
        if (pickerState.touchedSteps['4']) {
          setStepTouched('4', false);
          setStepSummary('4', '');
          resetStepsAfter('4');
        }
        renderPocketFields();
        if (refreshPocketSummary) renderPocketStepSummary();
        renderShellState();
        returnToGalleryPreview();
        return;
      }

      var ultemOptionButton = event.target.closest('[data-ultem-option]');
      if (ultemOptionButton && root.contains(ultemOptionButton)) {
        event.preventDefault();
        if (ultemOptionButton.disabled) return;
        var chosenOption = ultemOptionButton.getAttribute('data-ultem-option');
        var chosenMode = chosenOption === 'yes' ? 'ADD' : (chosenOption === 'swap' ? 'SWAP' : 'NONE');
        if (chosenMode === 'SWAP' && !isSwapSelectable()) return;
        setUltemMode(chosenMode);
        if (pickerState.touchedSteps['5']) {
          setStepTouched('5', false);
          setStepSummary('5', '');
        }
        applyUltemVisual();
        // Swapping changes the case itself, so the shown price is the Ultem
        // price rather than the aluminum price plus an add-on.
        refreshPriceDisplay();
        renderShellState();
        returnToGalleryPreview();
        return;
      }

      var addToCartTrigger = event.target.closest('[data-add-to-cart]');
      if (addToCartTrigger && root.contains(addToCartTrigger)) {
        event.preventDefault();
        handleAddToCart();
        return;
      }

      var notifyOpen = event.target.closest('[data-notify-open]');
      if (notifyOpen && root.contains(notifyOpen)) {
        event.preventDefault();
        openNotifyModal({ returnFocus: notifyOpen });
        return;
      }

      var notifyClose = event.target.closest('[data-notify-close]');
      if (notifyClose && root.contains(notifyClose)) {
        event.preventDefault();
        closeNotifyModal();
        return;
      }

      if (notifyModalEl && event.target === notifyModalEl) {
        closeNotifyModal();
        return;
      }

      var header = event.target.closest('[data-step-header]');
      if (header && root.contains(header)) {
        event.preventDefault();
        var headerStep = header.getAttribute('data-step-header');
        var stepEl = getStepEl(headerStep);
        if (!stepEl || stepEl.getAttribute('data-locked') === 'true') return;
        if (pickerState.expandedStep === headerStep) {
          confirmStep(headerStep);
        } else {
          expandStep(headerStep);
        }
        return;
      }

      var confirm = event.target.closest('[data-step-confirm]');
      if (confirm && root.contains(confirm)) {
        event.preventDefault();
        if (confirm.disabled) return;
        confirmStep(confirm.getAttribute('data-step-confirm'));
      }
    });

    if (galleryStage) {
      galleryStage.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveGallery(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveGallery(1);
        }
      });

      galleryStage.addEventListener('pointerdown', beginGallerySwipe);
      if (galleryV2) {
        root.querySelectorAll('[data-gallery-video]').forEach(function (video) {
          var onPlaybackChange = function () { updateGalleryVideoButton(video); };
          ['play', 'pause', 'error', 'emptied'].forEach(function (type) { video.addEventListener(type, onPlaybackChange); });
          galleryVideoCleanups.push(function () {
            ['play', 'pause', 'error', 'emptied'].forEach(function (type) { video.removeEventListener(type, onPlaybackChange); });
            video.pause();
          });
        });
        galleryStage.addEventListener('pointerdown', function () { revealGalleryUi(); });
        galleryStage.addEventListener('pointerdown', beginGalleryTap);
        galleryStage.addEventListener('pointermove', trackGalleryTap);
        galleryStage.addEventListener('pointerup', endGalleryTap);
        galleryStage.addEventListener('pointercancel', function () { galleryTap = null; });
        galleryStage.addEventListener('click', swallowHandledGalleryTapClick, true);
        galleryStage.addEventListener('click', handleGalleryTapClick);
        if (window.visualViewport) window.visualViewport.addEventListener('resize', syncGalleryPageZoom);
        syncGalleryPageZoom();
        // Hover only counts for a real mouse: taps fire compatibility mouse events
        // with no matching leave, which would keep the arrows up forever on phones.
        galleryStage.addEventListener('pointerenter', function (event) {
          if (event.pointerType !== 'mouse') return;
          galleryUiHover = true;
          root.setAttribute('data-gallery-ui', 'on');
        });
        galleryStage.addEventListener('pointerleave', function (event) {
          if (event.pointerType !== 'mouse') return;
          galleryUiHover = false;
          revealGalleryUi();
        });
      }
      galleryStage.addEventListener('pointerup', endGallerySwipe);
      galleryStage.addEventListener('pointercancel', cancelGallerySwipe);
      galleryStage.addEventListener('lostpointercapture', cancelGallerySwipe);
    }

    root.addEventListener('input', function (event) {
      var notifyEmail = event.target.closest('[data-notify-email]');
      if (notifyEmail && root.contains(notifyEmail)) {
        setNotifyMessage('', 'neutral');
        return;
      }

      var lidInput = event.target.closest('[data-lid-input]');
      if (lidInput && root.contains(lidInput)) {
        var maxLen = parseInt(lidInput.getAttribute('maxlength'), 10) || getLidMaxLength();
        if (lidInput.value.length > maxLen) lidInput.value = lidInput.value.slice(0, maxLen);
        updateLidCounter(lidInput);
        pickerState.lidEngraving.labels = normalizeLidLabels(readLidInputs(), getLidInputCount(), maxLen);
        pickerState.lidEngraving.mode = 'CUSTOM';
        pickerState.lidEngraving.variantId = pickerState.lidEngraving.mode !== 'NONE' && lidVariant ? String(lidVariant.id || '') : null;
        setValidationMessage(lidValidationEl, getLidInputValidationMessage());
        var refreshLidSummary = !!(pickerState.touchedSteps['3'] || pickerState.lidSummaryShown);
        if (pickerState.touchedSteps['3']) {
          setStepTouched('3', false);
          resetStepsAfter('3');
        }
        if (refreshLidSummary) renderLidStepSummary();
        renderLidBodyPreview();
        updateGalleryLidPreview();
        renderShellState();
      }
    });

    root.addEventListener('change', function (event) {
      var giftVariant = event.target.closest('[data-gift-variant]');
      if (giftVariant && root.contains(giftVariant)) {
        setStepTouched('6', false);
        setStepSummary('6', '');
        setValidationMessage(giftValidationEl, '');
        renderShellState();
        return;
      }
      var notifySize = event.target.closest('[data-notify-size]');
      if (notifySize && root.contains(notifySize)) {
        setNotifyMessage('', 'neutral');
        // Keep the chosen color when the new size offers it.
        loadNotifyColors(notifyFirstColorSelect ? notifyFirstColorSelect.value : '', '');
        return;
      }

      var notifyFirstColor = event.target.closest('[data-notify-first-color-select]');
      if (notifyFirstColor && root.contains(notifyFirstColor)) {
        setNotifyMessage('', 'neutral');
        if (isTwoCaseFamily()) {
          loadNotifySecondColors('');
        } else {
          syncNotifyFields();
        }
        return;
      }

      var notifySecondColor = event.target.closest('[data-notify-second-color-select]');
      if (notifySecondColor && root.contains(notifySecondColor)) {
        setNotifyMessage('', 'neutral');
        syncNotifyFields();
        return;
      }

      var pocketSelect = event.target.closest('[data-pocket-value]');
      if (pocketSelect && root.contains(pocketSelect)) {
        if (pickerState.pocketEngraving && pickerState.pocketEngraving.mode !== 'NONE') {
          pickerState.pocketEngraving = {
            mode: getPocketMode(getPocketKind()),
            value: pocketSelect.value,
            variantId: pocketSelect.value && pocketVariant ? String(pocketVariant.id || '') : null
          };
        }
        renderPocketBodyPreview();
        var refreshPocketSummary = !!(pickerState.touchedSteps['4'] || pickerState.pocketSummaryShown);
        if (pickerState.touchedSteps['4']) {
          setStepTouched('4', false);
          setStepSummary('4', '');
          resetStepsAfter('4');
        }
        if (refreshPocketSummary) renderPocketStepSummary();
        renderShellState();
      }
    });

    function onDocumentClick(event) {
      if (currentTooltip && !event.target.closest('[data-compare-tooltip], .dynamic-tooltip')) {
        closeCompareTooltip();
      }
    }

    function onDocumentKeydown(event) {
      if (!notifyModalEl || notifyModalEl.getAttribute('data-open') !== 'true') return;
      if (event.key === 'Tab') trapNotifyFocus(event);
      if (event.key === 'Escape') {
        event.preventDefault();
        closeNotifyModal();
      }
    }

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onDocumentKeydown);

    root.addEventListener('bundle-builder:statechange', function (event) {
      var state = event.detail && event.detail.state;
      if (!state || !state.size) return;
      syncDetailsSectionForSize(state.size);
    });

    var previewWidthQuery = null;
    if (window.matchMedia) {
      previewWidthQuery = window.matchMedia('(max-width: 767px)');
      if (previewWidthQuery.addEventListener) {
        previewWidthQuery.addEventListener('change', refreshGalleryPreviewWidths);
      } else if (previewWidthQuery.addListener) {
        previewWidthQuery.addListener(refreshGalleryPreviewWidths);
      }
    }

    initializeStateFromUrl();
    stepOrder.forEach(function (step) {
      setStepBodyVisible(step, false);
      applyStepVisualState(step);
    });
    setStepLocked('1', false);
    setStepLocked('2', true);
    setStepLocked('3', true);
    setStepLocked('4', true);
    setStepLocked('5', true);
    if (giftConfig) setStepLocked('6', true);
    if (!isUltemConfigured() && !getUltemCatalog()) {
      setStepSkipped('5', true);
    }
    if (notifyFormEl) {
      notifyFormEl.addEventListener('submit', onNotifySubmit);
    }
    setActiveGallerySlide(0);
    if (galleryV2) {
      // The first-load 2.5 s fade runs on a CSS clock (data-gallery-ui="intro"); JS takes over on first interaction.
      galleryReady = true;
      // After the page has finished loading and gone idle, quietly fetch the rest so swipes are instant.
      var idleLoad = function () {
        if (galleryDisposed) return;
        var run = function () { if (!galleryDisposed) loadAllGallerySlides(); };
        if (window.requestIdleCallback) galleryIdleHandle = window.requestIdleCallback(run, { timeout: 4000 });
        else galleryIdleTimer = setTimeout(run, 1500);
      };
      if (document.readyState === 'complete') idleLoad(); else window.addEventListener('load', idleLoad, { once: true });
      if (window.ResizeObserver && galleryStage) {
        galleryResizeObserver = new window.ResizeObserver(function () {
          if (!galleryDisposed) refreshGalleryPreviewWidths();
        });
        galleryResizeObserver.observe(galleryStage);
        if (mainThumb) galleryResizeObserver.observe(mainThumb);
      } else {
        window.addEventListener('resize', refreshGalleryPreviewWidths);
      }
      if (!galleryBgSrc) console.error('PDP gallery v2: the section has no Background image, so the case preview has no stone background.');
      ['pointerdown', 'click', 'keydown', 'input', 'change'].forEach(function (type) {
        root.addEventListener(type, function () { galleryLastUserAt = Date.now(); }, true);
      });
      var onBuyBoxChange = function (event) {
        if (!event.target || !event.target.closest) return;
        if (event.target.closest('[data-pdp-gallery]')) return;
        if (event.target.closest('[data-notify-modal], [data-notify-form]')) return;
        // Customising anything in the buy box shows the live preview; the next arrow then resumes.
        returnToGalleryPreview();
      };
      root.addEventListener('input', onBuyBoxChange);
      root.addEventListener('change', onBuyBoxChange);
    }
    expandStep('1');
    applyUrlPreselectFlow();
    openNotifyFromUrl();
    syncDetailsSectionForSize(defaultSizeKey, { initial: true });

    theme.bundleBuilder = theme.bundleBuilder || {};
    var bundleApi = {
      state: pickerState,
      setStepLocked: setStepLocked,
      setStepTouched: setStepTouched,
      setStepSummary: setStepSummary,
      expandStep: expandStep,
      resetStepsAfter: resetStepsAfter,
      refreshAddToCart: refreshAddToCart,
      fetchSizes: fetchSizes,
      fetchSingleColors: fetchSingleColors,
      fetchFirstColors: fetchFirstColors,
      fetchSecondColors: fetchSecondColors,
      buildCartItem: buildCartItems,
      buildCartItems: buildCartItems,
      handleAddToCart: handleAddToCart
    };
    theme.bundleBuilder[cfg.sectionId] = bundleApi;

    return {
      root: root,
      destroy: function () {
        if (galleryV2) {
          galleryDisposed = true;
          if (galleryUiTimer) clearTimeout(galleryUiTimer);
          if (galleryIdleTimer) clearTimeout(galleryIdleTimer);
          if (galleryIdleHandle !== null && window.cancelIdleCallback) window.cancelIdleCallback(galleryIdleHandle);
          window.removeEventListener('load', idleLoad);
          window.removeEventListener('resize', refreshGalleryPreviewWidths);
          if (window.visualViewport) window.visualViewport.removeEventListener('resize', syncGalleryPageZoom);
          if (galleryResizeObserver) galleryResizeObserver.disconnect();
          galleryVideoCleanups.forEach(function (cleanup) { cleanup(); });
        }
        invalidateNotifyRequests();
        notifyReturnFocusEl = null;
        document.removeEventListener('click', onDocumentClick);
        document.removeEventListener('keydown', onDocumentKeydown);
        unbindSizePopoverListeners();
        unbindColorPopoverListeners();
        if (currentTooltip) closeCompareTooltip();
        if (previewWidthQuery) {
          if (previewWidthQuery.removeEventListener) {
            previewWidthQuery.removeEventListener('change', refreshGalleryPreviewWidths);
          } else if (previewWidthQuery.removeListener) {
            previewWidthQuery.removeListener(refreshGalleryPreviewWidths);
          }
        }
        if (theme.bundleBuilder && theme.bundleBuilder[cfg.sectionId] === bundleApi) {
          delete theme.bundleBuilder[cfg.sectionId];
        }
      }
    };
  }

  function parseConfig(element) {
    try {
      return JSON.parse(element.textContent || '');
    } catch (error) {
      if (window.console && typeof window.console.error === 'function') {
        window.console.error('Could not parse Combined v2 configuration.', error);
      }
      return null;
    }
  }

  function init(cfg) {
    if (!cfg || cfg.sectionId === null || cfg.sectionId === undefined) return null;
    var sectionId = String(cfg.sectionId);
    var root = document.getElementById('bundle-builder-' + sectionId);
    if (!root) return null;

    var existing = instances[sectionId];
    if (existing && existing.root === root) return existing;
    if (existing) existing.destroy();

    cfg.sectionId = sectionId;
    var instance = createInstance(cfg);
    if (instance) instances[sectionId] = instance;
    return instance;
  }

  function initFrom(scope) {
    var root = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
    var configs = [];
    if (root.matches && root.matches(CONFIG_SELECTOR)) configs.push(root);
    var descendants = root.querySelectorAll(CONFIG_SELECTOR);
    for (var i = 0; i < descendants.length; i++) configs.push(descendants[i]);

    for (var j = 0; j < configs.length; j++) {
      var cfg = parseConfig(configs[j]);
      if (cfg) window.theme.combinedV2.init(cfg);
    }
  }

  function destroy(sectionId) {
    var key = String(sectionId || '');
    var instance = instances[key];
    if (!instance) return;
    instance.destroy();
    delete instances[key];
  }

  window.theme.combinedV2 = {
    init: init,
    initFrom: initFrom,
    destroy: destroy
  };

  document.addEventListener('shopify:section:load', function (event) {
    initFrom(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.detail && event.detail.sectionId) destroy(event.detail.sectionId);
  });

  function boot() {
    initFrom(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
